// Référentiel national des caisses (centres payeurs), généré depuis centrepayeur-export.csv.
// NE PAS éditer à la main : régénérer via scripts de parsing du CSV.
// Sert de source au bouton « Importer le référentiel des caisses » du split modal.
/* eslint-disable */
export const CAISSES_REFERENCE_VERSION = 1;
export const CAISSES_REFERENCE = [
{
"id": "02-471-0000",
"codeRegime": "02",
"caisseGestionnaire": "471",
"centreGestionnaire": "0000",
"libelle": "AGEN",
"regime": "Régime Agricole",
"organismeDestinataire": "471",
"codeCentreInformatique": "821",
"adresse1": "1. quai du Docteur-Calabet",
"adresse2": "",
"commune": "AGEN",
"codePostal": "47913",
"cedex": "CEDEX",
"telephone": "05.53.67.77.77",
"fax": "05.53.67.78.58"
},
{
"id": "02-475-0000",
"codeRegime": "02",
"caisseGestionnaire": "475",
"centreGestionnaire": "0000",
"libelle": "AGEN",
"regime": "Régime Agricole",
"organismeDestinataire": "471",
"codeCentreInformatique": "821",
"adresse1": "1. quai du Docteur-Calabet",
"adresse2": "",
"commune": "AGEN",
"codePostal": "47913",
"cedex": "CEDEX",
"telephone": "05.53.67.77.77",
"fax": "05.53.67.78.58"
},
{
"id": "02-201-0000",
"codeRegime": "02",
"caisseGestionnaire": "201",
"centreGestionnaire": "0000",
"libelle": "AJACCIO",
"regime": "Régime Agricole",
"organismeDestinataire": "201",
"codeCentreInformatique": "381",
"adresse1": "Parc Cunéo-d'Ornano",
"adresse2": "B.P. 407",
"commune": "AJACCIO",
"codePostal": "20184",
"cedex": "CEDEX",
"telephone": "04.95.29.27.00",
"fax": "04.95.29.27.64"
},
{
"id": "02-205-0000",
"codeRegime": "02",
"caisseGestionnaire": "205",
"centreGestionnaire": "0000",
"libelle": "AJACCIO",
"regime": "Régime Agricole",
"organismeDestinataire": "201",
"codeCentreInformatique": "381",
"adresse1": "Parc Cunéo-d'Ornano",
"adresse2": "B.P. 407",
"commune": "AJACCIO",
"codePostal": "20184",
"cedex": "CEDEX",
"telephone": "04.95.29.27.00",
"fax": "04.95.29.27.64"
},
{
"id": "02-811-0000",
"codeRegime": "02",
"caisseGestionnaire": "811",
"centreGestionnaire": "0000",
"libelle": "ALBI",
"regime": "Régime Agricole",
"organismeDestinataire": "811",
"codeCentreInformatique": "821",
"adresse1": "14, rue de Ciron",
"adresse2": "",
"commune": "ALBI",
"codePostal": "81017",
"cedex": "CEDEX 9",
"telephone": "05 63 68 40 40",
"fax": "05 63 68 40 99"
},
{
"id": "02-815-0000",
"codeRegime": "02",
"caisseGestionnaire": "815",
"centreGestionnaire": "0000",
"libelle": "ALBI",
"regime": "Régime Agricole",
"organismeDestinataire": "811",
"codeCentreInformatique": "821",
"adresse1": "14, rue de Ciron",
"adresse2": "",
"commune": "ALBI",
"codePostal": "81017",
"cedex": "CEDEX 9",
"telephone": "05 63 68 40 40",
"fax": "05 63 68 40 99"
},
{
"id": "02-611-0000",
"codeRegime": "02",
"caisseGestionnaire": "611",
"centreGestionnaire": "0000",
"libelle": "ALENCON",
"regime": "Régime Agricole",
"organismeDestinataire": "611",
"codeCentreInformatique": "351",
"adresse1": "52, bd. du 1er Chasseurs",
"adresse2": "",
"commune": "ALENCON",
"codePostal": "61011",
"cedex": "CEDEX",
"telephone": "02 33 31 40 00",
"fax": "02 33 31 41 97"
},
{
"id": "02-615-0000",
"codeRegime": "02",
"caisseGestionnaire": "615",
"centreGestionnaire": "0000",
"libelle": "ALENCON",
"regime": "Régime Agricole",
"organismeDestinataire": "611",
"codeCentreInformatique": "351",
"adresse1": "52, bd. du 1er Chasseurs",
"adresse2": "",
"commune": "ALENCON",
"codePostal": "61011",
"cedex": "CEDEX",
"telephone": "02 33 31 40 00",
"fax": "02 33 31 41 97"
},
{
"id": "02-801-0000",
"codeRegime": "02",
"caisseGestionnaire": "801",
"centreGestionnaire": "0000",
"libelle": "AMIENS",
"regime": "Régime Agricole",
"organismeDestinataire": "801",
"codeCentreInformatique": "591",
"adresse1": "27. rue Frédéric Petit",
"adresse2": "",
"commune": "AMIENS",
"codePostal": "80019",
"cedex": "CEDEX 9",
"telephone": "03.22.82.62.62",
"fax": "03.22.82.63.05"
},
{
"id": "02-805-0000",
"codeRegime": "02",
"caisseGestionnaire": "805",
"centreGestionnaire": "0000",
"libelle": "AMIENS",
"regime": "Régime Agricole",
"organismeDestinataire": "801",
"codeCentreInformatique": "591",
"adresse1": "27. rue Frédéric Petit",
"adresse2": "",
"commune": "AMIENS",
"codePostal": "80019",
"cedex": "CEDEX 9",
"telephone": "03.22.82.62.62",
"fax": "03.22.82.63.05"
},
{
"id": "02-491-0000",
"codeRegime": "02",
"caisseGestionnaire": "491",
"centreGestionnaire": "0000",
"libelle": "ANGERS",
"regime": "Régime Agricole",
"organismeDestinataire": "491",
"codeCentreInformatique": "351",
"adresse1": "3, RUE CHARLES LACRETELLE",
"adresse2": "BEAUCOUZE",
"commune": "ANGERS",
"codePostal": "49938",
"cedex": "CEDEX 9",
"telephone": "02.41.31.75.75",
"fax": "02.41.31.78.62"
},
{
"id": "02-495-0000",
"codeRegime": "02",
"caisseGestionnaire": "495",
"centreGestionnaire": "0000",
"libelle": "ANGERS",
"regime": "Régime Agricole",
"organismeDestinataire": "491",
"codeCentreInformatique": "351",
"adresse1": "3, RUE CHARLES LACRETELLE",
"adresse2": "BEAUCOUZE",
"commune": "ANGERS",
"codePostal": "49938",
"cedex": "CEDEX 9",
"telephone": "02.41.31.75.75",
"fax": "02.41.31.78.62"
},
{
"id": "02-161-0000",
"codeRegime": "02",
"caisseGestionnaire": "161",
"centreGestionnaire": "0000",
"libelle": "ANGOULEME",
"regime": "Régime Agricole",
"organismeDestinataire": "161",
"codeCentreInformatique": "821",
"adresse1": "Rue du Docteur Charles-Duroselle",
"adresse2": "",
"commune": "ANGOULEME",
"codePostal": "16016",
"cedex": "CEDEX",
"telephone": "05.45.97.80.80",
"fax": "05.45.92.62.38"
},
{
"id": "02-165-0000",
"codeRegime": "02",
"caisseGestionnaire": "165",
"centreGestionnaire": "0000",
"libelle": "ANGOULEME",
"regime": "Régime Agricole",
"organismeDestinataire": "161",
"codeCentreInformatique": "821",
"adresse1": "Rue du Docteur Charles-Duroselle",
"adresse2": "",
"commune": "ANGOULEME",
"codePostal": "16016",
"cedex": "CEDEX",
"telephone": "05.45.97.80.80",
"fax": "05.45.92.62.38"
},
{
"id": "02-741-0000",
"codeRegime": "02",
"caisseGestionnaire": "741",
"centreGestionnaire": "0000",
"libelle": "ANNECY",
"regime": "Régime Agricole",
"organismeDestinataire": "741",
"codeCentreInformatique": "381",
"adresse1": "2, bd. du Fier",
"adresse2": "",
"commune": "ANNECY",
"codePostal": "74993",
"cedex": "CEDEX",
"telephone": "09 69 36 87 00",
"fax": "04 50 57 92 92"
},
{
"id": "02-745-0000",
"codeRegime": "02",
"caisseGestionnaire": "745",
"centreGestionnaire": "0000",
"libelle": "ANNECY",
"regime": "Régime Agricole",
"organismeDestinataire": "741",
"codeCentreInformatique": "381",
"adresse1": "2, bd. du Fier",
"adresse2": "",
"commune": "ANNECY",
"codePostal": "74993",
"cedex": "CEDEX",
"telephone": "09 69 36 87 00",
"fax": "04 50 57 92 92"
},
{
"id": "01-591-0000",
"codeRegime": "01",
"caisseGestionnaire": "591",
"centreGestionnaire": "0000",
"libelle": "ARMENTIERES",
"regime": "Régime Général",
"organismeDestinataire": "591",
"codeCentreInformatique": "011",
"adresse1": "6, Rue des Nieulles",
"adresse2": "BP 121",
"commune": "ARMENTIERES",
"codePostal": "59428",
"cedex": "CEDEX",
"telephone": "03 20 44 39 39",
"fax": ""
},
{
"id": "02-621-0000",
"codeRegime": "02",
"caisseGestionnaire": "621",
"centreGestionnaire": "0000",
"libelle": "ARRAS",
"regime": "Régime Agricole",
"organismeDestinataire": "621",
"codeCentreInformatique": "591",
"adresse1": "1. rue A. Gatoux",
"adresse2": "",
"commune": "ARRAS",
"codePostal": "62024",
"cedex": "CEDEX",
"telephone": "03.21.24.60.62",
"fax": "03.21.24.60.84"
},
{
"id": "02-625-0000",
"codeRegime": "02",
"caisseGestionnaire": "625",
"centreGestionnaire": "0000",
"libelle": "ARRAS",
"regime": "Régime Agricole",
"organismeDestinataire": "621",
"codeCentreInformatique": "591",
"adresse1": "1. rue A. Gatoux",
"adresse2": "",
"commune": "ARRAS",
"codePostal": "62024",
"cedex": "CEDEX",
"telephone": "03.21.24.60.62",
"fax": "03.21.24.60.84"
},
{
"id": "01-621-0000",
"codeRegime": "01",
"caisseGestionnaire": "621",
"centreGestionnaire": "0000",
"libelle": "ARRAS",
"regime": "Régime Général",
"organismeDestinataire": "621",
"codeCentreInformatique": "011",
"adresse1": "Boulevard Allende",
"adresse2": "",
"commune": "ARRAS",
"codePostal": "62014",
"cedex": "CEDEX",
"telephone": "03 21 22 96 13",
"fax": ""
},
{
"id": "02-321-0000",
"codeRegime": "02",
"caisseGestionnaire": "321",
"centreGestionnaire": "0000",
"libelle": "AUCH",
"regime": "Régime Agricole",
"organismeDestinataire": "321",
"codeCentreInformatique": "321",
"adresse1": "21. Avenue de la Marne",
"adresse2": "",
"commune": "AUCH",
"codePostal": "32018",
"cedex": "CEDEX",
"telephone": "05.62.60.30.09",
"fax": "05.62.60.30.07"
},
{
"id": "02-325-0000",
"codeRegime": "02",
"caisseGestionnaire": "325",
"centreGestionnaire": "0000",
"libelle": "AUCH",
"regime": "Régime Agricole",
"organismeDestinataire": "321",
"codeCentreInformatique": "321",
"adresse1": "21. Avenue de la Marne",
"adresse2": "",
"commune": "AUCH",
"codePostal": "32018",
"cedex": "CEDEX",
"telephone": "05.62.60.30.39",
"fax": "05.62.60.30.07"
},
{
"id": "02-151-0000",
"codeRegime": "02",
"caisseGestionnaire": "151",
"centreGestionnaire": "0000",
"libelle": "AURILLAC",
"regime": "Régime Agricole",
"organismeDestinataire": "151",
"codeCentreInformatique": "381",
"adresse1": "16, rue Jean Claret",
"adresse2": "",
"commune": "CLERMONT-FERRAND",
"codePostal": "63972",
"cedex": "CEDEX 9",
"telephone": "04.71.64.66.46",
"fax": "04.70.35.35.34"
},
{
"id": "02-155-0000",
"codeRegime": "02",
"caisseGestionnaire": "155",
"centreGestionnaire": "0000",
"libelle": "AURILLAC",
"regime": "Régime Agricole",
"organismeDestinataire": "151",
"codeCentreInformatique": "381",
"adresse1": "16, rue Jean Claret",
"adresse2": "",
"commune": "CLERMONT-FERRAND",
"codePostal": "63972",
"cedex": "CEDEX 9",
"telephone": "04.71.64.66.46",
"fax": "04.70.35.35.34"
},
{
"id": "02-891-0000",
"codeRegime": "02",
"caisseGestionnaire": "891",
"centreGestionnaire": "0000",
"libelle": "AUXERRE",
"regime": "Régime Agricole",
"organismeDestinataire": "891",
"codeCentreInformatique": "541",
"adresse1": "14bis. rue Georges Guynemer",
"adresse2": "B.P. 95",
"commune": "AUXERRE",
"codePostal": "89001",
"cedex": "CEDEX",
"telephone": "03.86.47.37.00",
"fax": "03.86.47.37.01"
},
{
"id": "02-895-0000",
"codeRegime": "02",
"caisseGestionnaire": "895",
"centreGestionnaire": "0000",
"libelle": "AUXERRE",
"regime": "Régime Agricole",
"organismeDestinataire": "891",
"codeCentreInformatique": "541",
"adresse1": "14bis. rue Georges Guynemer",
"adresse2": "B.P. 95",
"commune": "AUXERRE",
"codePostal": "89001",
"cedex": "CEDEX",
"telephone": "03.86.47.37.00",
"fax": "03.86.47.37.01"
},
{
"id": "02-841-0000",
"codeRegime": "02",
"caisseGestionnaire": "841",
"centreGestionnaire": "0000",
"libelle": "AVIGNON",
"regime": "Régime Agricole",
"organismeDestinataire": "841",
"codeCentreInformatique": "341",
"adresse1": "1. place des Maraîchers",
"adresse2": "",
"commune": "AVIGNON",
"codePostal": "84056",
"cedex": "",
"telephone": "04.90.13.66.66",
"fax": "04.90.87.72.05"
},
{
"id": "02-845-0000",
"codeRegime": "02",
"caisseGestionnaire": "845",
"centreGestionnaire": "0000",
"libelle": "AVIGNON",
"regime": "Régime Agricole",
"organismeDestinataire": "841",
"codeCentreInformatique": "341",
"adresse1": "1. place des Maraîchers",
"adresse2": "",
"commune": "AVIGNON",
"codePostal": "84056",
"cedex": "",
"telephone": "04.90.13.66.66",
"fax": "04.90.87.72.05"
},
{
"id": "02-601-0000",
"codeRegime": "02",
"caisseGestionnaire": "601",
"centreGestionnaire": "0000",
"libelle": "BEAUVAIS",
"regime": "Régime Agricole",
"organismeDestinataire": "601",
"codeCentreInformatique": "591",
"adresse1": "8. avenue Victor Hugo",
"adresse2": "B.P. 70828",
"commune": "BEAUVAIS",
"codePostal": "60010",
"cedex": "CEDEX",
"telephone": "03.44.06.81.00",
"fax": "03.44.06.81.01"
},
{
"id": "02-605-0000",
"codeRegime": "02",
"caisseGestionnaire": "605",
"centreGestionnaire": "0000",
"libelle": "BEAUVAIS",
"regime": "Régime Agricole",
"organismeDestinataire": "601",
"codeCentreInformatique": "591",
"adresse1": "8. avenue Victor Hugo",
"adresse2": "B.P. 328-1",
"commune": "BEAUVAIS",
"codePostal": "60010",
"cedex": "CEDEX",
"telephone": "03.44.06.81.00",
"fax": "03.44.06.81.01"
},
{
"id": "02-251-0000",
"codeRegime": "02",
"caisseGestionnaire": "251",
"centreGestionnaire": "0000",
"libelle": "BESANCON",
"regime": "Régime Agricole",
"organismeDestinataire": "251",
"codeCentreInformatique": "541",
"adresse1": "13. avenue Elisée-Cusenier",
"adresse2": "",
"commune": "BESANCON",
"codePostal": "25090",
"cedex": "CEDEX 9",
"telephone": "03.81.65.60.60",
"fax": "03.81.65.60.09"
},
{
"id": "02-255-0000",
"codeRegime": "02",
"caisseGestionnaire": "255",
"centreGestionnaire": "0000",
"libelle": "BESANCON",
"regime": "Régime Agricole",
"organismeDestinataire": "251",
"codeCentreInformatique": "541",
"adresse1": "13. avenue Elisée-Cusenier",
"adresse2": "",
"commune": "BESANCON",
"codePostal": "25090",
"cedex": "CEDEX 9",
"telephone": "03.81.65.60.60",
"fax": "03.81.65.60.09"
},
{
"id": "02-411-0000",
"codeRegime": "02",
"caisseGestionnaire": "411",
"centreGestionnaire": "0000",
"libelle": "BLOIS",
"regime": "Régime Agricole",
"organismeDestinataire": "411",
"codeCentreInformatique": "411",
"adresse1": "MSA Berry Touraine 19 Avenue de Vendôme",
"adresse2": "CS 72301",
"commune": "BLOIS",
"codePostal": "41023",
"cedex": "CEDEX",
"telephone": "02 54 44 87 87",
"fax": "02 54 74 82 97"
},
{
"id": "02-415-0000",
"codeRegime": "02",
"caisseGestionnaire": "415",
"centreGestionnaire": "0000",
"libelle": "BLOIS",
"regime": "Régime Agricole",
"organismeDestinataire": "411",
"codeCentreInformatique": "411",
"adresse1": "MSA Berry Touraine 19 Avenue de Vendôme",
"adresse2": "CS 72301",
"commune": "BLOIS",
"codePostal": "41023",
"cedex": "CEDEX",
"telephone": "02.54.44.87.87",
"fax": "02.54.74.82.97"
},
{
"id": "02-761-0000",
"codeRegime": "02",
"caisseGestionnaire": "761",
"centreGestionnaire": "0000",
"libelle": "BOIS GUILLAUME",
"regime": "Régime Agricole",
"organismeDestinataire": "761",
"codeCentreInformatique": "591",
"adresse1": "Cité de l'Agriculture",
"adresse2": "",
"commune": "BOIS-GUILLAUME",
"codePostal": "76236",
"cedex": "CEDEX",
"telephone": "02.35.12.70.10",
"fax": "02.35.61.59.55"
},
{
"id": "02-765-0000",
"codeRegime": "02",
"caisseGestionnaire": "765",
"centreGestionnaire": "0000",
"libelle": "BOIS GUILLAUME",
"regime": "Régime Agricole",
"organismeDestinataire": "761",
"codeCentreInformatique": "591",
"adresse1": "Cité de l'Agriculture",
"adresse2": "",
"commune": "BOIS-GUILLAUME",
"codePostal": "76236",
"cedex": "CEDEX",
"telephone": "02.35.12.70.10",
"fax": "02.35.61.59.55"
},
{
"id": "02-331-0000",
"codeRegime": "02",
"caisseGestionnaire": "331",
"centreGestionnaire": "0000",
"libelle": "BORDEAUX",
"regime": "Régime Agricole",
"organismeDestinataire": "331",
"codeCentreInformatique": "331",
"adresse1": "13. rue Ferrère",
"adresse2": "",
"commune": "BORDEAUX",
"codePostal": "33052",
"cedex": "CEDEX",
"telephone": "05.56.01.83.83",
"fax": "05.56.79.35.98"
},
{
"id": "02-335-0000",
"codeRegime": "02",
"caisseGestionnaire": "335",
"centreGestionnaire": "0000",
"libelle": "BORDEAUX",
"regime": "Régime Agricole",
"organismeDestinataire": "331",
"codeCentreInformatique": "331",
"adresse1": "13. rue Ferrère",
"adresse2": "",
"commune": "BORDEAUX",
"codePostal": "33052",
"cedex": "CEDEX",
"telephone": "05.56.01.83.83",
"fax": "05.56.79.35.98"
},
{
"id": "01-622-0000",
"codeRegime": "01",
"caisseGestionnaire": "622",
"centreGestionnaire": "0000",
"libelle": "BOULOGNE SUR MER",
"regime": "Régime Général",
"organismeDestinataire": "622",
"codeCentreInformatique": "011",
"adresse1": "47, Boulevard Mariette",
"adresse2": "BP 489",
"commune": "BOULOGNE sur MER",
"codePostal": "62321",
"cedex": "CEDEX",
"telephone": "03 21 87 70 00",
"fax": "03 21 87 70 46"
},
{
"id": "02-011-0000",
"codeRegime": "02",
"caisseGestionnaire": "011",
"centreGestionnaire": "0000",
"libelle": "BOURG EN BRESSE",
"regime": "Régime Agricole",
"organismeDestinataire": "011",
"codeCentreInformatique": "011",
"adresse1": "15, avenue du Champ de Foire",
"adresse2": "",
"commune": "Bourg-en-Bresse",
"codePostal": "01059",
"cedex": "Cedex 9",
"telephone": "04 74 45 99 00",
"fax": "04 74 45 98 98"
},
{
"id": "02-015-0000",
"codeRegime": "02",
"caisseGestionnaire": "015",
"centreGestionnaire": "0000",
"libelle": "BOURG EN BRESSE",
"regime": "Régime Agricole",
"organismeDestinataire": "011",
"codeCentreInformatique": "011",
"adresse1": "15, avenue du Champ de Foire",
"adresse2": "",
"commune": "Bourg en Bresse",
"codePostal": "01059",
"cedex": "CEDEX 9",
"telephone": "04 74 45 99 00",
"fax": "04 74 45 98 98"
},
{
"id": "02-181-0000",
"codeRegime": "02",
"caisseGestionnaire": "181",
"centreGestionnaire": "0000",
"libelle": "BOURGES",
"regime": "Régime Agricole",
"organismeDestinataire": "181",
"codeCentreInformatique": "591",
"adresse1": "7. rue de l'Ile-d'Or",
"adresse2": "B.P. 133",
"commune": "BOURGES",
"codePostal": "18032",
"cedex": "CEDEX",
"telephone": "02.48.55.40.40",
"fax": "02.48.55.40.02"
},
{
"id": "02-185-0000",
"codeRegime": "02",
"caisseGestionnaire": "185",
"centreGestionnaire": "0000",
"libelle": "BOURGES",
"regime": "Régime Agricole",
"organismeDestinataire": "181",
"codeCentreInformatique": "591",
"adresse1": "7. rue de l'Ile-d'Or",
"adresse2": "B.P. 133",
"commune": "BOURGES",
"codePostal": "18032",
"cedex": "CEDEX",
"telephone": "02.48.55.40.40",
"fax": "02.48.55.40.02"
},
{
"id": "02-141-0000",
"codeRegime": "02",
"caisseGestionnaire": "141",
"centreGestionnaire": "0000",
"libelle": "CAEN",
"regime": "Régime Agricole",
"organismeDestinataire": "141",
"codeCentreInformatique": "351",
"adresse1": "37. rue de Maltot",
"adresse2": "",
"commune": "CAEN",
"codePostal": "14026",
"cedex": "CEDEX",
"telephone": "02.31.25.37.10",
"fax": "02.31.25.39.79"
},
{
"id": "02-145-0000",
"codeRegime": "02",
"caisseGestionnaire": "145",
"centreGestionnaire": "0000",
"libelle": "CAEN",
"regime": "Régime Agricole",
"organismeDestinataire": "141",
"codeCentreInformatique": "351",
"adresse1": "37. rue de Maltot",
"adresse2": "",
"commune": "CAEN",
"codePostal": "14026",
"cedex": "CEDEX",
"telephone": "02.31.25.37.10",
"fax": "02.31.25.39.79"
},
{
"id": "02-461-0000",
"codeRegime": "02",
"caisseGestionnaire": "461",
"centreGestionnaire": "0000",
"libelle": "CAHORS",
"regime": "Régime Agricole",
"organismeDestinataire": "461",
"codeCentreInformatique": "821",
"adresse1": "Rue du Pape Jean XXIII",
"adresse2": "B.P. 279",
"commune": "CAHORS",
"codePostal": "46014",
"cedex": "CEDEX",
"telephone": "05.65.35.43.82",
"fax": "05.65.22.18.73"
},
{
"id": "02-465-0000",
"codeRegime": "02",
"caisseGestionnaire": "465",
"centreGestionnaire": "0000",
"libelle": "CAHORS",
"regime": "Régime Agricole",
"organismeDestinataire": "461",
"codeCentreInformatique": "821",
"adresse1": "Rue du Pape Jean XXIII",
"adresse2": "B.P. 279",
"commune": "CAHORS",
"codePostal": "46014",
"cedex": "CEDEX",
"telephone": "05.65.35.43.82",
"fax": "05.65.22.18.73"
},
{
"id": "90-100-0000",
"codeRegime": "90",
"caisseGestionnaire": "100",
"centreGestionnaire": "0000",
"libelle": "Caisse d Assurance Vieillesse Invalidite et Maladie des Cultes",
"regime": "Caisse d'Assurance Vieillesse Invalidité et Maladie des Cultes - CAVIMAC",
"organismeDestinataire": "100",
"codeCentreInformatique": "004",
"adresse1": "9, rue de Rosny",
"adresse2": "",
"commune": "MONTREUIL-SOUS-BOIS",
"codePostal": "93100",
"cedex": "",
"telephone": "01 41 58 45 45",
"fax": ""
},
{
"id": "90-100-0011",
"codeRegime": "90",
"caisseGestionnaire": "100",
"centreGestionnaire": "0011",
"libelle": "Caisse d Assurance Vieillesse Invalidite et Maladie des Cultes",
"regime": "Caisse d'Assurance Vieillesse Invalidité et Maladie des Cultes - CAVIMAC",
"organismeDestinataire": "100",
"codeCentreInformatique": "004",
"adresse1": "9, rue de Rosny",
"adresse2": "",
"commune": "MONTREUIL-SOUS-BOIS",
"codePostal": "93100",
"cedex": "",
"telephone": "01 41 58 45 45",
"fax": ""
},
{
"id": "05-051-0000",
"codeRegime": "05",
"caisseGestionnaire": "051",
"centreGestionnaire": "0000",
"libelle": "Caisse de Coordination aux Assurances Sociales RATP",
"regime": "Régime Spécial de la RATP",
"organismeDestinataire": "051",
"codeCentreInformatique": "001",
"adresse1": "CH30  LAC GR1",
"adresse2": "30 rue Championnet",
"commune": "PARIS",
"codePostal": "75887",
"cedex": "CEDEX 18",
"telephone": "",
"fax": ""
},
{
"id": "04-110-0000",
"codeRegime": "04",
"caisseGestionnaire": "110",
"centreGestionnaire": "0000",
"libelle": "Caisse de Prevoyance",
"regime": "Caisse de Prévoyance et de Retraite du Personnel Ferroviaire - CPRPF",
"organismeDestinataire": "110",
"codeCentreInformatique": "001",
"adresse1": "17 avenue du général Leclerc",
"adresse2": "",
"commune": "Marseille",
"codePostal": "13347",
"cedex": "cedex 1",
"telephone": "04.95.04.04.04",
"fax": ""
},
{
"id": "01-908-0000",
"codeRegime": "01",
"caisseGestionnaire": "908",
"centreGestionnaire": "0000",
"libelle": "Caisse de Prevoyance et de Retraite du Personnel Ferroviaire",
"regime": "Régime Général",
"organismeDestinataire": "908",
"codeCentreInformatique": "075",
"adresse1": "17 avenue général Leclerc",
"adresse2": "C908",
"commune": "MARSEILLE",
"codePostal": "13936",
"cedex": "Cedex 20",
"telephone": "04.95.04.04.04",
"fax": ""
},
{
"id": "10-980-2101",
"codeRegime": "10",
"caisseGestionnaire": "980",
"centreGestionnaire": "2101",
"libelle": "Caisse de Ret.et Prev. Clercs et Emp. Notaires",
"regime": "Caisse de Retraite et de Prévoyance des Clercs et Employés de Notaire - CRPCEN",
"organismeDestinataire": "980",
"codeCentreInformatique": "004",
"adresse1": "5, bis rue de Madrid",
"adresse2": "",
"commune": "Paris",
"codePostal": "75395",
"cedex": "Cedex 08",
"telephone": "01 44 90 20 20",
"fax": ""
},
{
"id": "01-999-0000",
"codeRegime": "01",
"caisseGestionnaire": "999",
"centreGestionnaire": "0000",
"libelle": "Caisse de TEST",
"regime": "(Aucun : serveur de test)",
"organismeDestinataire": "999",
"codeCentreInformatique": "999",
"adresse1": "",
"adresse2": "",
"commune": "",
"codePostal": "",
"cedex": "",
"telephone": "",
"fax": ""
},
{
"id": "04-120-0000",
"codeRegime": "04",
"caisseGestionnaire": "120",
"centreGestionnaire": "0000",
"libelle": "Caisse des Cadres superieurs",
"regime": "Caisse de Prévoyance et de Retraite du Personnel Ferroviaire - CPRPF",
"organismeDestinataire": "110",
"codeCentreInformatique": "001",
"adresse1": "17 avenue du général Leclerc",
"adresse2": "",
"commune": "Marseille",
"codePostal": "13347",
"cedex": "cedex 1",
"telephone": "04.95.04.04.04",
"fax": ""
},
{
"id": "04-220-0000",
"codeRegime": "04",
"caisseGestionnaire": "220",
"centreGestionnaire": "0000",
"libelle": "Caisse Maladie d Alsace Lorraine",
"regime": "Caisse de Prévoyance et de Retraite du Personnel Ferroviaire - CPRPF",
"organismeDestinataire": "110",
"codeCentreInformatique": "001",
"adresse1": "17 avenue du général Leclerc",
"adresse2": "",
"commune": "Marseille",
"codePostal": "13347",
"cedex": "cedex 1",
"telephone": "04.95.04.04.04",
"fax": ""
},
{
"id": "01-592-0000",
"codeRegime": "01",
"caisseGestionnaire": "592",
"centreGestionnaire": "0000",
"libelle": "CAMBRAI",
"regime": "Régime Général",
"organismeDestinataire": "592",
"codeCentreInformatique": "011",
"adresse1": "10, Rue Saint Lazare",
"adresse2": "",
"commune": "CAMBRAI",
"codePostal": "59408",
"cedex": "CEDEX",
"telephone": "03 27 73 59 59",
"fax": ""
},
{
"id": "99-939-0603",
"codeRegime": "99",
"caisseGestionnaire": "939",
"centreGestionnaire": "0603",
"libelle": "CAMIEG",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "939",
"codeCentreInformatique": "038",
"adresse1": "CAMIEG",
"adresse2": "",
"commune": "NANTERRE",
"codePostal": "92011",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "02-111-0000",
"codeRegime": "02",
"caisseGestionnaire": "111",
"centreGestionnaire": "0000",
"libelle": "CARCASSONNE",
"regime": "Régime Agricole",
"organismeDestinataire": "111",
"codeCentreInformatique": "821",
"adresse1": "6.  rue du Palais",
"adresse2": "B.P. 854",
"commune": "CARCASSONNE",
"codePostal": "11011",
"cedex": "CEDEX",
"telephone": "04.68.11.77.11",
"fax": "04.68.47.84.82"
},
{
"id": "02-115-0000",
"codeRegime": "02",
"caisseGestionnaire": "115",
"centreGestionnaire": "0000",
"libelle": "CARCASSONNE",
"regime": "Régime Agricole",
"organismeDestinataire": "111",
"codeCentreInformatique": "821",
"adresse1": "6.  rue du Palais",
"adresse2": "B.P. 854",
"commune": "CARCASSONNE",
"codePostal": "11011",
"cedex": "CEDEX",
"telephone": "04.68.11.77.11",
"fax": "04.68.47.84.82"
},
{
"id": "17-191-0000",
"codeRegime": "17",
"caisseGestionnaire": "191",
"centreGestionnaire": "0000",
"libelle": "CFE",
"regime": "Caisse des Français à l'Etranger",
"organismeDestinataire": "191",
"codeCentreInformatique": "591",
"adresse1": "TSA 44381",
"adresse2": "",
"commune": "MELUN",
"codePostal": "77052",
"cedex": "CEDEX",
"telephone": "01 64 14 62 62",
"fax": ""
},
{
"id": "01-971-0000",
"codeRegime": "01",
"caisseGestionnaire": "971",
"centreGestionnaire": "0000",
"libelle": "CGSS de la Guadeloupe",
"regime": "Régime Général",
"organismeDestinataire": "971",
"codeCentreInformatique": "026",
"adresse1": "Quartier de l'Hôtel de Ville",
"adresse2": "BP 486",
"commune": "POINTE A PITRE",
"codePostal": "97159",
"cedex": "CEDEX",
"telephone": "05 90 90 50 00",
"fax": ""
},
{
"id": "01-973-0000",
"codeRegime": "01",
"caisseGestionnaire": "973",
"centreGestionnaire": "0000",
"libelle": "CGSS de la Guyane",
"regime": "Régime Général",
"organismeDestinataire": "973",
"codeCentreInformatique": "026",
"adresse1": "Espace Turenne Radamonthe",
"adresse2": "Route de Raban",
"commune": "CAYENNE",
"codePostal": "97307",
"cedex": "CEDEX",
"telephone": "05 94 39 60 00",
"fax": ""
},
{
"id": "01-972-0000",
"codeRegime": "01",
"caisseGestionnaire": "972",
"centreGestionnaire": "0000",
"libelle": "CGSS de la Martinique",
"regime": "Régime Général",
"organismeDestinataire": "972",
"codeCentreInformatique": "026",
"adresse1": "Place d'Armes",
"adresse2": "",
"commune": "LE LAMENTIN",
"codePostal": "97210",
"cedex": "CEDEX 2",
"telephone": "05 96 51 00 08",
"fax": ""
},
{
"id": "01-974-0000",
"codeRegime": "01",
"caisseGestionnaire": "974",
"centreGestionnaire": "0000",
"libelle": "CGSS de la Reunion",
"regime": "Régime Général",
"organismeDestinataire": "974",
"codeCentreInformatique": "027",
"adresse1": "4 Boulevard Doret",
"adresse2": "",
"commune": "SAINT DENIS",
"codePostal": "97704",
"cedex": "CEDEX 9",
"telephone": "02 62 40 33 40",
"fax": ""
},
{
"id": "02-731-0000",
"codeRegime": "02",
"caisseGestionnaire": "731",
"centreGestionnaire": "0000",
"libelle": "CHAMBERY",
"regime": "Régime Agricole",
"organismeDestinataire": "731",
"codeCentreInformatique": "381",
"adresse1": "106, rue Juiverie",
"adresse2": "",
"commune": "CHAMBERY",
"codePostal": "73016",
"cedex": "CEDEX",
"telephone": "09 69 36 87 00",
"fax": "04 79 69 42 24"
},
{
"id": "02-735-0000",
"codeRegime": "02",
"caisseGestionnaire": "735",
"centreGestionnaire": "0000",
"libelle": "CHAMBERY",
"regime": "Régime Agricole",
"organismeDestinataire": "731",
"codeCentreInformatique": "381",
"adresse1": "106, rue Juiverie",
"adresse2": "",
"commune": "CHAMBERY",
"codePostal": "73016",
"cedex": "CEDEX",
"telephone": "09 69 36 87 00",
"fax": "04 79 69 42 24"
},
{
"id": "02-081-0000",
"codeRegime": "02",
"caisseGestionnaire": "081",
"centreGestionnaire": "0000",
"libelle": "CHARLEVILLE MEZIERES",
"regime": "Régime Agricole",
"organismeDestinataire": "081",
"codeCentreInformatique": "541",
"adresse1": "30, Av. Jean-Jaurès",
"adresse2": "",
"commune": "CHARLEVILLE MEZIERES",
"codePostal": "08108",
"cedex": "",
"telephone": "03 24 59 52 72",
"fax": "03 24 59 52 98"
},
{
"id": "02-085-0000",
"codeRegime": "02",
"caisseGestionnaire": "085",
"centreGestionnaire": "0000",
"libelle": "CHARLEVILLE MEZIERES",
"regime": "Régime Agricole",
"organismeDestinataire": "081",
"codeCentreInformatique": "541",
"adresse1": "30, Av. Jean-Jaurès",
"adresse2": "",
"commune": "CHARLEVILLE MEZIERES",
"codePostal": "08108",
"cedex": "",
"telephone": "03 24 59 52 72",
"fax": "03 24 59 52 98"
},
{
"id": "02-281-0000",
"codeRegime": "02",
"caisseGestionnaire": "281",
"centreGestionnaire": "0000",
"libelle": "CHARTRES",
"regime": "Régime Agricole",
"organismeDestinataire": "281",
"codeCentreInformatique": "411",
"adresse1": "5. rue de Chanzy",
"adresse2": "",
"commune": "CHARTRES",
"codePostal": "28037",
"cedex": "CEDEX",
"telephone": "02.37.30.45.00",
"fax": "02.37.30.45.04"
},
{
"id": "02-285-0000",
"codeRegime": "02",
"caisseGestionnaire": "285",
"centreGestionnaire": "0000",
"libelle": "CHARTRES",
"regime": "Régime Agricole",
"organismeDestinataire": "281",
"codeCentreInformatique": "411",
"adresse1": "5. rue de Chanzy",
"adresse2": "",
"commune": "CHARTRES",
"codePostal": "28037",
"cedex": "CEDEX",
"telephone": "02.37.30.45.00",
"fax": "02.37.30.45.04"
},
{
"id": "02-361-0000",
"codeRegime": "02",
"caisseGestionnaire": "361",
"centreGestionnaire": "0000",
"libelle": "CHATEAUROUX",
"regime": "Régime Agricole",
"organismeDestinataire": "361",
"codeCentreInformatique": "591",
"adresse1": "MSA Berry Touraine 19 Avenue de Vendôme",
"adresse2": "CS 72301",
"commune": "BLOIS",
"codePostal": "41023",
"cedex": "CEDEX",
"telephone": "02 54 44 87 87",
"fax": "02 54 74 82 97"
},
{
"id": "02-365-0000",
"codeRegime": "02",
"caisseGestionnaire": "365",
"centreGestionnaire": "0000",
"libelle": "CHATEAUROUX",
"regime": "Régime Agricole",
"organismeDestinataire": "361",
"codeCentreInformatique": "591",
"adresse1": "MSA Berry Touraine 19 Avenue de Vendôme",
"adresse2": "CS 72301",
"commune": "BLOIS",
"codePostal": "41023",
"cedex": "CEDEX",
"telephone": "02 54 44 87 87",
"fax": "02 54 74 82 97"
},
{
"id": "02-521-0000",
"codeRegime": "02",
"caisseGestionnaire": "521",
"centreGestionnaire": "0000",
"libelle": "CHAUMONT",
"regime": "Régime Agricole",
"organismeDestinataire": "521",
"codeCentreInformatique": "541",
"adresse1": "4. avenue Emile-Cassez",
"adresse2": "B.P. 504",
"commune": "CHAUMONT",
"codePostal": "52017",
"cedex": "CEDEX",
"telephone": "03.25.30.33.00",
"fax": "03.25.32.67.37"
},
{
"id": "02-525-0000",
"codeRegime": "02",
"caisseGestionnaire": "525",
"centreGestionnaire": "0000",
"libelle": "CHAUMONT",
"regime": "Régime Agricole",
"organismeDestinataire": "521",
"codeCentreInformatique": "541",
"adresse1": "4. avenue Emile-Cassez",
"adresse2": "B.P. 504",
"commune": "CHAUMONT",
"codePostal": "52017",
"cedex": "CEDEX",
"telephone": "03.25.30.33.00",
"fax": "03.25.32.67.37"
},
{
"id": "02-631-0000",
"codeRegime": "02",
"caisseGestionnaire": "631",
"centreGestionnaire": "0000",
"libelle": "CLERMONT FERRAND",
"regime": "Régime Agricole",
"organismeDestinataire": "631",
"codeCentreInformatique": "381",
"adresse1": "16, rue Jean Claret",
"adresse2": "",
"commune": "CLERMONT-FERRAND",
"codePostal": "63972",
"cedex": "CEDEX 9",
"telephone": "04.71.64.66.46",
"fax": "04.70.35.35.34"
},
{
"id": "02-635-0000",
"codeRegime": "02",
"caisseGestionnaire": "635",
"centreGestionnaire": "0000",
"libelle": "CLERMONT FERRAND",
"regime": "Régime Agricole",
"organismeDestinataire": "631",
"codeCentreInformatique": "381",
"adresse1": "16, rue Jean Claret",
"adresse2": "",
"commune": "CLERMONT-FERRAND",
"codePostal": "63972",
"cedex": "CEDEX 9",
"telephone": "04.71.64.66.46",
"fax": "04.70.35.35.34"
},
{
"id": "08-756-0100",
"codeRegime": "08",
"caisseGestionnaire": "756",
"centreGestionnaire": "0100",
"libelle": "CNMSS Affilies",
"regime": "Caisse Nationale Militaire de Sécurité Sociale - CNMSS",
"organismeDestinataire": "756",
"codeCentreInformatique": "050",
"adresse1": "247  Avenue Jacques CARTIER",
"adresse2": "",
"commune": "TOULON",
"codePostal": "83090",
"cedex": "Cedex 09",
"telephone": "04 94 16 36 00",
"fax": "04 94 16 38 32"
},
{
"id": "08-835-0300",
"codeRegime": "08",
"caisseGestionnaire": "835",
"centreGestionnaire": "0300",
"libelle": "CNMSS Pensionnes Invalides de guerre",
"regime": "Caisse Nationale Militaire de Sécurité Sociale - CNMSS",
"organismeDestinataire": "835",
"codeCentreInformatique": "052",
"adresse1": "247 Avenue Jacques CARTIER",
"adresse2": "",
"commune": "TOULON",
"codePostal": "83090",
"cedex": "Cedex 09",
"telephone": "04 94 16 96 20",
"fax": "04 94 16 39 03"
},
{
"id": "08-758-0200",
"codeRegime": "08",
"caisseGestionnaire": "758",
"centreGestionnaire": "0200",
"libelle": "CNMSS Personnel",
"regime": "Caisse Nationale Militaire de Sécurité Sociale - CNMSS",
"organismeDestinataire": "758",
"codeCentreInformatique": "050",
"adresse1": "247 Avenue Jacques CARTIER",
"adresse2": "",
"commune": "TOULON",
"codePostal": "83090",
"cedex": "Cedex 09",
"telephone": "04 94 16 36 00",
"fax": "04 94 16 38 32"
},
{
"id": "02-681-0000",
"codeRegime": "02",
"caisseGestionnaire": "681",
"centreGestionnaire": "0000",
"libelle": "COLMAR",
"regime": "Régime Agricole",
"organismeDestinataire": "681",
"codeCentreInformatique": "541",
"adresse1": "9 , rue de Guebwiller",
"adresse2": "",
"commune": "COLMAR",
"codePostal": "68023",
"cedex": "CEDEX",
"telephone": "03.89.20.78.68",
"fax": "03.89.20.79.00"
},
{
"id": "02-685-0000",
"codeRegime": "02",
"caisseGestionnaire": "685",
"centreGestionnaire": "0000",
"libelle": "COLMAR",
"regime": "Régime Agricole",
"organismeDestinataire": "681",
"codeCentreInformatique": "541",
"adresse1": "9, rue de Guebwiller",
"adresse2": "",
"commune": "COLMAR",
"codePostal": "68023",
"cedex": "CEDEX",
"telephone": "03.89.20.78.68",
"fax": "03.89.20.79.00"
},
{
"id": "01-681-0000",
"codeRegime": "01",
"caisseGestionnaire": "681",
"centreGestionnaire": "0000",
"libelle": "COLMAR",
"regime": "Régime Général",
"organismeDestinataire": "681",
"codeCentreInformatique": "017",
"adresse1": "19, Boulevard du Champ de Mars",
"adresse2": "BP 40454",
"commune": "COLMAR",
"codePostal": "68022",
"cedex": "CEDEX",
"telephone": "03 89 21 78 23 / 24",
"fax": "03 89 21 77 04"
},
{
"id": "01-281-0000",
"codeRegime": "01",
"caisseGestionnaire": "281",
"centreGestionnaire": "0000",
"libelle": "CPAM d Eure-et-Loir",
"regime": "Régime Général",
"organismeDestinataire": "281",
"codeCentreInformatique": "008",
"adresse1": "11, Rue du Docteur André Haye",
"adresse2": "",
"commune": "CHARTRES",
"codePostal": "28034",
"cedex": "CEDEX",
"telephone": "0 820 904 101",
"fax": ""
},
{
"id": "01-351-0000",
"codeRegime": "01",
"caisseGestionnaire": "351",
"centreGestionnaire": "0000",
"libelle": "CPAM d Ille-et-Vilaine",
"regime": "Régime Général",
"organismeDestinataire": "351",
"codeCentreInformatique": "018",
"adresse1": "Cours des Alliés",
"adresse2": "BP 34 A",
"commune": "RENNES",
"codePostal": "35024",
"cedex": "CEDEX 9",
"telephone": "02 23 42 31 32",
"fax": "02 23 42 31 30"
},
{
"id": "01-371-0000",
"codeRegime": "01",
"caisseGestionnaire": "371",
"centreGestionnaire": "0000",
"libelle": "CPAM d Indre-et-Loire",
"regime": "Régime Général",
"organismeDestinataire": "371",
"codeCentreInformatique": "008",
"adresse1": "Cité Administrative du Champ Girault",
"adresse2": "36 Rue Edouard Vaillant",
"commune": "TOURS",
"codePostal": "37035",
"cedex": "CEDEX  9",
"telephone": "36 46",
"fax": ""
},
{
"id": "01-641-0000",
"codeRegime": "01",
"caisseGestionnaire": "641",
"centreGestionnaire": "0000",
"libelle": "CPAM de Bayonne",
"regime": "Régime Général",
"organismeDestinataire": "641",
"codeCentreInformatique": "005",
"adresse1": "CPAM HD - 68 Allées Marines",
"adresse2": "TSA 99998",
"commune": "BAYONNE",
"codePostal": "64119",
"cedex": "CEDEX",
"telephone": "36.08",
"fax": ""
},
{
"id": "01-011-0000",
"codeRegime": "01",
"caisseGestionnaire": "011",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Ain",
"regime": "Régime Général",
"organismeDestinataire": "011",
"codeCentreInformatique": "016",
"adresse1": "CPAM HD",
"adresse2": "Lots télétransmission TSA 99998",
"commune": "BOURG en BRESSE",
"codePostal": "01015",
"cedex": "CEDEX 9",
"telephone": "3608",
"fax": ""
},
{
"id": "01-021-0000",
"codeRegime": "01",
"caisseGestionnaire": "021",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Aisne",
"regime": "Régime Général",
"organismeDestinataire": "021",
"codeCentreInformatique": "011",
"adresse1": "CPAM HD",
"adresse2": "29 Bd Roosevelt CS 20606",
"commune": "SAINT QUENTIN",
"codePostal": "02323",
"cedex": "CEDEX",
"telephone": "3646",
"fax": "03 23 26 23 16"
},
{
"id": "01-031-0000",
"codeRegime": "01",
"caisseGestionnaire": "031",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Allier",
"regime": "Régime Général",
"organismeDestinataire": "031",
"codeCentreInformatique": "016",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998",
"commune": "MOULINS",
"codePostal": "03009",
"cedex": "CEDEX",
"telephone": "04 70 48 37 00",
"fax": ""
},
{
"id": "01-072-0000",
"codeRegime": "01",
"caisseGestionnaire": "072",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Ardeche",
"regime": "Régime Général",
"organismeDestinataire": "072",
"codeCentreInformatique": "016",
"adresse1": "6, Avenue de l'Europe Unie",
"adresse2": "",
"commune": "PRIVAS",
"codePostal": "07007",
"cedex": "CEDEX",
"telephone": "04 75 66 52 22",
"fax": "04 75 66 52 09"
},
{
"id": "01-091-0000",
"codeRegime": "01",
"caisseGestionnaire": "091",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Ariege",
"regime": "Régime Général",
"organismeDestinataire": "091",
"codeCentreInformatique": "002",
"adresse1": "1, Avenue de Sibian",
"adresse2": "",
"commune": "FOIX",
"codePostal": "09015",
"cedex": "CEDEX",
"telephone": "05 61 65 74 00",
"fax": "05 61 02 92 99"
},
{
"id": "01-624-0000",
"codeRegime": "01",
"caisseGestionnaire": "624",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Artois",
"regime": "Régime Général",
"organismeDestinataire": "624",
"codeCentreInformatique": "011",
"adresse1": "11 boulevard du Président Allendé",
"adresse2": "CS 90014",
"commune": "ARRAS Cedex",
"codePostal": "62014",
"cedex": "",
"telephone": "3646",
"fax": "03 21 14 05 74"
},
{
"id": "01-101-0000",
"codeRegime": "01",
"caisseGestionnaire": "101",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Aube",
"regime": "Régime Général",
"organismeDestinataire": "101",
"codeCentreInformatique": "013",
"adresse1": "CPAM HD",
"adresse2": "113 rue Etienne Pédron - TSA 99998",
"commune": "TROYES",
"codePostal": "10001",
"cedex": "CEDEX",
"telephone": "3646",
"fax": ""
},
{
"id": "01-111-0000",
"codeRegime": "01",
"caisseGestionnaire": "111",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Aude",
"regime": "Régime Général",
"organismeDestinataire": "111",
"codeCentreInformatique": "002",
"adresse1": "2, Allée de Bezons",
"adresse2": "",
"commune": "CARCASSONNE",
"codePostal": "11017",
"cedex": "CEDEX 9",
"telephone": "04 68 77 76 00",
"fax": ""
},
{
"id": "01-121-0000",
"codeRegime": "01",
"caisseGestionnaire": "121",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Aveyron",
"regime": "Régime Général",
"organismeDestinataire": "121",
"codeCentreInformatique": "002",
"adresse1": "Avenue de Bamberg",
"adresse2": "",
"commune": "RODEZ",
"codePostal": "12020",
"cedex": "CEDEX 9",
"telephone": "0 811 709 012",
"fax": ""
},
{
"id": "01-911-0000",
"codeRegime": "01",
"caisseGestionnaire": "911",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Essonne",
"regime": "Régime Général",
"organismeDestinataire": "911",
"codeCentreInformatique": "004",
"adresse1": "CPAM HD - PJ TELETRANSMISSION",
"adresse2": "5 RUE DU FACTEUR CHEVAL - TSA 99998",
"commune": "EVRY",
"codePostal": "91008",
"cedex": "CEDEX",
"telephone": "3608",
"fax": ""
},
{
"id": "01-271-0000",
"codeRegime": "01",
"caisseGestionnaire": "271",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Eure",
"regime": "Régime Général",
"organismeDestinataire": "271",
"codeCentreInformatique": "001",
"adresse1": "1bis, Place Saint Taurin",
"adresse2": "",
"commune": "EVREUX",
"codePostal": "27030",
"cedex": "CEDEX",
"telephone": "36 46",
"fax": ""
},
{
"id": "01-342-0000",
"codeRegime": "01",
"caisseGestionnaire": "342",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Herault",
"regime": "Régime Général",
"organismeDestinataire": "342",
"codeCentreInformatique": "002",
"adresse1": "CPAM DE L'HERAULT HD",
"adresse2": "TSA 99998",
"commune": "MONTPELLIER",
"codePostal": "34949",
"cedex": "CEDEX 9",
"telephone": "3608",
"fax": ""
},
{
"id": "01-361-0000",
"codeRegime": "01",
"caisseGestionnaire": "361",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Indre",
"regime": "Régime Général",
"organismeDestinataire": "361",
"codeCentreInformatique": "008",
"adresse1": "CPAM HD -LOTS TÉLÉTRANSMISSION",
"adresse2": "TSA 99998",
"commune": "CHATEAUROUX",
"codePostal": "36001",
"cedex": "CEDEX",
"telephone": "0 820 904 181",
"fax": "02 54 07 37 48"
},
{
"id": "01-381-0000",
"codeRegime": "01",
"caisseGestionnaire": "381",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Isere",
"regime": "Régime Général",
"organismeDestinataire": "381",
"codeCentreInformatique": "025",
"adresse1": "2, Rue des Alliés",
"adresse2": "",
"commune": "GRENOBLE",
"codePostal": "38045",
"cedex": "CEDEX 9",
"telephone": "04 76 68 50 50",
"fax": "04 76 68 50 48"
},
{
"id": "01-601-0000",
"codeRegime": "01",
"caisseGestionnaire": "601",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Oise",
"regime": "Régime Général",
"organismeDestinataire": "601",
"codeCentreInformatique": "011",
"adresse1": "Rue de Savoie",
"adresse2": "",
"commune": "BEAUVAIS",
"codePostal": "60013",
"cedex": "CEDEX",
"telephone": "03 44 10 12 52",
"fax": "03 44 10 11 50"
},
{
"id": "01-611-0000",
"codeRegime": "01",
"caisseGestionnaire": "611",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Orne",
"regime": "Régime Général",
"organismeDestinataire": "611",
"codeCentreInformatique": "001",
"adresse1": "34, Place du Général Bonet",
"adresse2": "",
"commune": "ALENCON",
"codePostal": "61012",
"cedex": "CEDEX",
"telephone": "0 820 904 161",
"fax": "02 33 32 36 40"
},
{
"id": "01-891-0000",
"codeRegime": "01",
"caisseGestionnaire": "891",
"centreGestionnaire": "0000",
"libelle": "CPAM de l Yonne",
"regime": "Régime Général",
"organismeDestinataire": "891",
"codeCentreInformatique": "010",
"adresse1": "1 et 3, Rue du Moulin",
"adresse2": "",
"commune": "AUXERRE",
"codePostal": "89024",
"cedex": "CEDEX",
"telephone": "0 820 904 167",
"fax": "03 86 83 42 99"
},
{
"id": "01-161-0000",
"codeRegime": "01",
"caisseGestionnaire": "161",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Charente",
"regime": "Régime Général",
"organismeDestinataire": "161",
"codeCentreInformatique": "008",
"adresse1": "CPAM HD",
"adresse2": "TSA 99998",
"commune": "ANGOULEME",
"codePostal": "16919",
"cedex": "CEDEX 9",
"telephone": "36.08",
"fax": ""
},
{
"id": "01-171-0000",
"codeRegime": "01",
"caisseGestionnaire": "171",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Charente-Maritime",
"regime": "Régime Général",
"organismeDestinataire": "171",
"codeCentreInformatique": "008",
"adresse1": "55-57, Rue de Suède",
"adresse2": "",
"commune": "LA ROCHELLE",
"codePostal": "17014",
"cedex": "CEDEX",
"telephone": "05 46 51 66 42",
"fax": "05 46 51 66 46"
},
{
"id": "01-191-0000",
"codeRegime": "01",
"caisseGestionnaire": "191",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Correze",
"regime": "Régime Général",
"organismeDestinataire": "191",
"codeCentreInformatique": "008",
"adresse1": "6 Rue Souham",
"adresse2": "",
"commune": "TULLE",
"codePostal": "19033",
"cedex": "CEDEX",
"telephone": "0820904133",
"fax": ""
},
{
"id": "01-201-0000",
"codeRegime": "01",
"caisseGestionnaire": "201",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Corse-du-Sud",
"regime": "Régime Général",
"organismeDestinataire": "201",
"codeCentreInformatique": "021",
"adresse1": "Boulevard Abbé Recco Les Paludes",
"adresse2": "BP 910",
"commune": "AJACCIO",
"codePostal": "20702",
"cedex": "CEDEX 9",
"telephone": "04 95 23 52 00",
"fax": "04 95 20 64 74"
},
{
"id": "01-623-0000",
"codeRegime": "01",
"caisseGestionnaire": "623",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Cote-d Opale",
"regime": "Régime Général",
"organismeDestinataire": "623",
"codeCentreInformatique": "011",
"adresse1": "CPAM HD 35 rue Descartes",
"adresse2": "TSA 99998",
"commune": "CALAIS",
"codePostal": "62109",
"cedex": "CEDEX",
"telephone": "03 21 46 84 00",
"fax": "03 21 97 81 47"
},
{
"id": "01-211-0000",
"codeRegime": "01",
"caisseGestionnaire": "211",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Cote-d Or",
"regime": "Régime Général",
"organismeDestinataire": "211",
"codeCentreInformatique": "010",
"adresse1": "BP 34548",
"adresse2": "",
"commune": "DIJON",
"codePostal": "21045",
"cedex": "CEDEX",
"telephone": "0380593759",
"fax": ""
},
{
"id": "01-231-0000",
"codeRegime": "01",
"caisseGestionnaire": "231",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Creuse",
"regime": "Régime Général",
"organismeDestinataire": "231",
"codeCentreInformatique": "008",
"adresse1": "Rue Marcel Brunet",
"adresse2": "",
"commune": "GUERET",
"codePostal": "23014",
"cedex": "CEDEX",
"telephone": "05 55 41 23 00",
"fax": "05 55 41 23 13"
},
{
"id": "01-241-0000",
"codeRegime": "01",
"caisseGestionnaire": "241",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Dordogne",
"regime": "Régime Général",
"organismeDestinataire": "241",
"codeCentreInformatique": "005",
"adresse1": "CPAM HD",
"adresse2": "50, Rue Claude Bernard - TSA99998",
"commune": "PERIGUEUX",
"codePostal": "24020",
"cedex": "CEDEX",
"telephone": "05 53 35 60 00",
"fax": "05 53 35 61 30"
},
{
"id": "01-261-0000",
"codeRegime": "01",
"caisseGestionnaire": "261",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Drome",
"regime": "Régime Général",
"organismeDestinataire": "261",
"codeCentreInformatique": "016",
"adresse1": "Avenue du Président Herriot",
"adresse2": "BP 1000",
"commune": "VALENCE",
"codePostal": "26024",
"cedex": "CEDEX",
"telephone": "3646",
"fax": "04 75 75 52 23"
},
{
"id": "01-331-0000",
"codeRegime": "01",
"caisseGestionnaire": "331",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Gironde",
"regime": "Régime Général",
"organismeDestinataire": "331",
"codeCentreInformatique": "005",
"adresse1": "Cité du Grand Parc",
"adresse2": "Place de l'Europe",
"commune": "BORDEAUX",
"codePostal": "33085",
"cedex": "CEDEX",
"telephone": "3646",
"fax": "05 56 11 54 15"
},
{
"id": "01-202-0000",
"codeRegime": "01",
"caisseGestionnaire": "202",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Haute-Corse",
"regime": "Régime Général",
"organismeDestinataire": "202",
"codeCentreInformatique": "021",
"adresse1": "5 avenue Jean Zuccarelli",
"adresse2": "",
"commune": "BASTIA",
"codePostal": "20406",
"cedex": "CEDEX",
"telephone": "36.46",
"fax": ""
},
{
"id": "01-311-0000",
"codeRegime": "01",
"caisseGestionnaire": "311",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Haute-Garonne",
"regime": "Régime Général",
"organismeDestinataire": "311",
"codeCentreInformatique": "002",
"adresse1": "TSA 99998",
"adresse2": "Télétransmission PS",
"commune": "TOULOUSE",
"codePostal": "31107",
"cedex": "CEDEX 9",
"telephone": "05.62.73.81.20",
"fax": ""
},
{
"id": "01-431-0000",
"codeRegime": "01",
"caisseGestionnaire": "431",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Haute-Loire",
"regime": "Régime Général",
"organismeDestinataire": "431",
"codeCentreInformatique": "016",
"adresse1": "10, Avenue André Soulier",
"adresse2": "BP 324",
"commune": "LE PUY EN VELAY",
"codePostal": "43011",
"cedex": "CEDEX",
"telephone": "04 71 07 58 88",
"fax": ""
},
{
"id": "01-521-0000",
"codeRegime": "01",
"caisseGestionnaire": "521",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Haute-Marne",
"regime": "Régime Général",
"organismeDestinataire": "521",
"codeCentreInformatique": "013",
"adresse1": "18, Bld Maréchal de Lattre de Tassigny",
"adresse2": "BP 2028",
"commune": "CHAUMONT",
"codePostal": "52915",
"cedex": "CEDEX 9",
"telephone": "03 25 02 85 85",
"fax": ""
},
{
"id": "01-701-0000",
"codeRegime": "01",
"caisseGestionnaire": "701",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Haute-Saone",
"regime": "Régime Général",
"organismeDestinataire": "701",
"codeCentreInformatique": "010",
"adresse1": "9, Boulevard des Alliés",
"adresse2": "BP 439",
"commune": "VESOUL",
"codePostal": "70020",
"cedex": "CEDEX",
"telephone": "03 84 97 72 72",
"fax": ""
},
{
"id": "01-741-0000",
"codeRegime": "01",
"caisseGestionnaire": "741",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Haute-Savoie",
"regime": "Régime Général",
"organismeDestinataire": "741",
"codeCentreInformatique": "016",
"adresse1": "Service Informatique de Production",
"adresse2": "2 rue Robert Schuman",
"commune": "ANNECY",
"codePostal": "74984",
"cedex": "CEDEX 9",
"telephone": "04 50 88 68 18",
"fax": "04 50 88 52 74"
},
{
"id": "01-871-0000",
"codeRegime": "01",
"caisseGestionnaire": "871",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Haute-Vienne",
"regime": "Régime Général",
"organismeDestinataire": "871",
"codeCentreInformatique": "008",
"adresse1": "22, Avenue Jean Gagnant",
"adresse2": "",
"commune": "LIMOGES",
"codePostal": "87037",
"cedex": "CEDEX",
"telephone": "05 55 45 87 87",
"fax": ""
},
{
"id": "01-422-0000",
"codeRegime": "01",
"caisseGestionnaire": "422",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Loire",
"regime": "Régime Général",
"organismeDestinataire": "422",
"codeCentreInformatique": "016",
"adresse1": "3 Parvis Pierre Laroque",
"adresse2": "",
"commune": "SAINT ETIENNE",
"codePostal": "42000",
"cedex": "CEDEX 1",
"telephone": "0 811 910 009",
"fax": ""
},
{
"id": "01-481-0000",
"codeRegime": "01",
"caisseGestionnaire": "481",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Lozere",
"regime": "Régime Général",
"organismeDestinataire": "481",
"codeCentreInformatique": "002",
"adresse1": "Quartier des Carmes",
"adresse2": "BP 26",
"commune": "MENDE",
"codePostal": "48006",
"cedex": "CEDEX",
"telephone": "04 66 49 56 80",
"fax": ""
},
{
"id": "01-501-0000",
"codeRegime": "01",
"caisseGestionnaire": "501",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Manche",
"regime": "Régime Général",
"organismeDestinataire": "501",
"codeCentreInformatique": "001",
"adresse1": "Montée du Bois André",
"adresse2": "",
"commune": "SAINT LO",
"codePostal": "50012",
"cedex": "CEDEX",
"telephone": "02 33 06 58 00",
"fax": ""
},
{
"id": "01-511-0000",
"codeRegime": "01",
"caisseGestionnaire": "511",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Marne",
"regime": "Régime Général",
"organismeDestinataire": "511",
"codeCentreInformatique": "013",
"adresse1": "14-16, Rue du Ruisselet",
"adresse2": "",
"commune": "REIMS",
"codePostal": "51086",
"cedex": "CEDEX",
"telephone": "03 26 84 40 40",
"fax": ""
},
{
"id": "01-531-0000",
"codeRegime": "01",
"caisseGestionnaire": "531",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Mayenne",
"regime": "Régime Général",
"organismeDestinataire": "531",
"codeCentreInformatique": "023",
"adresse1": "37, boulevard Montmorency",
"adresse2": "",
"commune": "LAVAL",
"codePostal": "53084",
"cedex": "CEDEX 9",
"telephone": "0 820 904 137",
"fax": "02 43 53 30 43"
},
{
"id": "01-542-0000",
"codeRegime": "01",
"caisseGestionnaire": "542",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Meurthe-et-Moselle",
"regime": "Régime Général",
"organismeDestinataire": "542",
"codeCentreInformatique": "013",
"adresse1": "9, Boulevard Joffre",
"adresse2": "",
"commune": "NANCY",
"codePostal": "54047",
"cedex": "CEDEX",
"telephone": "03 83 85 50 00",
"fax": "03 83 32 27 19"
},
{
"id": "01-551-0000",
"codeRegime": "01",
"caisseGestionnaire": "551",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Meuse",
"regime": "Régime Général",
"organismeDestinataire": "551",
"codeCentreInformatique": "013",
"adresse1": "CPAM HD",
"adresse2": "1, rue de Polval - TSA 99998",
"commune": "BAR LE DUC",
"codePostal": "55019",
"cedex": "CEDEX",
"telephone": "0 820 904 165",
"fax": ""
},
{
"id": "01-581-0000",
"codeRegime": "01",
"caisseGestionnaire": "581",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Nievre",
"regime": "Régime Général",
"organismeDestinataire": "581",
"codeCentreInformatique": "010",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998 - Rue Paul Vaillant Couturier",
"commune": "NEVERS",
"codePostal": "58025",
"cedex": "CEDEX",
"telephone": "3646",
"fax": ""
},
{
"id": "01-711-0000",
"codeRegime": "01",
"caisseGestionnaire": "711",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Saone-et-Loire",
"regime": "Régime Général",
"organismeDestinataire": "711",
"codeCentreInformatique": "010",
"adresse1": "113, Rue de Paris",
"adresse2": "",
"commune": "MACON",
"codePostal": "71022",
"cedex": "CEDEX 09",
"telephone": "36 46",
"fax": "03 85 39 73 48"
},
{
"id": "01-721-0000",
"codeRegime": "01",
"caisseGestionnaire": "721",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Sarthe",
"regime": "Régime Général",
"organismeDestinataire": "721",
"codeCentreInformatique": "023",
"adresse1": "178, Avenue Bollée",
"adresse2": "",
"commune": "LE MANS",
"codePostal": "72033",
"cedex": "CEDEX 9",
"telephone": "0 811 709 072",
"fax": "02 43 50 75 37"
},
{
"id": "01-731-0000",
"codeRegime": "01",
"caisseGestionnaire": "731",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Savoie",
"regime": "Régime Général",
"organismeDestinataire": "731",
"codeCentreInformatique": "025",
"adresse1": "5, Avenue Jean Jaurès",
"adresse2": "",
"commune": "CHAMBERY",
"codePostal": "73015",
"cedex": "CEDEX",
"telephone": "04 79 96 81 00",
"fax": "04 79 96 45 09"
},
{
"id": "01-771-0000",
"codeRegime": "01",
"caisseGestionnaire": "771",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Seine-et-Marne",
"regime": "Régime Général",
"organismeDestinataire": "771",
"codeCentreInformatique": "004",
"adresse1": "",
"adresse2": "",
"commune": "MARNE LA VALLEE",
"codePostal": "77605",
"cedex": "CEDEX 03",
"telephone": "36 46",
"fax": ""
},
{
"id": "01-931-0000",
"codeRegime": "01",
"caisseGestionnaire": "931",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Seine-Saint-Denis",
"regime": "Régime Général",
"organismeDestinataire": "931",
"codeCentreInformatique": "004",
"adresse1": "CPAM HD - Télétransmission",
"adresse2": "195 Avenue Paul Vaillant Couturier - TSA 99998",
"commune": "BOBIGNY",
"codePostal": "93016",
"cedex": "CEDEX",
"telephone": "01 48 96 48 48",
"fax": ""
},
{
"id": "01-801-0000",
"codeRegime": "01",
"caisseGestionnaire": "801",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Somme",
"regime": "Régime Général",
"organismeDestinataire": "801",
"codeCentreInformatique": "011",
"adresse1": "TSA 99998",
"adresse2": "",
"commune": "AMIENS",
"codePostal": "80049",
"cedex": "CEDEX 1",
"telephone": "",
"fax": ""
},
{
"id": "01-851-0000",
"codeRegime": "01",
"caisseGestionnaire": "851",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Vendee",
"regime": "Régime Général",
"organismeDestinataire": "851",
"codeCentreInformatique": "023",
"adresse1": "Rue Alain",
"adresse2": "",
"commune": "LA ROCHE sur YON",
"codePostal": "85031",
"cedex": "CEDEX",
"telephone": "0811709098",
"fax": "02 51 44 18 00"
},
{
"id": "01-861-0000",
"codeRegime": "01",
"caisseGestionnaire": "861",
"centreGestionnaire": "0000",
"libelle": "CPAM de la Vienne",
"regime": "Régime Général",
"organismeDestinataire": "861",
"codeCentreInformatique": "008",
"adresse1": "41, Rue du Touffenet",
"adresse2": "",
"commune": "POITIERS",
"codePostal": "86043",
"cedex": "CEDEX9",
"telephone": "05 49 44 59 97",
"fax": ""
},
{
"id": "01-595-0000",
"codeRegime": "01",
"caisseGestionnaire": "595",
"centreGestionnaire": "0000",
"libelle": "CPAM de Lille-Douai",
"regime": "Régime Général",
"organismeDestinataire": "595",
"codeCentreInformatique": "011",
"adresse1": "125 rue Saint Sulpice",
"adresse2": "CS 20821",
"commune": "DOUAI",
"codePostal": "59508",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "01-411-0000",
"codeRegime": "01",
"caisseGestionnaire": "411",
"centreGestionnaire": "0000",
"libelle": "CPAM de Loir-et-Cher",
"regime": "Régime Général",
"organismeDestinataire": "411",
"codeCentreInformatique": "008",
"adresse1": "6, Rue Louis Armand",
"adresse2": "TSA 99998",
"commune": "BLOIS",
"codePostal": "41035",
"cedex": "CEDEX",
"telephone": "36 46",
"fax": "02.54.50.16.24"
},
{
"id": "01-441-0000",
"codeRegime": "01",
"caisseGestionnaire": "441",
"centreGestionnaire": "0000",
"libelle": "CPAM de Loire-Atlantique",
"regime": "Régime Général",
"organismeDestinataire": "441",
"codeCentreInformatique": "023",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998",
"commune": "NANTES",
"codePostal": "44958",
"cedex": "CEDEX",
"telephone": "3608",
"fax": ""
},
{
"id": "01-471-0000",
"codeRegime": "01",
"caisseGestionnaire": "471",
"centreGestionnaire": "0000",
"libelle": "CPAM de Lot-et-Garonne",
"regime": "Régime Général",
"organismeDestinataire": "471",
"codeCentreInformatique": "005",
"adresse1": "CPAM HD",
"adresse2": "TSA 99998",
"commune": "AGEN",
"codePostal": "47909",
"cedex": "CEDEX 9",
"telephone": "05 53 69 10 64",
"fax": ""
},
{
"id": "01-571-0000",
"codeRegime": "01",
"caisseGestionnaire": "571",
"centreGestionnaire": "0000",
"libelle": "CPAM de Moselle",
"regime": "Régime Général",
"organismeDestinataire": "571",
"codeCentreInformatique": "017",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998",
"commune": "METZ",
"codePostal": "57751",
"cedex": "CEDEX 9",
"telephone": "03 87 39 36 36",
"fax": ""
},
{
"id": "01-751-0000",
"codeRegime": "01",
"caisseGestionnaire": "751",
"centreGestionnaire": "0000",
"libelle": "CPAM de Paris",
"regime": "Régime Général",
"organismeDestinataire": "751",
"codeCentreInformatique": "036",
"adresse1": "21 rue Georges Auric",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75948",
"cedex": "CEDEX 19",
"telephone": "01 53 38 70 00",
"fax": "01 53 38 73 47"
},
{
"id": "01-642-0000",
"codeRegime": "01",
"caisseGestionnaire": "642",
"centreGestionnaire": "0000",
"libelle": "CPAM de Pau",
"regime": "Régime Général",
"organismeDestinataire": "642",
"codeCentreInformatique": "005",
"adresse1": "26 bis Avenue des Lilas",
"adresse2": "",
"commune": "PAU",
"codePostal": "64022",
"cedex": "CEDEX 9",
"telephone": "05 59 90 30 00",
"fax": ""
},
{
"id": "01-597-0000",
"codeRegime": "01",
"caisseGestionnaire": "597",
"centreGestionnaire": "0000",
"libelle": "CPAM de Roubaix-Tourcoing",
"regime": "Régime Général",
"organismeDestinataire": "597",
"codeCentreInformatique": "011",
"adresse1": "6, Rue Rémi Cogghe",
"adresse2": "BP 769",
"commune": "ROUBAIX",
"codePostal": "59065",
"cedex": "CEDEX 1",
"telephone": "3646",
"fax": ""
},
{
"id": "01-764-0000",
"codeRegime": "01",
"caisseGestionnaire": "764",
"centreGestionnaire": "0000",
"libelle": "CPAM de Rouen-Elbeuf-Dieppe-Seine-Maritime",
"regime": "Régime Général",
"organismeDestinataire": "764",
"codeCentreInformatique": "001",
"adresse1": "50, Avenue de Bretagne",
"adresse2": "",
"commune": "ROUEN",
"codePostal": "76039",
"cedex": "CEDEX",
"telephone": "02 35 03 63 63",
"fax": ""
},
{
"id": "01-041-0000",
"codeRegime": "01",
"caisseGestionnaire": "041",
"centreGestionnaire": "0000",
"libelle": "CPAM des Alpes de Haute Provence",
"regime": "Régime Général",
"organismeDestinataire": "041",
"codeCentreInformatique": "021",
"adresse1": "CPAM HD",
"adresse2": "TSA 99998",
"commune": "DIGNE les BAINS",
"codePostal": "04029",
"cedex": "CEDEX",
"telephone": "08 11 70 36 46",
"fax": ""
},
{
"id": "01-061-0000",
"codeRegime": "01",
"caisseGestionnaire": "061",
"centreGestionnaire": "0000",
"libelle": "CPAM des Alpes-Maritimes",
"regime": "Régime Général",
"organismeDestinataire": "061",
"codeCentreInformatique": "021",
"adresse1": "CPAM HD - Télétransmission PS/ CDS",
"adresse2": "48 AV ROI ROBERT COMTE DE PROVENCE - TSA 99998",
"commune": "NICE",
"codePostal": "06099",
"cedex": "CEDEX 1",
"telephone": "3646",
"fax": ""
},
{
"id": "01-081-0000",
"codeRegime": "01",
"caisseGestionnaire": "081",
"centreGestionnaire": "0000",
"libelle": "CPAM des Ardennes",
"regime": "Régime Général",
"organismeDestinataire": "081",
"codeCentreInformatique": "013",
"adresse1": "14, Avenue G. Corneau",
"adresse2": "",
"commune": "CHARLEVILLE MEZIERES",
"codePostal": "08101",
"cedex": "CEDEX",
"telephone": "0 820 904 148",
"fax": ""
},
{
"id": "01-131-0000",
"codeRegime": "01",
"caisseGestionnaire": "131",
"centreGestionnaire": "0000",
"libelle": "CPAM des Bouches-du-Rhone",
"regime": "Régime Général",
"organismeDestinataire": "131",
"codeCentreInformatique": "021",
"adresse1": "29 rue JB Reboul",
"adresse2": "TSA 99998",
"commune": "MARSEILLE",
"codePostal": "13395",
"cedex": "CEDEX 10",
"telephone": "04 91 83 70 00",
"fax": ""
},
{
"id": "01-221-0000",
"codeRegime": "01",
"caisseGestionnaire": "221",
"centreGestionnaire": "0000",
"libelle": "CPAM des Cotes-d Armor",
"regime": "Régime Général",
"organismeDestinataire": "221",
"codeCentreInformatique": "018",
"adresse1": "106, Boulevard Hoche",
"adresse2": "",
"commune": "SAINT-BRIEUC",
"codePostal": "22024",
"cedex": "CEDEX 1",
"telephone": "0 820 904 179",
"fax": ""
},
{
"id": "01-791-0000",
"codeRegime": "01",
"caisseGestionnaire": "791",
"centreGestionnaire": "0000",
"libelle": "CPAM des Deux-Sevres",
"regime": "Régime Général",
"organismeDestinataire": "791",
"codeCentreInformatique": "008",
"adresse1": "Parc d'activités de l'Ebaupin",
"adresse2": "1 rue de l'Angélique",
"commune": "NIORT",
"codePostal": "79041",
"cedex": "CEDEX",
"telephone": "05 49 77 30 00",
"fax": ""
},
{
"id": "01-594-0000",
"codeRegime": "01",
"caisseGestionnaire": "594",
"centreGestionnaire": "0000",
"libelle": "CPAM des Flandres-Dunkerque-Armentieres",
"regime": "Régime Général",
"organismeDestinataire": "594",
"codeCentreInformatique": "011",
"adresse1": "2 Rue de la Batellerie",
"adresse2": "BP 4523",
"commune": "DUNKERQUE",
"codePostal": "59386",
"cedex": "CEDEX 1",
"telephone": "03 28 26 39 39",
"fax": "03 28 26 38 80"
},
{
"id": "01-051-0000",
"codeRegime": "01",
"caisseGestionnaire": "051",
"centreGestionnaire": "0000",
"libelle": "CPAM des Hautes-Alpes",
"regime": "Régime Général",
"organismeDestinataire": "051",
"codeCentreInformatique": "021",
"adresse1": "CPAM HD",
"adresse2": "10, Bd G. Pompidou - TSA 99998",
"commune": "GAP",
"codePostal": "05005",
"cedex": "CEDEX",
"telephone": "04 92 53 11 91",
"fax": "04.92.51.38.70"
},
{
"id": "01-651-0000",
"codeRegime": "01",
"caisseGestionnaire": "651",
"centreGestionnaire": "0000",
"libelle": "CPAM des Hautes-Pyrenees",
"regime": "Régime Général",
"organismeDestinataire": "651",
"codeCentreInformatique": "002",
"adresse1": "CPAM HD 8, Place au Bois",
"adresse2": "TSA 99998",
"commune": "TARBES",
"codePostal": "65919",
"cedex": "CEDEX 9",
"telephone": "0820 904 135",
"fax": "05 62 34 49 34"
},
{
"id": "01-921-0000",
"codeRegime": "01",
"caisseGestionnaire": "921",
"centreGestionnaire": "0000",
"libelle": "CPAM des Hauts-de-Seine",
"regime": "Régime Général",
"organismeDestinataire": "921",
"codeCentreInformatique": "036",
"adresse1": "113, Rue des Trois Fontanot",
"adresse2": "",
"commune": "NANTERRE",
"codePostal": "92026",
"cedex": "CEDEX",
"telephone": "01 41 45 20 00",
"fax": ""
},
{
"id": "01-401-0000",
"codeRegime": "01",
"caisseGestionnaire": "401",
"centreGestionnaire": "0000",
"libelle": "CPAM des Landes",
"regime": "Régime Général",
"organismeDestinataire": "401",
"codeCentreInformatique": "005",
"adresse1": "207, Rue Fontainebleau",
"adresse2": "",
"commune": "MONT de MARSAN",
"codePostal": "40013",
"cedex": "CEDEX",
"telephone": "05 58 06 62 00",
"fax": ""
},
{
"id": "01-661-0000",
"codeRegime": "01",
"caisseGestionnaire": "661",
"centreGestionnaire": "0000",
"libelle": "CPAM des Pyrenees-Orientales",
"regime": "Régime Général",
"organismeDestinataire": "661",
"codeCentreInformatique": "002",
"adresse1": "rue des remparts saint mathieu",
"adresse2": "BP 89928",
"commune": "PERPIGNAN",
"codePostal": "66013",
"cedex": "CEDEX 9",
"telephone": "3646",
"fax": "04.68.35.96.96"
},
{
"id": "01-881-0000",
"codeRegime": "01",
"caisseGestionnaire": "881",
"centreGestionnaire": "0000",
"libelle": "CPAM des Vosges",
"regime": "Régime Général",
"organismeDestinataire": "881",
"codeCentreInformatique": "013",
"adresse1": "CPAM HD ? Services lots Télétransmissions",
"adresse2": "14, rue de la Clé d'Or - TSA 99998",
"commune": "EPINAL",
"codePostal": "88060",
"cedex": "CEDEX 9",
"telephone": "0820904166",
"fax": "0329643419"
},
{
"id": "01-781-0000",
"codeRegime": "01",
"caisseGestionnaire": "781",
"centreGestionnaire": "0000",
"libelle": "CPAM des Yvelines",
"regime": "Régime Général",
"organismeDestinataire": "781",
"codeCentreInformatique": "036",
"adresse1": "CPAM HD-TELETRANSMISSIONS",
"adresse2": "TSA 99 998",
"commune": "VERSAILLES",
"codePostal": "78085",
"cedex": "CEDEX 9",
"telephone": "01 39 20 30 00",
"fax": ""
},
{
"id": "01-673-0000",
"codeRegime": "01",
"caisseGestionnaire": "673",
"centreGestionnaire": "0000",
"libelle": "CPAM du Bas-Rhin",
"regime": "Régime Général",
"organismeDestinataire": "673",
"codeCentreInformatique": "017",
"adresse1": "16, Rue de Lausanne",
"adresse2": "BP 408 R 2",
"commune": "STRASBOURG",
"codePostal": "67090",
"cedex": "CEDEX",
"telephone": "0811 709 067",
"fax": ""
},
{
"id": "01-141-0000",
"codeRegime": "01",
"caisseGestionnaire": "141",
"centreGestionnaire": "0000",
"libelle": "CPAM du Calvados",
"regime": "Régime Général",
"organismeDestinataire": "141",
"codeCentreInformatique": "001",
"adresse1": "CPAM HD 108 Boulevard Jean Moulin",
"adresse2": "TSA 99 998",
"commune": "CAEN",
"codePostal": "14913",
"cedex": "CEDEX 9",
"telephone": "3608",
"fax": ""
},
{
"id": "01-151-0000",
"codeRegime": "01",
"caisseGestionnaire": "151",
"centreGestionnaire": "0000",
"libelle": "CPAM du Cantal",
"regime": "Régime Général",
"organismeDestinataire": "151",
"codeCentreInformatique": "016",
"adresse1": "CPAM HD - TELETRANSMISSION",
"adresse2": "15, Rue Pierre Marty - TSA 99998",
"commune": "AURILLAC",
"codePostal": "15002",
"cedex": "CEDEX",
"telephone": "04 71 46 57 00",
"fax": ""
},
{
"id": "01-181-0000",
"codeRegime": "01",
"caisseGestionnaire": "181",
"centreGestionnaire": "0000",
"libelle": "CPAM du Cher",
"regime": "Régime Général",
"organismeDestinataire": "181",
"codeCentreInformatique": "008",
"adresse1": "Boulevard de la République",
"adresse2": "",
"commune": "BOURGES",
"codePostal": "18030",
"cedex": "CEDEX 9",
"telephone": "0 820 904 180",
"fax": "02 48 55 49 62"
},
{
"id": "01-251-0000",
"codeRegime": "01",
"caisseGestionnaire": "251",
"centreGestionnaire": "0000",
"libelle": "CPAM du Doubs",
"regime": "Régime Général",
"organismeDestinataire": "251",
"codeCentreInformatique": "010",
"adresse1": "2, Rue Denis Papin",
"adresse2": "",
"commune": "BESANCON",
"codePostal": "25036",
"cedex": "CEDEX",
"telephone": "0 811 70 90 25",
"fax": ""
},
{
"id": "01-291-0000",
"codeRegime": "01",
"caisseGestionnaire": "291",
"centreGestionnaire": "0000",
"libelle": "CPAM du Finistere",
"regime": "Régime Général",
"organismeDestinataire": "291",
"codeCentreInformatique": "018",
"adresse1": "Rue de Savoie",
"adresse2": "",
"commune": "BREST",
"codePostal": "29282",
"cedex": "CEDEX",
"telephone": "3646",
"fax": "02 98 34 53 00"
},
{
"id": "01-301-0000",
"codeRegime": "01",
"caisseGestionnaire": "301",
"centreGestionnaire": "0000",
"libelle": "CPAM du Gard",
"regime": "Régime Général",
"organismeDestinataire": "301",
"codeCentreInformatique": "002",
"adresse1": "14, Rue du Cirque Romain",
"adresse2": "",
"commune": "NIMES",
"codePostal": "30921",
"cedex": "CEDEX 9",
"telephone": "04 66 76 62 62",
"fax": ""
},
{
"id": "01-321-0000",
"codeRegime": "01",
"caisseGestionnaire": "321",
"centreGestionnaire": "0000",
"libelle": "CPAM du Gers",
"regime": "Régime Général",
"organismeDestinataire": "321",
"codeCentreInformatique": "002",
"adresse1": "11, Rue de Châteaudun",
"adresse2": "",
"commune": "AUCH",
"codePostal": "32012",
"cedex": "CEDEX",
"telephone": "0 820 904 134",
"fax": "05 62 61 61 78"
},
{
"id": "01-599-0000",
"codeRegime": "01",
"caisseGestionnaire": "599",
"centreGestionnaire": "0000",
"libelle": "CPAM du Hainaut",
"regime": "Régime Général",
"organismeDestinataire": "599",
"codeCentreInformatique": "011",
"adresse1": "63, rue du Rempart",
"adresse2": "BP 499",
"commune": "VALENCIENNES",
"codePostal": "59321",
"cedex": "CEDEX",
"telephone": "03 27 23 95 95",
"fax": ""
},
{
"id": "01-682-0000",
"codeRegime": "01",
"caisseGestionnaire": "682",
"centreGestionnaire": "0000",
"libelle": "CPAM du Haut-Rhin",
"regime": "Régime Général",
"organismeDestinataire": "682",
"codeCentreInformatique": "017",
"adresse1": "19, bd du Champ de Mars",
"adresse2": "BP 40454",
"commune": "COLMAR",
"codePostal": "68022",
"cedex": "CEDEX",
"telephone": "03 89 46 97 00",
"fax": ""
},
{
"id": "01-763-0000",
"codeRegime": "01",
"caisseGestionnaire": "763",
"centreGestionnaire": "0000",
"libelle": "CPAM du Havre",
"regime": "Régime Général",
"organismeDestinataire": "763",
"codeCentreInformatique": "001",
"adresse1": "222, Boulevard de Strasbourg",
"adresse2": "",
"commune": "LE HAVRE",
"codePostal": "76094",
"cedex": "CEDEX",
"telephone": "02 32 74 80 00",
"fax": "02 32 74 80 08"
},
{
"id": "01-391-0000",
"codeRegime": "01",
"caisseGestionnaire": "391",
"centreGestionnaire": "0000",
"libelle": "CPAM du Jura",
"regime": "Régime Général",
"organismeDestinataire": "391",
"codeCentreInformatique": "010",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998",
"commune": "LONS LE SAUNIER CEDEX",
"codePostal": "39007",
"cedex": "",
"telephone": "",
"fax": ""
},
{
"id": "01-451-0000",
"codeRegime": "01",
"caisseGestionnaire": "451",
"centreGestionnaire": "0000",
"libelle": "CPAM du Loiret",
"regime": "Régime Général",
"organismeDestinataire": "451",
"codeCentreInformatique": "008",
"adresse1": "HD",
"adresse2": "Place du Général de Gaulle",
"commune": "ORLEANS",
"codePostal": "45021",
"cedex": "CEDEX 1",
"telephone": "02 38 79 47 00",
"fax": ""
},
{
"id": "01-461-0000",
"codeRegime": "01",
"caisseGestionnaire": "461",
"centreGestionnaire": "0000",
"libelle": "CPAM du Lot",
"regime": "Régime Général",
"organismeDestinataire": "461",
"codeCentreInformatique": "002",
"adresse1": "238 rue Hautesserre",
"adresse2": "",
"commune": "CAHORS",
"codePostal": "46015",
"cedex": "CEDEX 9",
"telephone": "05 65 20 40 40",
"fax": ""
},
{
"id": "01-491-0000",
"codeRegime": "01",
"caisseGestionnaire": "491",
"centreGestionnaire": "0000",
"libelle": "CPAM du Maine-et-Loire",
"regime": "Régime Général",
"organismeDestinataire": "491",
"codeCentreInformatique": "023",
"adresse1": "32 Rue Louis Gain",
"adresse2": "",
"commune": "ANGERS",
"codePostal": "49037",
"cedex": "CEDEX 01",
"telephone": "0820 904 158",
"fax": "02 41 81 76 00"
},
{
"id": "01-561-0000",
"codeRegime": "01",
"caisseGestionnaire": "561",
"centreGestionnaire": "0000",
"libelle": "CPAM du Morbihan",
"regime": "Régime Général",
"organismeDestinataire": "561",
"codeCentreInformatique": "018",
"adresse1": "",
"adresse2": "BP 20321",
"commune": "VANNES",
"codePostal": "56021",
"cedex": "CEDEX",
"telephone": "3646",
"fax": ""
},
{
"id": "01-631-0000",
"codeRegime": "01",
"caisseGestionnaire": "631",
"centreGestionnaire": "0000",
"libelle": "CPAM du Puy-de-Dome",
"regime": "Régime Général",
"organismeDestinataire": "631",
"codeCentreInformatique": "016",
"adresse1": "2 rue Serge Gainsbourg",
"adresse2": "",
"commune": "CLERMONT-FERRAND",
"codePostal": "63000",
"cedex": "",
"telephone": "0820904145",
"fax": "0473425570"
},
{
"id": "01-691-0000",
"codeRegime": "01",
"caisseGestionnaire": "691",
"centreGestionnaire": "0000",
"libelle": "CPAM du Rhone",
"regime": "Régime Général",
"organismeDestinataire": "691",
"codeCentreInformatique": "025",
"adresse1": "CPAM de LYON",
"adresse2": "",
"commune": "LYON",
"codePostal": "69907",
"cedex": "CEDEX 20",
"telephone": "0 811 709 069",
"fax": ""
},
{
"id": "01-811-0000",
"codeRegime": "01",
"caisseGestionnaire": "811",
"centreGestionnaire": "0000",
"libelle": "CPAM du Tarn",
"regime": "Régime Général",
"organismeDestinataire": "811",
"codeCentreInformatique": "002",
"adresse1": "CPAM HD",
"adresse2": "TSA 99998",
"commune": "ALBI",
"codePostal": "81037",
"cedex": "CEDEX 9",
"telephone": "36 08",
"fax": ""
},
{
"id": "01-821-0000",
"codeRegime": "01",
"caisseGestionnaire": "821",
"centreGestionnaire": "0000",
"libelle": "CPAM du Tarn-et-Garonne",
"regime": "Régime Général",
"organismeDestinataire": "821",
"codeCentreInformatique": "002",
"adresse1": "592, boulevard Blaise Doumerc",
"adresse2": "BP 778",
"commune": "MONTAUBAN",
"codePostal": "82015",
"cedex": "CEDEX",
"telephone": "0820904118",
"fax": "05 63 21 39 08"
},
{
"id": "01-901-0000",
"codeRegime": "01",
"caisseGestionnaire": "901",
"centreGestionnaire": "0000",
"libelle": "CPAM du Territoire de Belfort",
"regime": "Régime Général",
"organismeDestinataire": "901",
"codeCentreInformatique": "010",
"adresse1": "12, Rue du Général Strolz",
"adresse2": "",
"commune": "BELFORT",
"codePostal": "90021",
"cedex": "CEDEX",
"telephone": "03 84 46 53 53",
"fax": ""
},
{
"id": "01-951-0000",
"codeRegime": "01",
"caisseGestionnaire": "951",
"centreGestionnaire": "0000",
"libelle": "CPAM du Val-d Oise",
"regime": "Régime Général",
"organismeDestinataire": "951",
"codeCentreInformatique": "036",
"adresse1": "Immeuble Les Marjoberts",
"adresse2": "2, Rue des Chauffours",
"commune": "CERGY-PONTOISE",
"codePostal": "95017",
"cedex": "CEDEX",
"telephone": "01 34 22 22 22",
"fax": "01 30 32 51 57"
},
{
"id": "01-941-0000",
"codeRegime": "01",
"caisseGestionnaire": "941",
"centreGestionnaire": "0000",
"libelle": "CPAM du Val-de-Marne",
"regime": "Régime Général",
"organismeDestinataire": "941",
"codeCentreInformatique": "004",
"adresse1": "1 à 9, Avenue du Général de Gaulle 94031 CRETEIL CEDEX",
"adresse2": "",
"commune": "CRETEIL",
"codePostal": "94031",
"cedex": "CEDEX",
"telephone": "01 43 99 33 33",
"fax": ""
},
{
"id": "01-831-0000",
"codeRegime": "01",
"caisseGestionnaire": "831",
"centreGestionnaire": "0000",
"libelle": "CPAM du Var",
"regime": "Régime Général",
"organismeDestinataire": "831",
"codeCentreInformatique": "021",
"adresse1": "42 Rue Emile Ollivier",
"adresse2": "HD TSA 99 998",
"commune": "TOULON",
"codePostal": "83082",
"cedex": "CEDEX",
"telephone": "04 94 46 87 00",
"fax": ""
},
{
"id": "01-841-0000",
"codeRegime": "01",
"caisseGestionnaire": "841",
"centreGestionnaire": "0000",
"libelle": "CPAM du Vaucluse",
"regime": "Régime Général",
"organismeDestinataire": "841",
"codeCentreInformatique": "021",
"adresse1": "7, Rue François 1er",
"adresse2": "",
"commune": "AVIGNON",
"codePostal": "84043",
"cedex": "CEDEX 9",
"telephone": "0 811 709 084",
"fax": ""
},
{
"id": "02-771-0000",
"codeRegime": "02",
"caisseGestionnaire": "771",
"centreGestionnaire": "0000",
"libelle": "CPS SAINT BARTHELEMY",
"regime": "Régime Agricole",
"organismeDestinataire": "771",
"codeCentreInformatique": "591",
"adresse1": "13 Rue Lubin Brin",
"adresse2": "",
"commune": "GUSTAVIA",
"codePostal": "97133",
"cedex": "",
"telephone": "0590872210",
"fax": ""
},
{
"id": "02-775-0000",
"codeRegime": "02",
"caisseGestionnaire": "775",
"centreGestionnaire": "0000",
"libelle": "CPS SAINT BARTHELEMY",
"regime": "Régime Agricole",
"organismeDestinataire": "771",
"codeCentreInformatique": "591",
"adresse1": "13 Rue Lubin Brin",
"adresse2": "",
"commune": "GUSTAVIA",
"codePostal": "97133",
"cedex": "",
"telephone": "05 90 87 22 10",
"fax": ""
},
{
"id": "01-602-0000",
"codeRegime": "01",
"caisseGestionnaire": "602",
"centreGestionnaire": "0000",
"libelle": "CREIL",
"regime": "Régime Général",
"organismeDestinataire": "602",
"codeCentreInformatique": "011",
"adresse1": "Rue Ribot",
"adresse2": "BP 201",
"commune": "CREIL",
"codePostal": "60313",
"cedex": "CEDEX",
"telephone": "03 44 61 70 84",
"fax": "03 44 24 34 36"
},
{
"id": "01-976-0000",
"codeRegime": "01",
"caisseGestionnaire": "976",
"centreGestionnaire": "0000",
"libelle": "CSS de Mayotte",
"regime": "Régime Général",
"organismeDestinataire": "976",
"codeCentreInformatique": "007",
"adresse1": "CENTRE KINGA",
"adresse2": "90, route nationale 1 KAWENI - BP 84",
"commune": "MAMOUDZOU",
"codePostal": "97600",
"cedex": "",
"telephone": "0269 61 91 91",
"fax": ""
},
{
"id": "01-761-0000",
"codeRegime": "01",
"caisseGestionnaire": "761",
"centreGestionnaire": "0000",
"libelle": "DIEPPE",
"regime": "Régime Général",
"organismeDestinataire": "761",
"codeCentreInformatique": "001",
"adresse1": "Boulevard Georges Clémenceau",
"adresse2": "",
"commune": "DIEPPE",
"codePostal": "76882",
"cedex": "CEDEX",
"telephone": "02 35 04 78 00",
"fax": ""
},
{
"id": "02-211-0000",
"codeRegime": "02",
"caisseGestionnaire": "211",
"centreGestionnaire": "0000",
"libelle": "DIJON",
"regime": "Régime Agricole",
"organismeDestinataire": "211",
"codeCentreInformatique": "541",
"adresse1": "14. rue Félix-Trutat",
"adresse2": "",
"commune": "DIJON",
"codePostal": "21046",
"cedex": "CEDEX",
"telephone": "03.80.63.22.00",
"fax": "03.80.63.23.23"
},
{
"id": "02-215-0000",
"codeRegime": "02",
"caisseGestionnaire": "215",
"centreGestionnaire": "0000",
"libelle": "DIJON",
"regime": "Régime Agricole",
"organismeDestinataire": "211",
"codeCentreInformatique": "541",
"adresse1": "14. rue Félix-Trutat",
"adresse2": "",
"commune": "DIJON",
"codePostal": "21046",
"cedex": "CEDEX",
"telephone": "03.80.63.22.00",
"fax": "03.80.63.23.23"
},
{
"id": "01-593-0000",
"codeRegime": "01",
"caisseGestionnaire": "593",
"centreGestionnaire": "0000",
"libelle": "DOUAI",
"regime": "Régime Général",
"organismeDestinataire": "593",
"codeCentreInformatique": "011",
"adresse1": "125, Rue Saint Sulpice",
"adresse2": "BP 821",
"commune": "DOUAI",
"codePostal": "59508",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "02-831-0000",
"codeRegime": "02",
"caisseGestionnaire": "831",
"centreGestionnaire": "0000",
"libelle": "DRAGUIGNAN",
"regime": "Régime Agricole",
"organismeDestinataire": "831",
"codeCentreInformatique": "381",
"adresse1": "Rue Jean-Aicard",
"adresse2": "",
"commune": "DRAGUIGNAN",
"codePostal": "83013",
"cedex": "CEDEX",
"telephone": "04.94.60.38.38",
"fax": "04.94.68.47.58"
},
{
"id": "02-835-0000",
"codeRegime": "02",
"caisseGestionnaire": "835",
"centreGestionnaire": "0000",
"libelle": "DRAGUIGNAN",
"regime": "Régime Agricole",
"organismeDestinataire": "831",
"codeCentreInformatique": "381",
"adresse1": "Rue Jean-Aicard",
"adresse2": "",
"commune": "DRAGUIGNAN",
"codePostal": "83013",
"cedex": "CEDEX",
"telephone": "04.94.60.38.38",
"fax": "04.94.68.47.58"
},
{
"id": "01-762-0000",
"codeRegime": "01",
"caisseGestionnaire": "762",
"centreGestionnaire": "0000",
"libelle": "ELBEUF",
"regime": "Régime Général",
"organismeDestinataire": "762",
"codeCentreInformatique": "001",
"adresse1": "Rue de la Prairie",
"adresse2": "BP400",
"commune": "ELBEUF SUR SEINE",
"codePostal": "76504",
"cedex": "CEDEX",
"telephone": "02 32 96 92 69",
"fax": "02 35 81 64 06"
},
{
"id": "06-200-0600",
"codeRegime": "06",
"caisseGestionnaire": "200",
"centreGestionnaire": "0600",
"libelle": "ENIM",
"regime": "Etablissement National des Invalides de la Marine - ENIM",
"organismeDestinataire": "200",
"codeCentreInformatique": "029",
"adresse1": "ARSENAL DE LA MARINE",
"adresse2": "QUAI SOLIDOR",
"commune": "SAINT MALO",
"codePostal": "35415",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "06-200-0200",
"codeRegime": "06",
"caisseGestionnaire": "200",
"centreGestionnaire": "0200",
"libelle": "ENIM - CLP Bordeaux",
"regime": "Etablissement National des Invalides de la Marine - ENIM",
"organismeDestinataire": "200",
"codeCentreInformatique": "029",
"adresse1": "ARSENAL DE LA MARINE",
"adresse2": "QUAI SOLIDOR",
"commune": "SAINT MALO",
"codePostal": "35415",
"cedex": "CEDEX",
"telephone": "0809 54 00 64",
"fax": ""
},
{
"id": "06-200-0800",
"codeRegime": "06",
"caisseGestionnaire": "200",
"centreGestionnaire": "0800",
"libelle": "ENIM - CLP Lorient",
"regime": "Etablissement National des Invalides de la Marine - ENIM",
"organismeDestinataire": "200",
"codeCentreInformatique": "029",
"adresse1": "33 BD COSMAO DUMANOIR",
"adresse2": "CS 87770",
"commune": "LORIENT",
"codePostal": "56327",
"cedex": "CEDEX",
"telephone": "0809 54 00 64",
"fax": ""
},
{
"id": "06-200-0400",
"codeRegime": "06",
"caisseGestionnaire": "200",
"centreGestionnaire": "0400",
"libelle": "ENIM - CLP Saint-Malo",
"regime": "Etablissement National des Invalides de la Marine - ENIM",
"organismeDestinataire": "200",
"codeCentreInformatique": "029",
"adresse1": "ARSENAL DE LA MARINE",
"adresse2": "QUAI SOLIDOR",
"commune": "SAINT MALO",
"codePostal": "35415",
"cedex": "CEDEX",
"telephone": "0809 54 00 64",
"fax": ""
},
{
"id": "02-881-0000",
"codeRegime": "02",
"caisseGestionnaire": "881",
"centreGestionnaire": "0000",
"libelle": "EPINAL",
"regime": "Régime Agricole",
"organismeDestinataire": "881",
"codeCentreInformatique": "541",
"adresse1": "8, av. Général de Gaulle",
"adresse2": "BP 277",
"commune": "EPINAL",
"codePostal": "88017",
"cedex": "CEDEX",
"telephone": "03 29 64 88 00",
"fax": "03 29 82 00 71"
},
{
"id": "02-885-0000",
"codeRegime": "02",
"caisseGestionnaire": "885",
"centreGestionnaire": "0000",
"libelle": "EPINAL",
"regime": "Régime Agricole",
"organismeDestinataire": "881",
"codeCentreInformatique": "541",
"adresse1": "8, av. Général de Gaulle",
"adresse2": "BP 277",
"commune": "EPINAL",
"codePostal": "88017",
"cedex": "CEDEX",
"telephone": "03 29 64 88 00",
"fax": "03 29 82 00 71"
},
{
"id": "02-271-0000",
"codeRegime": "02",
"caisseGestionnaire": "271",
"centreGestionnaire": "0000",
"libelle": "EVREUX",
"regime": "Régime Agricole",
"organismeDestinataire": "271",
"codeCentreInformatique": "591",
"adresse1": "32. rue Politzer",
"adresse2": "",
"commune": "EVREUX",
"codePostal": "27036",
"cedex": "CEDEX",
"telephone": "02.35.12.70.10",
"fax": "02.32.28.00.98"
},
{
"id": "02-275-0000",
"codeRegime": "02",
"caisseGestionnaire": "275",
"centreGestionnaire": "0000",
"libelle": "EVREUX",
"regime": "Régime Agricole",
"organismeDestinataire": "271",
"codeCentreInformatique": "591",
"adresse1": "32. rue Politzer",
"adresse2": "",
"commune": "EVREUX",
"codePostal": "27036",
"cedex": "CEDEX",
"telephone": "02.35.12.70.10",
"fax": "02.32.28.00.98"
},
{
"id": "02-091-0000",
"codeRegime": "02",
"caisseGestionnaire": "091",
"centreGestionnaire": "0000",
"libelle": "FOIX",
"regime": "Régime Agricole",
"organismeDestinataire": "091",
"codeCentreInformatique": "821",
"adresse1": "26. Allées-de-Villote",
"adresse2": "",
"commune": "FOIX",
"codePostal": "09002",
"cedex": "CEDEX",
"telephone": "05.61.65.30.55",
"fax": "05.61.02.66.52"
},
{
"id": "02-095-0000",
"codeRegime": "02",
"caisseGestionnaire": "095",
"centreGestionnaire": "0000",
"libelle": "FOIX",
"regime": "Régime Agricole",
"organismeDestinataire": "091",
"codeCentreInformatique": "821",
"adresse1": "26. Allées-de-Villote",
"adresse2": "",
"commune": "FOIX",
"codePostal": "09002",
"cedex": "CEDEX",
"telephone": "05.61.65.30.55",
"fax": "05.61.02.66.52"
},
{
"id": "14-100-0000",
"codeRegime": "14",
"caisseGestionnaire": "100",
"centreGestionnaire": "0000",
"libelle": "Fonds de Securite Sociale de l Assemblee Nationale",
"regime": "Assemblée Nationale",
"organismeDestinataire": "100",
"codeCentreInformatique": "001",
"adresse1": "126, rue de l'Université",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75355",
"cedex": "CEDEX 07",
"telephone": "01.40.63.86.22",
"fax": "01.40.63.86.92"
},
{
"id": "02-051-0000",
"codeRegime": "02",
"caisseGestionnaire": "051",
"centreGestionnaire": "0000",
"libelle": "GAP",
"regime": "Régime Agricole",
"organismeDestinataire": "051",
"codeCentreInformatique": "301",
"adresse1": "25 B Avenue Commandant Dumont",
"adresse2": "B.P. 79",
"commune": "GAP",
"codePostal": "05015",
"cedex": "CEDEX",
"telephone": "04.92.40.11.00",
"fax": "04.92.51.49.23"
},
{
"id": "02-055-0000",
"codeRegime": "02",
"caisseGestionnaire": "055",
"centreGestionnaire": "0000",
"libelle": "GAP",
"regime": "Régime Agricole",
"organismeDestinataire": "051",
"codeCentreInformatique": "301",
"adresse1": "25 B Avenue Commandant Dumont",
"adresse2": "B.P. 79",
"commune": "GAP",
"codePostal": "05015",
"cedex": "CEDEX",
"telephone": "04.92.40.11.00",
"fax": "04.92.51.49.23"
},
{
"id": "02-381-0000",
"codeRegime": "02",
"caisseGestionnaire": "381",
"centreGestionnaire": "0000",
"libelle": "GRENOBLE",
"regime": "Régime Agricole",
"organismeDestinataire": "381",
"codeCentreInformatique": "381",
"adresse1": "5. place Gustave-Rivet",
"adresse2": "",
"commune": "GRENOBLE",
"codePostal": "38048",
"cedex": "CEDEX",
"telephone": "04.76.88.76.00",
"fax": "04.76.88.76.88"
},
{
"id": "02-385-0000",
"codeRegime": "02",
"caisseGestionnaire": "385",
"centreGestionnaire": "0000",
"libelle": "GRENOBLE",
"regime": "Régime Agricole",
"organismeDestinataire": "381",
"codeCentreInformatique": "381",
"adresse1": "5. place Gustave-Rivet",
"adresse2": "",
"commune": "GRENOBLE",
"codePostal": "38048",
"cedex": "CEDEX",
"telephone": "04.76.88.76.00",
"fax": "04.76.88.76.88"
},
{
"id": "02-231-0000",
"codeRegime": "02",
"caisseGestionnaire": "231",
"centreGestionnaire": "0000",
"libelle": "GUERET",
"regime": "Régime Agricole",
"organismeDestinataire": "231",
"codeCentreInformatique": "821",
"adresse1": "Avenue d'Auvergne",
"adresse2": "B.P. 169",
"commune": "GUERET",
"codePostal": "23011",
"cedex": "CEDEX",
"telephone": "05.55.51.30.00",
"fax": "05.55.51.30.14"
},
{
"id": "02-235-0000",
"codeRegime": "02",
"caisseGestionnaire": "235",
"centreGestionnaire": "0000",
"libelle": "GUERET",
"regime": "Régime Agricole",
"organismeDestinataire": "231",
"codeCentreInformatique": "821",
"adresse1": "Avenue d'Auvergne",
"adresse2": "B.P. 169",
"commune": "GUERET",
"codePostal": "23011",
"cedex": "CEDEX",
"telephone": "05.55.51.30.00",
"fax": "05.55.51.30.14"
},
{
"id": "01-671-0000",
"codeRegime": "01",
"caisseGestionnaire": "671",
"centreGestionnaire": "0000",
"libelle": "HAGUENAU",
"regime": "Régime Général",
"organismeDestinataire": "671",
"codeCentreInformatique": "017",
"adresse1": "17, Rue du Maréchal Joffre",
"adresse2": "",
"commune": "HAGUENAU",
"codePostal": "67505",
"cedex": "CEDEX",
"telephone": "03 88 63 45 00",
"fax": ""
},
{
"id": "02-851-0000",
"codeRegime": "02",
"caisseGestionnaire": "851",
"centreGestionnaire": "0000",
"libelle": "LA ROCHE SUR YON",
"regime": "Régime Agricole",
"organismeDestinataire": "851",
"codeCentreInformatique": "851",
"adresse1": "33. boulevard Réaumur",
"adresse2": "",
"commune": "LA ROCHE-SUR-YON",
"codePostal": "85011",
"cedex": "CEDEX",
"telephone": "02.51.36.88.88",
"fax": "02.51.36.88.55"
},
{
"id": "02-855-0000",
"codeRegime": "02",
"caisseGestionnaire": "855",
"centreGestionnaire": "0000",
"libelle": "LA ROCHE SUR YON",
"regime": "Régime Agricole",
"organismeDestinataire": "851",
"codeCentreInformatique": "851",
"adresse1": "33. boulevard Réaumur",
"adresse2": "",
"commune": "LA ROCHE-SUR-YON",
"codePostal": "85011",
"cedex": "CEDEX",
"telephone": "02.51.36.88.88",
"fax": "02.51.36.88.55"
},
{
"id": "02-291-0000",
"codeRegime": "02",
"caisseGestionnaire": "291",
"centreGestionnaire": "0000",
"libelle": "LANDERNEAU",
"regime": "Régime Agricole",
"organismeDestinataire": "291",
"codeCentreInformatique": "351",
"adresse1": "3. rue Hervé-de-Guébriant",
"adresse2": "",
"commune": "LANDERNEAU",
"codePostal": "29412",
"cedex": "CEDEX",
"telephone": "02.98.85.79.79",
"fax": "02.98.85.79.09"
},
{
"id": "02-295-0000",
"codeRegime": "02",
"caisseGestionnaire": "295",
"centreGestionnaire": "0000",
"libelle": "LANDERNEAU",
"regime": "Régime Agricole",
"organismeDestinataire": "291",
"codeCentreInformatique": "351",
"adresse1": "3. rue Hervé-de-Guébriant",
"adresse2": "",
"commune": "LANDERNEAU",
"codePostal": "29412",
"cedex": "CEDEX",
"telephone": "02.98.85.79.79",
"fax": "02.98.85.79.09"
},
{
"id": "02-021-0000",
"codeRegime": "02",
"caisseGestionnaire": "021",
"centreGestionnaire": "0000",
"libelle": "LAON",
"regime": "Régime Agricole",
"organismeDestinataire": "021",
"codeCentreInformatique": "591",
"adresse1": "rue turgot",
"adresse2": "",
"commune": "LAON",
"codePostal": "02008",
"cedex": "CEDEX 9",
"telephone": "03.23.23.65.00",
"fax": "03.23.79.62.56"
},
{
"id": "02-025-0000",
"codeRegime": "02",
"caisseGestionnaire": "025",
"centreGestionnaire": "0000",
"libelle": "LAON",
"regime": "Régime Agricole",
"organismeDestinataire": "021",
"codeCentreInformatique": "591",
"adresse1": "rue Turgot",
"adresse2": "",
"commune": "LAON",
"codePostal": "02008",
"cedex": "CEDEX 9",
"telephone": "03.23.23.65.00",
"fax": "03.23.79.62.56"
},
{
"id": "02-531-0000",
"codeRegime": "02",
"caisseGestionnaire": "531",
"centreGestionnaire": "0000",
"libelle": "LAVAL",
"regime": "Régime Agricole",
"organismeDestinataire": "531",
"codeCentreInformatique": "351",
"adresse1": "76. boulevard Lucien-Daniel",
"adresse2": "",
"commune": "LAVAL",
"codePostal": "53029",
"cedex": "CEDEX",
"telephone": "02.43.91.41.41",
"fax": "02.43.91.16.14"
},
{
"id": "02-535-0000",
"codeRegime": "02",
"caisseGestionnaire": "535",
"centreGestionnaire": "0000",
"libelle": "LAVAL",
"regime": "Régime Agricole",
"organismeDestinataire": "531",
"codeCentreInformatique": "351",
"adresse1": "76. boulevard Lucien-Daniel",
"adresse2": "",
"commune": "LAVAL",
"codePostal": "53029",
"cedex": "CEDEX",
"telephone": "02.43.91.41.41",
"fax": "02.43.91.16.14"
},
{
"id": "02-721-0000",
"codeRegime": "02",
"caisseGestionnaire": "721",
"centreGestionnaire": "0000",
"libelle": "LE MANS",
"regime": "Régime Agricole",
"organismeDestinataire": "721",
"codeCentreInformatique": "351",
"adresse1": "30. rue Paul Ligneul",
"adresse2": "",
"commune": "LE MANS",
"codePostal": "72032",
"cedex": "CEDEX",
"telephone": "02.43.39.43.39",
"fax": "02.43.39.43.43"
},
{
"id": "02-725-0000",
"codeRegime": "02",
"caisseGestionnaire": "725",
"centreGestionnaire": "0000",
"libelle": "LE MANS",
"regime": "Régime Agricole",
"organismeDestinataire": "721",
"codeCentreInformatique": "351",
"adresse1": "30. rue Paul Ligneul",
"adresse2": "",
"commune": "LE MANS",
"codePostal": "72032",
"cedex": "CEDEX",
"telephone": "02.43.39.43.39",
"fax": "02.43.39.43.43"
},
{
"id": "02-431-0000",
"codeRegime": "02",
"caisseGestionnaire": "431",
"centreGestionnaire": "0000",
"libelle": "LE PUY",
"regime": "Régime Agricole",
"organismeDestinataire": "431",
"codeCentreInformatique": "381",
"adresse1": "16, rue Jean Claret",
"adresse2": "",
"commune": "CLERMONT-FERRAND",
"codePostal": "63972",
"cedex": "CEDEX 9",
"telephone": "04.71.64.66.46",
"fax": "04.70.35.35.34"
},
{
"id": "02-435-0000",
"codeRegime": "02",
"caisseGestionnaire": "435",
"centreGestionnaire": "0000",
"libelle": "LE PUY",
"regime": "Régime Agricole",
"organismeDestinataire": "431",
"codeCentreInformatique": "381",
"adresse1": "16, rue Jean Claret",
"adresse2": "",
"commune": "CLERMONT-FERRAND",
"codePostal": "63972",
"cedex": "CEDEX 9",
"telephone": "04.71.64.66.46",
"fax": "04.70.35.35.34"
},
{
"id": "02-591-0000",
"codeRegime": "02",
"caisseGestionnaire": "591",
"centreGestionnaire": "0000",
"libelle": "LILLE",
"regime": "Régime Agricole",
"organismeDestinataire": "591",
"codeCentreInformatique": "591",
"adresse1": "",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59716",
"cedex": "CEDEX 9",
"telephone": "03.20.00.21.99",
"fax": "03.20.00.20.13"
},
{
"id": "02-595-0000",
"codeRegime": "02",
"caisseGestionnaire": "595",
"centreGestionnaire": "0000",
"libelle": "LILLE",
"regime": "Régime Agricole",
"organismeDestinataire": "591",
"codeCentreInformatique": "591",
"adresse1": "",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59716",
"cedex": "CEDEX 9",
"telephone": "03.20.00.21.99",
"fax": "03.20.00.20.13"
},
{
"id": "02-871-0000",
"codeRegime": "02",
"caisseGestionnaire": "871",
"centreGestionnaire": "0000",
"libelle": "LIMOGES",
"regime": "Régime Agricole",
"organismeDestinataire": "871",
"codeCentreInformatique": "821",
"adresse1": "Impasse Sainte-Claire",
"adresse2": "",
"commune": "LIMOGES",
"codePostal": "87041",
"cedex": "CEDEX",
"telephone": "05.55.44.87.00",
"fax": "05.55.44.88.89"
},
{
"id": "02-875-0000",
"codeRegime": "02",
"caisseGestionnaire": "875",
"centreGestionnaire": "0000",
"libelle": "LIMOGES",
"regime": "Régime Agricole",
"organismeDestinataire": "871",
"codeCentreInformatique": "821",
"adresse1": "Impasse Sainte-Claire",
"adresse2": "",
"commune": "LIMOGES",
"codePostal": "87041",
"cedex": "CEDEX",
"telephone": "05.55.44.87.00",
"fax": "05.55.44.88.89"
},
{
"id": "01-541-0000",
"codeRegime": "01",
"caisseGestionnaire": "541",
"centreGestionnaire": "0000",
"libelle": "LONGWY",
"regime": "Régime Général",
"organismeDestinataire": "541",
"codeCentreInformatique": "013",
"adresse1": "3, boulevard Joffre",
"adresse2": "",
"commune": "NANCY",
"codePostal": "54047",
"cedex": "CEDEX",
"telephone": "03 83 85 50 00",
"fax": "03 83 32 27 19"
},
{
"id": "02-391-0000",
"codeRegime": "02",
"caisseGestionnaire": "391",
"centreGestionnaire": "0000",
"libelle": "LONS LE SAUNIER",
"regime": "Régime Agricole",
"organismeDestinataire": "391",
"codeCentreInformatique": "541",
"adresse1": "13 Avenue Elisée Cusenier",
"adresse2": "",
"commune": "BESANCON",
"codePostal": "25090",
"cedex": "CEDEX 9",
"telephone": "03.81.65.60.60",
"fax": "03.81.65.60.09"
},
{
"id": "02-395-0000",
"codeRegime": "02",
"caisseGestionnaire": "395",
"centreGestionnaire": "0000",
"libelle": "LONS LE SAUNIER",
"regime": "Régime Agricole",
"organismeDestinataire": "391",
"codeCentreInformatique": "541",
"adresse1": "10. rue des Perrières",
"adresse2": "B.P. 416",
"commune": "LONS-LE-SAUNIER",
"codePostal": "39016",
"cedex": "CEDEX",
"telephone": "03.84.35.25.25",
"fax": "03.84.35.25.22"
},
{
"id": "02-691-0000",
"codeRegime": "02",
"caisseGestionnaire": "691",
"centreGestionnaire": "0000",
"libelle": "LYON",
"regime": "Régime Agricole",
"organismeDestinataire": "691",
"codeCentreInformatique": "381",
"adresse1": "35. rue du Plat",
"adresse2": "B.P. 2612",
"commune": "LYON",
"codePostal": "69232",
"cedex": "CEDEX 02",
"telephone": "04 74 45 99 00",
"fax": "04 74 45 98 98"
},
{
"id": "02-695-0000",
"codeRegime": "02",
"caisseGestionnaire": "695",
"centreGestionnaire": "0000",
"libelle": "LYON",
"regime": "Régime Agricole",
"organismeDestinataire": "691",
"codeCentreInformatique": "381",
"adresse1": "35. rue du Plat",
"adresse2": "B.P. 2612",
"commune": "LYON",
"codePostal": "69232",
"cedex": "CEDEX 02",
"telephone": "04 74 45 99 00",
"fax": "04 74 45 98 98"
},
{
"id": "02-711-0000",
"codeRegime": "02",
"caisseGestionnaire": "711",
"centreGestionnaire": "0000",
"libelle": "MACON",
"regime": "Régime Agricole",
"organismeDestinataire": "711",
"codeCentreInformatique": "381",
"adresse1": "46. rue de Paris",
"adresse2": "",
"commune": "MACON",
"codePostal": "71023",
"cedex": "CEDEX",
"telephone": "03.85.39.51.51",
"fax": "03.85.39.51.80"
},
{
"id": "02-715-0000",
"codeRegime": "02",
"caisseGestionnaire": "715",
"centreGestionnaire": "0000",
"libelle": "MACON",
"regime": "Régime Agricole",
"organismeDestinataire": "711",
"codeCentreInformatique": "381",
"adresse1": "46. rue de Paris",
"adresse2": "",
"commune": "MACON",
"codePostal": "71023",
"cedex": "CEDEX",
"telephone": "03.85.39.51.51",
"fax": "03.85.39.51.80"
},
{
"id": "02-131-0000",
"codeRegime": "02",
"caisseGestionnaire": "131",
"centreGestionnaire": "0000",
"libelle": "MARSEILLE",
"regime": "Régime Agricole",
"organismeDestinataire": "131",
"codeCentreInformatique": "131",
"adresse1": "152, avenue de Hambourg",
"adresse2": "",
"commune": "MARSEILLE",
"codePostal": "13416",
"cedex": "CEDEX 08",
"telephone": "04.91.16.58.58",
"fax": "04.91.72.28.01"
},
{
"id": "02-135-0000",
"codeRegime": "02",
"caisseGestionnaire": "135",
"centreGestionnaire": "0000",
"libelle": "MARSEILLE",
"regime": "Régime Agricole",
"organismeDestinataire": "131",
"codeCentreInformatique": "131",
"adresse1": "152, avenue de Hambourg",
"adresse2": "",
"commune": "MARSEILLE",
"codePostal": "13416",
"cedex": "CEDEX 08",
"telephone": "04.91.16.58.58",
"fax": "04.91.72.28.01"
},
{
"id": "01-596-0000",
"codeRegime": "01",
"caisseGestionnaire": "596",
"centreGestionnaire": "0000",
"libelle": "MAUBEUGE",
"regime": "Régime Général",
"organismeDestinataire": "596",
"codeCentreInformatique": "011",
"adresse1": "24 rue de la Croix",
"adresse2": "BP 78",
"commune": "MAUBEUGE",
"codePostal": "59607",
"cedex": "CEDEX",
"telephone": "03 27 69 52 52",
"fax": ""
},
{
"id": "02-481-0000",
"codeRegime": "02",
"caisseGestionnaire": "481",
"centreGestionnaire": "0000",
"libelle": "MENDE",
"regime": "Régime Agricole",
"organismeDestinataire": "481",
"codeCentreInformatique": "301",
"adresse1": "10. cité des Carmes",
"adresse2": "",
"commune": "MENDE",
"codePostal": "48005",
"cedex": "CEDEX",
"telephone": "04.66.49.79.20",
"fax": "04.66.49.79.59"
},
{
"id": "02-485-0000",
"codeRegime": "02",
"caisseGestionnaire": "485",
"centreGestionnaire": "0000",
"libelle": "MENDE",
"regime": "Régime Agricole",
"organismeDestinataire": "481",
"codeCentreInformatique": "301",
"adresse1": "10. cité des Carmes",
"adresse2": "",
"commune": "MENDE",
"codePostal": "48005",
"cedex": "CEDEX",
"telephone": "04.66.49.79.20",
"fax": "04.66.49.79.59"
},
{
"id": "02-571-0000",
"codeRegime": "02",
"caisseGestionnaire": "571",
"centreGestionnaire": "0000",
"libelle": "METZ",
"regime": "Régime Agricole",
"organismeDestinataire": "571",
"codeCentreInformatique": "541",
"adresse1": "17. avenue André Malraux",
"adresse2": "",
"commune": "METZ",
"codePostal": "57778",
"cedex": "CEDEX 09",
"telephone": "03.87.55.76.41",
"fax": "03.87.55.76.97"
},
{
"id": "02-575-0000",
"codeRegime": "02",
"caisseGestionnaire": "575",
"centreGestionnaire": "0000",
"libelle": "METZ",
"regime": "Régime Agricole",
"organismeDestinataire": "571",
"codeCentreInformatique": "541",
"adresse1": "17. avenue André Malraux",
"adresse2": "",
"commune": "METZ",
"codePostal": "57778",
"cedex": "CEDEX 09",
"telephone": "03.87.55.76.41",
"fax": "03.87.55.76.97"
},
{
"id": "91-919-5010",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5010",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5020",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5020",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5030",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5030",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5040",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5040",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5050",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5050",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5060",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5060",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5070",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5070",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5080",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5080",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5090",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5090",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5130",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5130",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5140",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5140",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5160",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5160",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5170",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5170",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5180",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5180",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5210",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5210",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5220",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5220",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-919-5250",
"codeRegime": "91",
"caisseGestionnaire": "919",
"centreGestionnaire": "5250",
"libelle": "MGEN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "919",
"codeCentreInformatique": "076",
"adresse1": "TSA 81514",
"adresse2": "",
"commune": "MAYENNE",
"codePostal": "53106",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-011-0506",
"codeRegime": "91",
"caisseGestionnaire": "011",
"centreGestionnaire": "0506",
"libelle": "MGEN AIN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "011",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE  CEDEX",
"codePostal": "69601",
"cedex": "Cedex",
"telephone": "0 820 212 312",
"fax": ""
},
{
"id": "91-021-0506",
"codeRegime": "91",
"caisseGestionnaire": "021",
"centreGestionnaire": "0506",
"libelle": "MGEN AISNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "021",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "Cedex",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-031-0506",
"codeRegime": "91",
"caisseGestionnaire": "031",
"centreGestionnaire": "0506",
"libelle": "MGEN ALLIER",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "031",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-041-0506",
"codeRegime": "91",
"caisseGestionnaire": "041",
"centreGestionnaire": "0506",
"libelle": "MGEN ALPES DE HAUTE PROVENCE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "041",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Marseille MGEN",
"adresse2": "",
"commune": "MARSEILLE",
"codePostal": "13411",
"cedex": "CEDEX 20",
"telephone": "0 820 212 312",
"fax": ""
},
{
"id": "91-061-0506",
"codeRegime": "91",
"caisseGestionnaire": "061",
"centreGestionnaire": "0506",
"libelle": "MGEN ALPES MARITIMES",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "061",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Marseille MGEN",
"adresse2": "",
"commune": "MARSEILLE",
"codePostal": "13411",
"cedex": "CEDEX 20",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-072-0506",
"codeRegime": "91",
"caisseGestionnaire": "072",
"centreGestionnaire": "0506",
"libelle": "MGEN ARDECHE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "072",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-081-0506",
"codeRegime": "91",
"caisseGestionnaire": "081",
"centreGestionnaire": "0506",
"libelle": "MGEN ARDENNES",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "081",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE CEDEX",
"codePostal": "59871",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-091-0506",
"codeRegime": "91",
"caisseGestionnaire": "091",
"centreGestionnaire": "0506",
"libelle": "MGEN ARIEGE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "091",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "CEDEX 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-101-0506",
"codeRegime": "91",
"caisseGestionnaire": "101",
"centreGestionnaire": "0506",
"libelle": "MGEN AUBE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "101",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE CEDEX",
"codePostal": "59871",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-111-0506",
"codeRegime": "91",
"caisseGestionnaire": "111",
"centreGestionnaire": "0506",
"libelle": "MGEN AUDE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "111",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "CEDEX 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-121-0506",
"codeRegime": "91",
"caisseGestionnaire": "121",
"centreGestionnaire": "0506",
"libelle": "MGEN AVEYRON",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "121",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "CEDEX 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-673-0506",
"codeRegime": "91",
"caisseGestionnaire": "673",
"centreGestionnaire": "0506",
"libelle": "MGEN BAS RHIN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "673",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Paris MGEN",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75952",
"cedex": "CEDEX 19",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-131-0506",
"codeRegime": "91",
"caisseGestionnaire": "131",
"centreGestionnaire": "0506",
"libelle": "MGEN BOUCHES DU RHONE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "131",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Marseille MGEN",
"adresse2": "",
"commune": "MARSEILLE",
"codePostal": "13411",
"cedex": "CEDEX 20",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-141-0506",
"codeRegime": "91",
"caisseGestionnaire": "141",
"centreGestionnaire": "0506",
"libelle": "MGEN CALVADOS",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "141",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière MGEN",
"adresse2": "6B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-151-0506",
"codeRegime": "91",
"caisseGestionnaire": "151",
"centreGestionnaire": "0506",
"libelle": "MGEN CANTAL",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "151",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-161-0506",
"codeRegime": "91",
"caisseGestionnaire": "161",
"centreGestionnaire": "0506",
"libelle": "MGEN CHARENTE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "161",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX CEDEX",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-171-0506",
"codeRegime": "91",
"caisseGestionnaire": "171",
"centreGestionnaire": "0506",
"libelle": "MGEN CHARENTE MARITIME",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "171",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX Cedex",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-181-0506",
"codeRegime": "91",
"caisseGestionnaire": "181",
"centreGestionnaire": "0506",
"libelle": "MGEN CHER",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "181",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière - MGEN",
"adresse2": "6 B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-191-0506",
"codeRegime": "91",
"caisseGestionnaire": "191",
"centreGestionnaire": "0506",
"libelle": "MGEN CORREZE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "191",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX CEDEX",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-201-0506",
"codeRegime": "91",
"caisseGestionnaire": "201",
"centreGestionnaire": "0506",
"libelle": "MGEN CORSE DU SUD",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "201",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Marseille MGEN",
"adresse2": "",
"commune": "MARSEILLE",
"codePostal": "13411",
"cedex": "Cedex 20",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-211-0506",
"codeRegime": "91",
"caisseGestionnaire": "211",
"centreGestionnaire": "0506",
"libelle": "MGEN COTE D OR",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "211",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-221-0506",
"codeRegime": "91",
"caisseGestionnaire": "221",
"centreGestionnaire": "0506",
"libelle": "MGEN COTES D ARMOR",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "221",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Rennes MGEN",
"adresse2": "",
"commune": "RENNES",
"codePostal": "35035",
"cedex": "CEDEX 9",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-231-0506",
"codeRegime": "91",
"caisseGestionnaire": "231",
"centreGestionnaire": "0506",
"libelle": "MGEN CREUSE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "231",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX Cedex",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-791-0506",
"codeRegime": "91",
"caisseGestionnaire": "791",
"centreGestionnaire": "0506",
"libelle": "MGEN DEUX SEVRES",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "791",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX CEDEX",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-241-0506",
"codeRegime": "91",
"caisseGestionnaire": "241",
"centreGestionnaire": "0506",
"libelle": "MGEN DORDOGNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "241",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX CEDEX",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-251-0506",
"codeRegime": "91",
"caisseGestionnaire": "251",
"centreGestionnaire": "0506",
"libelle": "MGEN DOUBS",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "251",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-261-0506",
"codeRegime": "91",
"caisseGestionnaire": "261",
"centreGestionnaire": "0506",
"libelle": "MGEN DROME",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "261",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-911-0506",
"codeRegime": "91",
"caisseGestionnaire": "911",
"centreGestionnaire": "0506",
"libelle": "MGEN ESSONNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "911",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Paris MGEN",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75952",
"cedex": "Cedex 19",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-271-0506",
"codeRegime": "91",
"caisseGestionnaire": "271",
"centreGestionnaire": "0506",
"libelle": "MGEN EURE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "271",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière",
"adresse2": "6 B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-281-0506",
"codeRegime": "91",
"caisseGestionnaire": "281",
"centreGestionnaire": "0506",
"libelle": "MGEN EURE ET LOIR",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "281",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière",
"adresse2": "6 B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-291-0506",
"codeRegime": "91",
"caisseGestionnaire": "291",
"centreGestionnaire": "0506",
"libelle": "MGEN FINISTERE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "291",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Rennes MGEN",
"adresse2": "",
"commune": "RENNES",
"codePostal": "35035",
"cedex": "CEDEX 9",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-301-0506",
"codeRegime": "91",
"caisseGestionnaire": "301",
"centreGestionnaire": "0506",
"libelle": "MGEN GARD",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "301",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-321-0506",
"codeRegime": "91",
"caisseGestionnaire": "321",
"centreGestionnaire": "0506",
"libelle": "MGEN GERS",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "321",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "CEDEX 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-331-0506",
"codeRegime": "91",
"caisseGestionnaire": "331",
"centreGestionnaire": "0506",
"libelle": "MGEN GIRONDE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "331",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX CEDEX",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-971-0506",
"codeRegime": "91",
"caisseGestionnaire": "971",
"centreGestionnaire": "0506",
"libelle": "MGEN GUADELOUPE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "971",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion du Mans MGEN",
"adresse2": "12 rue Ferdinand Lesseps CS 54701",
"commune": "LE MANS",
"codePostal": "72047",
"cedex": "Cedex 2 FRANCE",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-973-0506",
"codeRegime": "91",
"caisseGestionnaire": "973",
"centreGestionnaire": "0506",
"libelle": "MGEN GUYANE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "973",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion du Mans MGEN",
"adresse2": "12 rue Ferdinand de LessepsCS 54701",
"commune": "LE MANS",
"codePostal": "72047",
"cedex": "Cedex 2  FRANCE",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-682-0506",
"codeRegime": "91",
"caisseGestionnaire": "682",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUT RHIN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "682",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Paris MGEN",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75952",
"cedex": "Cedex 19",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-202-0506",
"codeRegime": "91",
"caisseGestionnaire": "202",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUTE CORSE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "202",
"codeCentreInformatique": "007",
"adresse1": "Centre Gestion de Marseille MGEN",
"adresse2": "",
"commune": "MARSEILLE",
"codePostal": "13411",
"cedex": "Cedex 20",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-311-0506",
"codeRegime": "91",
"caisseGestionnaire": "311",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUTE GARONNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "311",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-431-0506",
"codeRegime": "91",
"caisseGestionnaire": "431",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUTE LOIRE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "431",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-521-0506",
"codeRegime": "91",
"caisseGestionnaire": "521",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUTE MARNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "521",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-701-0506",
"codeRegime": "91",
"caisseGestionnaire": "701",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUTE SAONE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "701",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-741-0506",
"codeRegime": "91",
"caisseGestionnaire": "741",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUTE SAVOIE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "741",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-871-0506",
"codeRegime": "91",
"caisseGestionnaire": "871",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUTE VIENNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "871",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX CEDEX",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-051-0506",
"codeRegime": "91",
"caisseGestionnaire": "051",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUTES ALPES",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "051",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Marseille MGEN",
"adresse2": "",
"commune": "MARSEILLE",
"codePostal": "13411",
"cedex": "CEDEX 20",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-651-0506",
"codeRegime": "91",
"caisseGestionnaire": "651",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUTES PYRENEES",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "651",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-921-0506",
"codeRegime": "91",
"caisseGestionnaire": "921",
"centreGestionnaire": "0506",
"libelle": "MGEN HAUTS DE SEINE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "921",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Paris MGEN",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75952",
"cedex": "Cedex 19",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-342-0506",
"codeRegime": "91",
"caisseGestionnaire": "342",
"centreGestionnaire": "0506",
"libelle": "MGEN HERAULT",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "342",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "CEDEX 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-351-0506",
"codeRegime": "91",
"caisseGestionnaire": "351",
"centreGestionnaire": "0506",
"libelle": "MGEN ILLE ET VILAINE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "351",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Rennes MGEN",
"adresse2": "",
"commune": "RENNES",
"codePostal": "35035",
"cedex": "CEDEX 9",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-361-0506",
"codeRegime": "91",
"caisseGestionnaire": "361",
"centreGestionnaire": "0506",
"libelle": "MGEN INDRE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "361",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière",
"adresse2": "6B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-371-0506",
"codeRegime": "91",
"caisseGestionnaire": "371",
"centreGestionnaire": "0506",
"libelle": "MGEN INDRE ET LOIRE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "371",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière MGEN",
"adresse2": "6 B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-381-0506",
"codeRegime": "91",
"caisseGestionnaire": "381",
"centreGestionnaire": "0506",
"libelle": "MGEN ISERE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "381",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-391-0506",
"codeRegime": "91",
"caisseGestionnaire": "391",
"centreGestionnaire": "0506",
"libelle": "MGEN JURA",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "391",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-401-0506",
"codeRegime": "91",
"caisseGestionnaire": "401",
"centreGestionnaire": "0506",
"libelle": "MGEN LANDES",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "401",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX CEDEX",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-411-0506",
"codeRegime": "91",
"caisseGestionnaire": "411",
"centreGestionnaire": "0506",
"libelle": "MGEN LOIR ET CHER",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "411",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière MGEN",
"adresse2": "6B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-422-0506",
"codeRegime": "91",
"caisseGestionnaire": "422",
"centreGestionnaire": "0506",
"libelle": "MGEN LOIRE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "422",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-441-0506",
"codeRegime": "91",
"caisseGestionnaire": "441",
"centreGestionnaire": "0506",
"libelle": "MGEN LOIRE ATLANTIQUE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "441",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Rennes MGEN",
"adresse2": "",
"commune": "RENNES",
"codePostal": "35035",
"cedex": "CEDEX 9",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-451-0506",
"codeRegime": "91",
"caisseGestionnaire": "451",
"centreGestionnaire": "0506",
"libelle": "MGEN LOIRET",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "451",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière MGEN",
"adresse2": "6 B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-461-0506",
"codeRegime": "91",
"caisseGestionnaire": "461",
"centreGestionnaire": "0506",
"libelle": "MGEN LOT",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "461",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-471-0506",
"codeRegime": "91",
"caisseGestionnaire": "471",
"centreGestionnaire": "0506",
"libelle": "MGEN LOT ET GARONNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "471",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX Cedex",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-481-0506",
"codeRegime": "91",
"caisseGestionnaire": "481",
"centreGestionnaire": "0506",
"libelle": "MGEN LOZERE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "481",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-491-0506",
"codeRegime": "91",
"caisseGestionnaire": "491",
"centreGestionnaire": "0506",
"libelle": "MGEN MAINE ET LOIRE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "491",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Rennes MGEN",
"adresse2": "",
"commune": "RENNES",
"codePostal": "35035",
"cedex": "Cedex 9",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-501-0506",
"codeRegime": "91",
"caisseGestionnaire": "501",
"centreGestionnaire": "0506",
"libelle": "MGEN MANCHE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "501",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière MGEN",
"adresse2": "6B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-511-0506",
"codeRegime": "91",
"caisseGestionnaire": "511",
"centreGestionnaire": "0506",
"libelle": "MGEN MARNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "511",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-972-0506",
"codeRegime": "91",
"caisseGestionnaire": "972",
"centreGestionnaire": "0506",
"libelle": "MGEN MARTINIQUE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "972",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion du Mans MGEN",
"adresse2": "12 rue Ferdinand de Lesseps CS 54701",
"commune": "LE MANS",
"codePostal": "72047",
"cedex": "Cedex 2 FRANCE",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-531-0506",
"codeRegime": "91",
"caisseGestionnaire": "531",
"centreGestionnaire": "0506",
"libelle": "MGEN MAYENNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "531",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Rennes MGEN",
"adresse2": "",
"commune": "RENNES",
"codePostal": "35035",
"cedex": "Cedex 9",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-542-0506",
"codeRegime": "91",
"caisseGestionnaire": "542",
"centreGestionnaire": "0506",
"libelle": "MGEN MEURTHE ET MOSELLE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "542",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-551-0506",
"codeRegime": "91",
"caisseGestionnaire": "551",
"centreGestionnaire": "0506",
"libelle": "MGEN MEUSE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "551",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-976-0501",
"codeRegime": "91",
"caisseGestionnaire": "976",
"centreGestionnaire": "0501",
"libelle": "MGEN MFP MAYOTTE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "976",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion du Mans MGEN",
"adresse2": "12 rue Ferdinand de Lesseps CS 54701",
"commune": "LE MANS",
"codePostal": "72047",
"cedex": "CEDEX 2 FRANCE",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-561-0506",
"codeRegime": "91",
"caisseGestionnaire": "561",
"centreGestionnaire": "0506",
"libelle": "MGEN MORBIHAN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "561",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Rennes MGEN",
"adresse2": "",
"commune": "RENNES",
"codePostal": "35035",
"cedex": "Cedex 9",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-571-0506",
"codeRegime": "91",
"caisseGestionnaire": "571",
"centreGestionnaire": "0506",
"libelle": "MGEN MOSELLE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "571",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Paris MGEN",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75952",
"cedex": "Cedex 19",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-581-0506",
"codeRegime": "91",
"caisseGestionnaire": "581",
"centreGestionnaire": "0506",
"libelle": "MGEN NIEVRE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "581",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-594-0506",
"codeRegime": "91",
"caisseGestionnaire": "594",
"centreGestionnaire": "0506",
"libelle": "MGEN NORD 1",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "594",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-595-0506",
"codeRegime": "91",
"caisseGestionnaire": "595",
"centreGestionnaire": "0506",
"libelle": "MGEN NORD 2",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "595",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-597-0506",
"codeRegime": "91",
"caisseGestionnaire": "597",
"centreGestionnaire": "0506",
"libelle": "MGEN NORD 3",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "597",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "Cedex",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-599-0506",
"codeRegime": "91",
"caisseGestionnaire": "599",
"centreGestionnaire": "0506",
"libelle": "MGEN NORD 4",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "599",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "Cedex",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-601-0506",
"codeRegime": "91",
"caisseGestionnaire": "601",
"centreGestionnaire": "0506",
"libelle": "MGEN OISE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "601",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "Cedex",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-611-0506",
"codeRegime": "91",
"caisseGestionnaire": "611",
"centreGestionnaire": "0506",
"libelle": "MGEN ORNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "611",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière MGEN",
"adresse2": "6 B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-751-0506",
"codeRegime": "91",
"caisseGestionnaire": "751",
"centreGestionnaire": "0506",
"libelle": "MGEN PARIS",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "751",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Paris MGEN",
"adresse2": "",
"commune": "Paris",
"codePostal": "75952",
"cedex": "CEDEX 19",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-623-0506",
"codeRegime": "91",
"caisseGestionnaire": "623",
"centreGestionnaire": "0506",
"libelle": "MGEN PAS DE CALAIS 1",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "623",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "CEDEX",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-624-0506",
"codeRegime": "91",
"caisseGestionnaire": "624",
"centreGestionnaire": "0506",
"libelle": "MGEN PAS DE CALAIS 2",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "624",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "Cedex",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-631-0506",
"codeRegime": "91",
"caisseGestionnaire": "631",
"centreGestionnaire": "0506",
"libelle": "MGEN PUY DE DOME",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "631",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-641-0506",
"codeRegime": "91",
"caisseGestionnaire": "641",
"centreGestionnaire": "0506",
"libelle": "MGEN PYRENEES ATLANTIQUES 1",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "641",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX CEDEX",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-642-0506",
"codeRegime": "91",
"caisseGestionnaire": "642",
"centreGestionnaire": "0506",
"libelle": "MGEN PYRENEES ATLANTIQUES 2",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "642",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX CEDEX",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-661-0506",
"codeRegime": "91",
"caisseGestionnaire": "661",
"centreGestionnaire": "0506",
"libelle": "MGEN PYRENEES ORIENTALES",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "661",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-974-0506",
"codeRegime": "91",
"caisseGestionnaire": "974",
"centreGestionnaire": "0506",
"libelle": "MGEN REUNION",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "974",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion du Mans MGEN",
"adresse2": "12 rue Ferdinand de Lesseps CS 54701",
"commune": "LE MANS",
"codePostal": "72047",
"cedex": "Cedex 2 FRANCE",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-691-0506",
"codeRegime": "91",
"caisseGestionnaire": "691",
"centreGestionnaire": "0506",
"libelle": "MGEN RHONE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "691",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-751-0501",
"codeRegime": "91",
"caisseGestionnaire": "751",
"centreGestionnaire": "0501",
"libelle": "MGEN S.E.M. (Etranger)",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "999",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion du Mans MGEN",
"adresse2": "12 rue Ferdinand de Lesseps CS 54701",
"commune": "LE MANS",
"codePostal": "72047",
"cedex": "Cedex 2 FRANCE",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-711-0506",
"codeRegime": "91",
"caisseGestionnaire": "711",
"centreGestionnaire": "0506",
"libelle": "MGEN SAONE ET LOIRE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "711",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-721-0506",
"codeRegime": "91",
"caisseGestionnaire": "721",
"centreGestionnaire": "0506",
"libelle": "MGEN SARTHE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "721",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Rennes MGEN",
"adresse2": "",
"commune": "RENNES",
"codePostal": "35035",
"cedex": "Cedex 9",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-731-0506",
"codeRegime": "91",
"caisseGestionnaire": "731",
"centreGestionnaire": "0506",
"libelle": "MGEN SAVOIE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "731",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lyon MGEN",
"adresse2": "BP 5062",
"commune": "VILLEURBANNE CEDEX",
"codePostal": "69601",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-771-0506",
"codeRegime": "91",
"caisseGestionnaire": "771",
"centreGestionnaire": "0506",
"libelle": "MGEN SEINE ET MARNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "771",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Paris MGEN",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75952",
"cedex": "Cedex 19",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-763-0506",
"codeRegime": "91",
"caisseGestionnaire": "763",
"centreGestionnaire": "0506",
"libelle": "MGEN SEINE MARITIME 1",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "763",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière MGEN",
"adresse2": "6B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-764-0506",
"codeRegime": "91",
"caisseGestionnaire": "764",
"centreGestionnaire": "0506",
"libelle": "MGEN SEINE MARITIME 2",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "764",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière MGEN",
"adresse2": "6B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-931-0506",
"codeRegime": "91",
"caisseGestionnaire": "931",
"centreGestionnaire": "0506",
"libelle": "MGEN SEINE SAINT DENIS",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "931",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Paris MGEN",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75952",
"cedex": "Cedex 19",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-801-0506",
"codeRegime": "91",
"caisseGestionnaire": "801",
"centreGestionnaire": "0506",
"libelle": "MGEN SOMME",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "801",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "Cedex",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-811-0506",
"codeRegime": "91",
"caisseGestionnaire": "811",
"centreGestionnaire": "0506",
"libelle": "MGEN TARN",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "811",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-821-0506",
"codeRegime": "91",
"caisseGestionnaire": "821",
"centreGestionnaire": "0506",
"libelle": "MGEN TARN ET GARONNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "821",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-901-0506",
"codeRegime": "91",
"caisseGestionnaire": "901",
"centreGestionnaire": "0506",
"libelle": "MGEN TERRITOIRE DE BELFORT",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "901",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-951-0506",
"codeRegime": "91",
"caisseGestionnaire": "951",
"centreGestionnaire": "0506",
"libelle": "MGEN VAL D OISE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "951",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Paris MGEN",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75952",
"cedex": "CEDEX 19",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-941-0506",
"codeRegime": "91",
"caisseGestionnaire": "941",
"centreGestionnaire": "0506",
"libelle": "MGEN VAL DE MARNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "941",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Paris MGEN",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75952",
"cedex": "CEDEX 19",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-831-0506",
"codeRegime": "91",
"caisseGestionnaire": "831",
"centreGestionnaire": "0506",
"libelle": "MGEN VAR",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "831",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Marseille MGEN",
"adresse2": "",
"commune": "MARSEILLE",
"codePostal": "13411",
"cedex": "CEDEX 20",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-841-0506",
"codeRegime": "91",
"caisseGestionnaire": "841",
"centreGestionnaire": "0506",
"libelle": "MGEN VAUCLUSE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "841",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Marseille MGEN",
"adresse2": "",
"commune": "MARSEILLE",
"codePostal": "13411",
"cedex": "CEDEX 20",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-851-0506",
"codeRegime": "91",
"caisseGestionnaire": "851",
"centreGestionnaire": "0506",
"libelle": "MGEN VENDEE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "851",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Rennes MGEN",
"adresse2": "",
"commune": "RENNES",
"codePostal": "35035",
"cedex": "Cedex 9",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-861-0506",
"codeRegime": "91",
"caisseGestionnaire": "861",
"centreGestionnaire": "0506",
"libelle": "MGEN VIENNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "861",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Bordeaux MGEN",
"adresse2": "114 rue Malbec",
"commune": "BORDEAUX CEDEX",
"codePostal": "33080",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-881-0506",
"codeRegime": "91",
"caisseGestionnaire": "881",
"centreGestionnaire": "0506",
"libelle": "MGEN VOSGES",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "881",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Lille MGEN",
"adresse2": "BP 30018",
"commune": "SAINT ANDRE",
"codePostal": "59871",
"cedex": "Cedex",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-891-0506",
"codeRegime": "91",
"caisseGestionnaire": "891",
"centreGestionnaire": "0506",
"libelle": "MGEN YONNE",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "891",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de Montpellier MGEN",
"adresse2": "CS 26001",
"commune": "MONTPELLIER",
"codePostal": "34060",
"cedex": "Cedex 2",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "91-781-0506",
"codeRegime": "91",
"caisseGestionnaire": "781",
"centreGestionnaire": "0506",
"libelle": "MGEN YVELINES",
"regime": "Mutuelle Générale de l'Education Nationale - MGEN",
"organismeDestinataire": "781",
"codeCentreInformatique": "007",
"adresse1": "Centre de Gestion de La Verrière MGEN",
"adresse2": "6B AV Joseph Rollo CS 10601 LA VERRIERE",
"commune": "LE MESNIL-SAINT-DENIS CEDEX",
"codePostal": "78321",
"cedex": "",
"telephone": "0820 212 312",
"fax": ""
},
{
"id": "93-789-0471",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0471",
"libelle": "MGP AGEN",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "TSA 99998",
"commune": "AGEN",
"codePostal": "47909",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0201",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0201",
"libelle": "MGP AJACCIO",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Boulevard Abbé Recco Les Paludes",
"adresse2": "BP 910",
"commune": "AJACCIO",
"codePostal": "20702",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0811",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0811",
"libelle": "MGP ALBI",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "TSA 99998",
"commune": "ALBI",
"codePostal": "81037",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0611",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0611",
"libelle": "MGP ALENCON",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "34, Place du Général Bonet",
"adresse2": "",
"commune": "ALENCON",
"codePostal": "61012",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0801",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0801",
"libelle": "MGP AMIENS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "TSA 99998",
"adresse2": "",
"commune": "AMIENS",
"codePostal": "80049",
"cedex": "CEDEX 1",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0491",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0491",
"libelle": "MGP ANGERS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "32 Rue Louis Gain",
"adresse2": "",
"commune": "ANGERS",
"codePostal": "49037",
"cedex": "CEDEX 01",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0161",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0161",
"libelle": "MGP ANGOULEME",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "TSA 99998",
"commune": "ANGOULEME",
"codePostal": "16919",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0741",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0741",
"libelle": "MGP ANNECY",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Service Informatique de Production",
"adresse2": "2 rue Robert Schuman",
"commune": "ANNECY",
"codePostal": "74984",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0071",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0071",
"libelle": "MGP ANNONAY",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "5, avenue du Vanel",
"adresse2": "B.P. 614",
"commune": "PRIVAS",
"codePostal": "07006",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0591",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0591",
"libelle": "MGP ARMENTIERES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "6, Rue des Nieulles",
"adresse2": "BP 121",
"commune": "ARMENTIERES",
"codePostal": "59428",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0621",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0621",
"libelle": "MGP ARRAS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Boulevard Allende",
"adresse2": "",
"commune": "ARRAS",
"codePostal": "62014",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0321",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0321",
"libelle": "MGP AUCH",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "11, Rue de Châteaudun",
"adresse2": "",
"commune": "AUCH",
"codePostal": "32012",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0151",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0151",
"libelle": "MGP AURILLAC",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD - TELETRANSMISSION",
"adresse2": "15, Rue Pierre Marty - TSA 99998",
"commune": "AURILLAC",
"codePostal": "15002",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0891",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0891",
"libelle": "MGP AUXERRE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "1 et 3, Rue du Moulin",
"adresse2": "",
"commune": "AUXERRE",
"codePostal": "89024",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0841",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0841",
"libelle": "MGP AVIGNON",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "7, Rue François 1er",
"adresse2": "",
"commune": "AVIGNON",
"codePostal": "84043",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0551",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0551",
"libelle": "MGP BAR LE DUC",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM 78",
"adresse2": "",
"commune": "VERSAILLES",
"codePostal": "78085",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0202",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0202",
"libelle": "MGP BASTIA",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "5 avenue Jean Zuccarelli",
"adresse2": "",
"commune": "BASTIA",
"codePostal": "20406",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0641",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0641",
"libelle": "MGP BAYONNE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD - 68 Allées Marines",
"adresse2": "TSA 99998",
"commune": "BAYONNE",
"codePostal": "64119",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0601",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0601",
"libelle": "MGP BEAUVAIS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Rue de Savoie",
"adresse2": "",
"commune": "BEAUVAIS",
"codePostal": "60013",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0901",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0901",
"libelle": "MGP BELFORT",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "12, Rue du Général Strolz",
"adresse2": "",
"commune": "BELFORT",
"codePostal": "90021",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0251",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0251",
"libelle": "MGP BESANCON",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2, Rue Denis Papin",
"adresse2": "",
"commune": "BESANCON",
"codePostal": "25036",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0341",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0341",
"libelle": "MGP BEZIERS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2. Maison de l'Agriculture",
"adresse2": "Place Chaptal",
"commune": "MONTPELLIER",
"codePostal": "34262",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0411",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0411",
"libelle": "MGP BLOIS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "6, Rue Louis Armand",
"adresse2": "TSA 99998",
"commune": "BLOIS",
"codePostal": "41035",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0331",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0331",
"libelle": "MGP BORDEAUX",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Cité du Grand Parc",
"adresse2": "Place de l'Europe",
"commune": "BORDEAUX",
"codePostal": "33085",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0622",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0622",
"libelle": "MGP BOULOGNE SUR MER",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "47, Boulevard Mariette",
"adresse2": "BP 489",
"commune": "BOULOGNE sur MER",
"codePostal": "62321",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0011",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0011",
"libelle": "MGP BOURG EN BRESSE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "Lots télétransmission TSA 99998",
"commune": "BOURG en BRESSE",
"codePostal": "01015",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0181",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0181",
"libelle": "MGP BOURGES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Boulevard de la République",
"adresse2": "",
"commune": "BOURGES",
"codePostal": "18030",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0291",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0291",
"libelle": "MGP BREST",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Rue de Savoie",
"adresse2": "",
"commune": "BREST",
"codePostal": "29282",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0141",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0141",
"libelle": "MGP CAEN",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD 108 Boulevard Jean Moulin",
"adresse2": "TSA 99 998",
"commune": "CAEN",
"codePostal": "14913",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0461",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0461",
"libelle": "MGP CAHORS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "238 rue Hautesserre",
"adresse2": "",
"commune": "CAHORS",
"codePostal": "46015",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0623",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0623",
"libelle": "MGP CALAIS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD 35 rue Descartes",
"adresse2": "TSA 99998",
"commune": "CALAIS",
"codePostal": "62109",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0592",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0592",
"libelle": "MGP CAMBRAI",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "10, Rue Saint Lazare",
"adresse2": "",
"commune": "CAMBRAI",
"codePostal": "59408",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0111",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0111",
"libelle": "MGP CARCASSONNE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2, Allée de Bezons",
"adresse2": "",
"commune": "CARCASSONNE",
"codePostal": "11017",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0973",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0973",
"libelle": "MGP CAYENNE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Espace Turenne Radamonthe",
"adresse2": "Route de Raban",
"commune": "CAYENNE",
"codePostal": "97307",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0731",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0731",
"libelle": "MGP CHAMBERY",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "5, Avenue Jean Jaurès",
"adresse2": "",
"commune": "CHAMBERY",
"codePostal": "73015",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0081",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0081",
"libelle": "MGP CHARLEVILLE MEZIERES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "14, Avenue G. Corneau",
"adresse2": "",
"commune": "CHARLEVILLE MEZIERES",
"codePostal": "08101",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0281",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0281",
"libelle": "MGP CHARTRES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "11, Rue du Docteur André Haye",
"adresse2": "",
"commune": "CHARTRES",
"codePostal": "28034",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0361",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0361",
"libelle": "MGP CHATEAUROUX",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "14 rue Claude Nicolas Ledoux",
"adresse2": "",
"commune": "CHATEAUROUX",
"codePostal": "36026",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0521",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0521",
"libelle": "MGP CHAUMONT",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "18, Bld Maréchal de Lattre de Tassigny",
"adresse2": "BP 2028",
"commune": "CHAUMONT",
"codePostal": "52915",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0492",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0492",
"libelle": "MGP CHOLET",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "32 Rue Louis Gain",
"adresse2": "",
"commune": "ANGERS",
"codePostal": "49037",
"cedex": "CEDEX 01",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0631",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0631",
"libelle": "MGP CLERMONT FERRAND",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2 rue Serge Gainsbourg",
"adresse2": "",
"commune": "CLERMONT-FERRAND",
"codePostal": "63000",
"cedex": "",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0681",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0681",
"libelle": "MGP COLMAR",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "19, Boulevard du Champ de Mars",
"adresse2": "BP 40454",
"commune": "COLMAR",
"codePostal": "68022",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0602",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0602",
"libelle": "MGP CREIL",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Rue Ribot",
"adresse2": "BP 201",
"commune": "CREIL",
"codePostal": "60313",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0761",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0761",
"libelle": "MGP DIEPPE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Boulevard Georges Clémenceau",
"adresse2": "",
"commune": "DIEPPE",
"codePostal": "76882",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0041",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0041",
"libelle": "MGP DIGNE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "TSA 99998",
"commune": "DIGNE les BAINS",
"codePostal": "04029",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0211",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0211",
"libelle": "MGP DIJON",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "BP 34548",
"adresse2": "",
"commune": "DIJON",
"codePostal": "21045",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0593",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0593",
"libelle": "MGP DOUAI",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "125, Rue Saint Sulpice",
"adresse2": "BP 821",
"commune": "DOUAI",
"codePostal": "59508",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0594",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0594",
"libelle": "MGP DUNKERQUE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2 Rue de la Batellerie",
"adresse2": "BP 4523",
"commune": "DUNKERQUE",
"codePostal": "59386",
"cedex": "CEDEX 1",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0762",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0762",
"libelle": "MGP ELBEUF",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Rue de la Prairie",
"adresse2": "BP400",
"commune": "ELBEUF SUR SEINE",
"codePostal": "76504",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0881",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0881",
"libelle": "MGP EPINAL",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD - Services lots Télétransmissions",
"adresse2": "14, rue de la Clé d'Or - TSA 99998",
"commune": "EPINAL",
"codePostal": "88060",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0271",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0271",
"libelle": "MGP EVREUX",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "1bis, Place Saint Taurin",
"adresse2": "",
"commune": "EVREUX",
"codePostal": "27030",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0091",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0091",
"libelle": "MGP FOIX",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "1, Avenue de Sibian",
"adresse2": "",
"commune": "FOIX",
"codePostal": "09015",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0972",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0972",
"libelle": "MGP FORT DE FRANCE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Place d'Armes",
"adresse2": "",
"commune": "LE LAMENTIN",
"codePostal": "97210",
"cedex": "CEDEX 2",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0051",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0051",
"libelle": "MGP GAP",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "10, Bd G. Pompidou - TSA 99998",
"commune": "GAP",
"codePostal": "05005",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0381",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0381",
"libelle": "MGP GRENOBLE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2, Rue des Alliés",
"adresse2": "",
"commune": "GRENOBLE",
"codePostal": "38045",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0231",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0231",
"libelle": "MGP GUERET",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Rue Marcel Brunet",
"adresse2": "",
"commune": "GUERET",
"codePostal": "23014",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0671",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0671",
"libelle": "MGP HAGUENAU",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "17, Rue du Maréchal Joffre",
"adresse2": "",
"commune": "HAGUENAU",
"codePostal": "67505",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0851",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0851",
"libelle": "MGP LA ROCHE SUR YON",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Rue Alain",
"adresse2": "",
"commune": "LA ROCHE sur YON",
"codePostal": "85031",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0171",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0171",
"libelle": "MGP LA ROCHELLE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "55-57, Rue de Suède",
"adresse2": "",
"commune": "LA ROCHELLE",
"codePostal": "17014",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0021",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0021",
"libelle": "MGP LAON",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "29 Bd Roosevelt CS 20606",
"commune": "SAINT QUENTIN",
"codePostal": "02323",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0531",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0531",
"libelle": "MGP LAVAL",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "37, boulevard Montmorency",
"adresse2": "",
"commune": "LAVAL",
"codePostal": "53084",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0763",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0763",
"libelle": "MGP LE HAVRE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "222, Boulevard de Strasbourg",
"adresse2": "",
"commune": "LE HAVRE",
"codePostal": "76094",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0721",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0721",
"libelle": "MGP LE MANS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "178, Avenue Bollée",
"adresse2": "",
"commune": "LE MANS",
"codePostal": "72033",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0431",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0431",
"libelle": "MGP LE PUY",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "10, Avenue André Soulier",
"adresse2": "BP 324",
"commune": "LE PUY EN VELAY",
"codePostal": "43011",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0624",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0624",
"libelle": "MGP LENS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "11 boulevard du Président Allendé",
"adresse2": "CS 90014",
"commune": "ARRAS",
"codePostal": "62014",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0595",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0595",
"libelle": "MGP LILLE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "125 rue Saint Sulpice",
"adresse2": "CS 20821",
"commune": "DOUAI",
"codePostal": "59508",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0871",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0871",
"libelle": "MGP LIMOGES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "22, Avenue Jean Gagnant",
"adresse2": "",
"commune": "LIMOGES",
"codePostal": "87037",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0541",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0541",
"libelle": "MGP LONGWY",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "3, boulevard Joffre",
"adresse2": "",
"commune": "NANCY",
"codePostal": "54047",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0391",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0391",
"libelle": "MGP LONS LE SAUNIER",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998",
"commune": "LONS LE SAUNIER",
"codePostal": "39007",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0691",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0691",
"libelle": "MGP LYON",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM de LYON",
"adresse2": "",
"commune": "LYON",
"codePostal": "69907",
"cedex": "CEDEX 20",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0711",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0711",
"libelle": "MGP MACON",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "113, Rue de Paris",
"adresse2": "",
"commune": "MACON",
"codePostal": "71022",
"cedex": "CEDEX 09",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0131",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0131",
"libelle": "MGP MARSEILLE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "29 rue JB Reboul",
"adresse2": "TSA 99998",
"commune": "MARSEILLE",
"codePostal": "13395",
"cedex": "CEDEX 10",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0596",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0596",
"libelle": "MGP MAUBEUGE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "24 rue de la Croix",
"adresse2": "BP 78",
"commune": "MAUBEUGE",
"codePostal": "59607",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0481",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0481",
"libelle": "MGP MENDE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Quartier des Carmes",
"adresse2": "BP 26",
"commune": "MENDE",
"codePostal": "48006",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0571",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0571",
"libelle": "MGP METZ",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998",
"commune": "METZ",
"codePostal": "57751",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0401",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0401",
"libelle": "MGP MONT DE MARSAN",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM 78",
"adresse2": "",
"commune": "VERSAILLES",
"codePostal": "78085",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0821",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0821",
"libelle": "MGP MONTAUBAN",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "592, boulevard Blaise Doumerc",
"adresse2": "BP 778",
"commune": "MONTAUBAN",
"codePostal": "82015",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0252",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0252",
"libelle": "MGP MONTBELIARD",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "3, Avenue Léon Blum",
"adresse2": "",
"commune": "MONTBELIARD",
"codePostal": "25215",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0342",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0342",
"libelle": "MGP MONTPELLIER",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM DE L'HERAULT HD",
"adresse2": "TSA 99998",
"commune": "MONTPELLIER",
"codePostal": "34949",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0031",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0031",
"libelle": "MGP MOULINS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998",
"commune": "MOULINS",
"codePostal": "03009",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0682",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0682",
"libelle": "MGP MULHOUSE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "19, bd du Champ de Mars",
"adresse2": "BP 40454",
"commune": "COLMAR",
"codePostal": "68022",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0542",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0542",
"libelle": "MGP NANCY",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM 78",
"adresse2": "",
"commune": "VERSAILLES",
"codePostal": "78085",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0441",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0441",
"libelle": "MGP NANTES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998",
"commune": "NANTES",
"codePostal": "44958",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0581",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0581",
"libelle": "MGP NEVERS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998 - Rue Paul Vaillant Couturier",
"commune": "NEVERS",
"codePostal": "58025",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0061",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0061",
"libelle": "MGP NICE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD - Télétransmission PS/ CDS",
"adresse2": "48 AV ROI ROBERT COMTE DE PROVENCE - TSA 99998",
"commune": "NICE",
"codePostal": "06099",
"cedex": "CEDEX 1",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0301",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0301",
"libelle": "MGP NIMES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "14, Rue du Cirque Romain",
"adresse2": "",
"commune": "NIMES",
"codePostal": "30921",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0791",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0791",
"libelle": "MGP NIORT",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Parc d'activités de l'Ebaupin",
"adresse2": "1 rue de l'Angélique",
"commune": "NIORT",
"codePostal": "79041",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0451",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0451",
"libelle": "MGP ORLEANS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "HD",
"adresse2": "Place du Général de Gaulle",
"commune": "ORLEANS",
"codePostal": "45021",
"cedex": "CEDEX 1",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0642",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0642",
"libelle": "MGP PAU",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM 78",
"adresse2": "",
"commune": "VERSAILLES",
"codePostal": "78085",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0643",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0643",
"libelle": "MGP PAU MNH",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "26 bis Avenue des Lilas",
"adresse2": "",
"commune": "PAU",
"codePostal": "64022",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0241",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0241",
"libelle": "MGP PERIGUEUX",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "50, Rue Claude Bernard - TSA99998",
"commune": "PERIGUEUX",
"codePostal": "24020",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0661",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0661",
"libelle": "MGP PERPIGNAN",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "rue des remparts saint mathieu",
"adresse2": "BP 89928",
"commune": "PERPIGNAN",
"codePostal": "66013",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0971",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0971",
"libelle": "MGP POINTE A PITRE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Quartier de l'Hôtel de Ville",
"adresse2": "BP 486",
"commune": "POINTE A PITRE",
"codePostal": "97159",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0861",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0861",
"libelle": "MGP POITIERS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "41, Rue du Touffenet",
"adresse2": "",
"commune": "POITIERS",
"codePostal": "86043",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0072",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0072",
"libelle": "MGP PRIVAS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "6, Avenue de l'Europe Unie",
"adresse2": "",
"commune": "PRIVAS",
"codePostal": "07007",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0292",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0292",
"libelle": "MGP QUIMPER",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Rue de Savoie",
"adresse2": "",
"commune": "BREST",
"codePostal": "29282",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0511",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0511",
"libelle": "MGP REIMS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "14-16, Rue du Ruisselet",
"adresse2": "",
"commune": "REIMS",
"codePostal": "51086",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0351",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0351",
"libelle": "MGP RENNES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Cours des Alliés",
"adresse2": "BP 34 A",
"commune": "RENNES",
"codePostal": "35024",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0421",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0421",
"libelle": "MGP ROANNE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "43. avenue Albert-Raimond",
"adresse2": "B.P. 51",
"commune": "ST-PRIEST-EN-JAREZ",
"codePostal": "42275",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0121",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0121",
"libelle": "MGP RODEZ",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Avenue de Bamberg",
"adresse2": "",
"commune": "RODEZ",
"codePostal": "12020",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0597",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0597",
"libelle": "MGP ROUBAIX",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "6, Rue Rémi Cogghe",
"adresse2": "BP 769",
"commune": "ROUBAIX",
"codePostal": "59065",
"cedex": "CEDEX 1",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0764",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0764",
"libelle": "MGP ROUEN",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "50, Avenue de Bretagne",
"adresse2": "",
"commune": "ROUEN",
"codePostal": "76039",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0221",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0221",
"libelle": "MGP SAINT BRIEUC",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "106, Boulevard Hoche",
"adresse2": "",
"commune": "SAINT-BRIEUC",
"codePostal": "22024",
"cedex": "CEDEX 1",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0974",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0974",
"libelle": "MGP SAINT DENIS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "4 Boulevard Doret",
"adresse2": "",
"commune": "SAINT DENIS",
"codePostal": "97704",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0422",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0422",
"libelle": "MGP SAINT ETIENNE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "3 Parvis Pierre Laroque",
"adresse2": "",
"commune": "SAINT ETIENNE",
"codePostal": "42000",
"cedex": "CEDEX 1",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0501",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0501",
"libelle": "MGP SAINT LO",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Montée du Bois André",
"adresse2": "",
"commune": "SAINT LO",
"codePostal": "50012",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0442",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0442",
"libelle": "MGP SAINT NAZAIRE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "TSA 99 998",
"commune": "NANTES",
"codePostal": "44958",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0022",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0022",
"libelle": "MGP SAINT QUENTIN",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "29, Boulevard Roosevelt",
"adresse2": "BP 606",
"commune": "SAINT QUENTIN",
"codePostal": "02323",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0572",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0572",
"libelle": "MGP SARREGUEMINES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2, Rue de l'Ecole",
"adresse2": "BP 31169",
"commune": "SARREGUEMINES",
"codePostal": "57217",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0672",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0672",
"libelle": "MGP SELESTAT",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2, Avenue Schweisguth",
"adresse2": "",
"commune": "SELESTAT",
"codePostal": "67605",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0673",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0673",
"libelle": "MGP STRASBOURG",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "16, Rue de Lausanne",
"adresse2": "BP 408 R 2",
"commune": "STRASBOURG",
"codePostal": "67090",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0651",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0651",
"libelle": "MGP TARBES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD 8, Place au Bois",
"adresse2": "TSA 99998",
"commune": "TARBES",
"codePostal": "65919",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0573",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0573",
"libelle": "MGP THIONVILLE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2, Allée Bel Air",
"adresse2": "BP 50351",
"commune": "THIONVILLE",
"codePostal": "57128",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0831",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0831",
"libelle": "MGP TOULON",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "42 Rue Emile Ollivier",
"adresse2": "HD TSA 99 998",
"commune": "TOULON",
"codePostal": "83082",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0311",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0311",
"libelle": "MGP TOULOUSE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "TSA 99998",
"adresse2": "Télétransmission PS",
"commune": "TOULOUSE",
"codePostal": "31107",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0598",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0598",
"libelle": "MGP TOURCOING",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2 Place Sébastopol",
"adresse2": "BP 700",
"commune": "TOURCOING",
"codePostal": "59208",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0371",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0371",
"libelle": "MGP TOURS",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Cité Administrative du Champ Girault",
"adresse2": "36 Rue Edouard Vaillant",
"commune": "TOURS",
"codePostal": "37035",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0101",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0101",
"libelle": "MGP TROYES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD",
"adresse2": "113 rue Etienne Pédron - TSA 99998",
"commune": "TROYES",
"codePostal": "10001",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0191",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0191",
"libelle": "MGP TULLE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "6 Rue Souham",
"adresse2": "",
"commune": "TULLE",
"codePostal": "19033",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0751",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0751",
"libelle": "MGP UNG",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "21 rue Georges Auric",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75948",
"cedex": "CEDEX 19",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0771",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0771",
"libelle": "MGP UNG",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "",
"adresse2": "",
"commune": "MARNE LA VALLEE",
"codePostal": "77605",
"cedex": "CEDEX 03",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0781",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0781",
"libelle": "MGP UNG",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD-TELETRANSMISSIONS",
"adresse2": "TSA 99 998",
"commune": "VERSAILLES",
"codePostal": "78085",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0911",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0911",
"libelle": "MGP UNG",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD - PJ TELETRANSMISSION",
"adresse2": "5 RUE DU FACTEUR CHEVAL - TSA 99998",
"commune": "EVRY",
"codePostal": "91008",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0921",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0921",
"libelle": "MGP UNG",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "113, Rue des Trois Fontanot",
"adresse2": "",
"commune": "NANTERRE",
"codePostal": "92026",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0931",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0931",
"libelle": "MGP UNG",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM HD - Télétransmission",
"adresse2": "195 Avenue Paul Vaillant Couturier - TSA 99998",
"commune": "BOBIGNY",
"codePostal": "93016",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0941",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0941",
"libelle": "MGP UNG",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "1 à 9, Avenue du Général de Gaulle 94031 CRETEIL CEDEX",
"adresse2": "",
"commune": "CRETEIL",
"codePostal": "94031",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0951",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0951",
"libelle": "MGP UNG",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Immeuble Les Marjoberts",
"adresse2": "2, Rue des Chauffours",
"commune": "CERGY-PONTOISE",
"codePostal": "95017",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0261",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0261",
"libelle": "MGP VALENCE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "Avenue du Président Herriot",
"adresse2": "BP 1000",
"commune": "VALENCE",
"codePostal": "26024",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0599",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0599",
"libelle": "MGP VALENCIENNES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "63, rue du Rempart",
"adresse2": "BP 499",
"commune": "VALENCIENNES",
"codePostal": "59321",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0561",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0561",
"libelle": "MGP VANNES",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "",
"adresse2": "BP 20321",
"commune": "VANNES",
"codePostal": "56021",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0701",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0701",
"libelle": "MGP VESOUL",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "9, Boulevard des Alliés",
"adresse2": "BP 439",
"commune": "VESOUL",
"codePostal": "70020",
"cedex": "CEDEX",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0382",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0382",
"libelle": "MGP VIENNE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "2, Rue des Alliés",
"adresse2": "",
"commune": "GRENOBLE",
"codePostal": "38045",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "93-789-0692",
"codeRegime": "93",
"caisseGestionnaire": "789",
"centreGestionnaire": "0692",
"libelle": "MGP VILLEFRANCHE SUR SAONE",
"regime": "Mutuelle Générale de la Police - MGP",
"organismeDestinataire": "789",
"codeCentreInformatique": "064",
"adresse1": "CPAM 78",
"adresse2": "",
"commune": "VERSAILLES",
"codePostal": "78085",
"cedex": "CEDEX 9",
"telephone": "",
"fax": ""
},
{
"id": "02-401-0000",
"codeRegime": "02",
"caisseGestionnaire": "401",
"centreGestionnaire": "0000",
"libelle": "MONT DE MARSAN",
"regime": "Régime Agricole",
"organismeDestinataire": "401",
"codeCentreInformatique": "641",
"adresse1": "70, rue Alphonse Daudet",
"adresse2": "",
"commune": "ST. PIERRE DU MONT",
"codePostal": "40286",
"cedex": "CEDEX",
"telephone": "05 58 06 55 55",
"fax": "05 58 75 19 76"
},
{
"id": "02-405-0000",
"codeRegime": "02",
"caisseGestionnaire": "405",
"centreGestionnaire": "0000",
"libelle": "MONT DE MARSAN",
"regime": "Régime Agricole",
"organismeDestinataire": "401",
"codeCentreInformatique": "641",
"adresse1": "70, rue Alphonse Daudet",
"adresse2": "",
"commune": "ST. PIERRE DU MONT",
"codePostal": "40286",
"cedex": "CEDEX",
"telephone": "05 58 06 55 55",
"fax": "05 58 75 19 76"
},
{
"id": "02-821-0000",
"codeRegime": "02",
"caisseGestionnaire": "821",
"centreGestionnaire": "0000",
"libelle": "MONTAUBAN",
"regime": "Régime Agricole",
"organismeDestinataire": "821",
"codeCentreInformatique": "821",
"adresse1": "180. avenue Marcel Unal",
"adresse2": "",
"commune": "MONTAUBAN",
"codePostal": "82014",
"cedex": "CEDEX",
"telephone": "05.63.21.61.61",
"fax": "05.63.21.61.79"
},
{
"id": "02-825-0000",
"codeRegime": "02",
"caisseGestionnaire": "825",
"centreGestionnaire": "0000",
"libelle": "MONTAUBAN",
"regime": "Régime Agricole",
"organismeDestinataire": "821",
"codeCentreInformatique": "821",
"adresse1": "180. avenue Marcel Unal",
"adresse2": "",
"commune": "MONTAUBAN",
"codePostal": "82014",
"cedex": "CEDEX",
"telephone": "05.63.21.61.61",
"fax": "05.63.21.61.79"
},
{
"id": "01-252-0000",
"codeRegime": "01",
"caisseGestionnaire": "252",
"centreGestionnaire": "0000",
"libelle": "MONTBELIARD",
"regime": "Régime Général",
"organismeDestinataire": "252",
"codeCentreInformatique": "010",
"adresse1": "3, Avenue Léon Blum",
"adresse2": "",
"commune": "MONTBELIARD",
"codePostal": "25215",
"cedex": "CEDEX",
"telephone": "03 81 99 12 02",
"fax": "03 81 99 13 19"
},
{
"id": "02-341-0000",
"codeRegime": "02",
"caisseGestionnaire": "341",
"centreGestionnaire": "0000",
"libelle": "MONTPELLIER",
"regime": "Régime Agricole",
"organismeDestinataire": "341",
"codeCentreInformatique": "341",
"adresse1": "2. Maison de l'Agriculture",
"adresse2": "Place Chaptal",
"commune": "MONTPELLIER",
"codePostal": "34262",
"cedex": "CEDEX",
"telephone": "04.67.34.80.00",
"fax": "04.67.34.79.79"
},
{
"id": "02-345-0000",
"codeRegime": "02",
"caisseGestionnaire": "345",
"centreGestionnaire": "0000",
"libelle": "MONTPELLIER",
"regime": "Régime Agricole",
"organismeDestinataire": "341",
"codeCentreInformatique": "341",
"adresse1": "2. Maison de l'Agriculture",
"adresse2": "Place Chaptal",
"commune": "MONTPELLIER",
"codePostal": "34262",
"cedex": "CEDEX",
"telephone": "04.67.34.80.00",
"fax": "04.67.34.79.79"
},
{
"id": "02-031-0000",
"codeRegime": "02",
"caisseGestionnaire": "031",
"centreGestionnaire": "0000",
"libelle": "MOULINS",
"regime": "Régime Agricole",
"organismeDestinataire": "031",
"codeCentreInformatique": "031",
"adresse1": "16, rue Jean Claret",
"adresse2": "",
"commune": "CLERMONT-FERRAND",
"codePostal": "63972",
"cedex": "CEDEX 9",
"telephone": "04.71.64.66.46",
"fax": "04.70.35.35.34"
},
{
"id": "02-035-0000",
"codeRegime": "02",
"caisseGestionnaire": "035",
"centreGestionnaire": "0000",
"libelle": "MOULINS",
"regime": "Régime Agricole",
"organismeDestinataire": "031",
"codeCentreInformatique": "031",
"adresse1": "16, rue Jean Claret",
"adresse2": "",
"commune": "CLERMONT-FERRAND",
"codePostal": "63972",
"cedex": "CEDEX 9",
"telephone": "04.71.64.66.46",
"fax": "04.70.35.35.34"
},
{
"id": "02-941-0000",
"codeRegime": "02",
"caisseGestionnaire": "941",
"centreGestionnaire": "0000",
"libelle": "MSA D ARMORIQUE - MAYOTTE",
"regime": "Régime Agricole",
"organismeDestinataire": "941",
"codeCentreInformatique": "821",
"adresse1": "CENTRE KINGA",
"adresse2": "90, route nationale 1 KAWENI - BP 84",
"commune": "MAMOUDZOU",
"codePostal": "97600",
"cedex": "",
"telephone": "0269 61 91 91",
"fax": ""
},
{
"id": "99-751-0533",
"codeRegime": "99",
"caisseGestionnaire": "751",
"centreGestionnaire": "0533",
"libelle": "Mutuelle des Affaires Etrangeres et Europeennes",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "534",
"codeCentreInformatique": "026",
"adresse1": "1 RUE DE L'ABBE ROGER DERRY",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75730",
"cedex": "CEDEX 15",
"telephone": "01 43 17 54 00",
"fax": ""
},
{
"id": "99-609-0021",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0021",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0061",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0061",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0131",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0131",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0171",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0171",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0241",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0241",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE - CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 91 00 43",
"fax": ""
},
{
"id": "99-609-0301",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0301",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0311",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0311",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0331",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0331",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0342",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0342",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0351",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0351",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0441",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0441",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0542",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0542",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0571",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0571",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0594",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0594",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0595",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0595",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0597",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0597",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0599",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0599",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0602",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0602",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0623",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0623",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0624",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0624",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0641",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0641",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0642",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0642",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0691",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0691",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0751",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0751",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0763",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0763",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0764",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0764",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0771",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0771",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0781",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0781",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0801",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0801",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0831",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0831",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0911",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0911",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0921",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0921",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0931",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0931",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0941",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0941",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "99-609-0951",
"codeRegime": "99",
"caisseGestionnaire": "609",
"centreGestionnaire": "0951",
"libelle": "Mutuelle INTERIALE",
"regime": "Sections Locales Mutualistes - SLM",
"organismeDestinataire": "609",
"codeCentreInformatique": "072",
"adresse1": "INTERIALE -CS 50005",
"adresse2": "",
"commune": "LILLE",
"codePostal": "59040",
"cedex": "CEDEX",
"telephone": "0811 910 043",
"fax": ""
},
{
"id": "02-441-0000",
"codeRegime": "02",
"caisseGestionnaire": "441",
"centreGestionnaire": "0000",
"libelle": "NANTES",
"regime": "Régime Agricole",
"organismeDestinataire": "441",
"codeCentreInformatique": "441",
"adresse1": "2 impasse de l'Espéranto",
"adresse2": "SAINT-HERBLAIN",
"commune": "NANTES",
"codePostal": "44957",
"cedex": "CEDEX 9",
"telephone": "02.40.41.39.39",
"fax": "02.40.41.39.19"
},
{
"id": "02-445-0000",
"codeRegime": "02",
"caisseGestionnaire": "445",
"centreGestionnaire": "0000",
"libelle": "NANTES",
"regime": "Régime Agricole",
"organismeDestinataire": "441",
"codeCentreInformatique": "441",
"adresse1": "2 impasse de l'Espéranto",
"adresse2": "SAINT-HERBLAIN",
"commune": "NANTES",
"codePostal": "44957",
"cedex": "CEDEX 9",
"telephone": "02.40.41.39.39",
"fax": "02 40  41 39 19"
},
{
"id": "02-581-0000",
"codeRegime": "02",
"caisseGestionnaire": "581",
"centreGestionnaire": "0000",
"libelle": "NEVERS",
"regime": "Régime Agricole",
"organismeDestinataire": "581",
"codeCentreInformatique": "541",
"adresse1": "Maison de l'Agriculture",
"adresse2": "B.P. 805",
"commune": "NEVERS",
"codePostal": "58017",
"cedex": "CEDEX",
"telephone": "03.86.93.50.00",
"fax": "03.86.93.50.09"
},
{
"id": "02-585-0000",
"codeRegime": "02",
"caisseGestionnaire": "585",
"centreGestionnaire": "0000",
"libelle": "NEVERS",
"regime": "Régime Agricole",
"organismeDestinataire": "581",
"codeCentreInformatique": "541",
"adresse1": "Maison de l'Agriculture",
"adresse2": "B.P. 805",
"commune": "NEVERS",
"codePostal": "58017",
"cedex": "CEDEX",
"telephone": "03.86.93.50.00",
"fax": "03.86.93.50.09"
},
{
"id": "02-061-0000",
"codeRegime": "02",
"caisseGestionnaire": "061",
"centreGestionnaire": "0000",
"libelle": "NICE",
"regime": "Régime Agricole",
"organismeDestinataire": "061",
"codeCentreInformatique": "381",
"adresse1": "32. avenue de la Lanterne",
"adresse2": "",
"commune": "NICE",
"codePostal": "06044",
"cedex": "CEDEX",
"telephone": "04.93.72.68.00",
"fax": "04.93.72.69.00"
},
{
"id": "02-065-0000",
"codeRegime": "02",
"caisseGestionnaire": "065",
"centreGestionnaire": "0000",
"libelle": "NICE",
"regime": "Régime Agricole",
"organismeDestinataire": "061",
"codeCentreInformatique": "381",
"adresse1": "32. avenue de la Lanterne",
"adresse2": "",
"commune": "NICE",
"codePostal": "06044",
"cedex": "CEDEX",
"telephone": "04.93.72.68.00",
"fax": "04.93.72.69.00"
},
{
"id": "02-301-0000",
"codeRegime": "02",
"caisseGestionnaire": "301",
"centreGestionnaire": "0000",
"libelle": "NIMES",
"regime": "Régime Agricole",
"organismeDestinataire": "301",
"codeCentreInformatique": "301",
"adresse1": "Rue Edouard-Lalo",
"adresse2": "",
"commune": "NIMES",
"codePostal": "30924",
"cedex": "CEDEX 9",
"telephone": "04.66.63.68.68",
"fax": "04.66.63.68.90"
},
{
"id": "02-305-0000",
"codeRegime": "02",
"caisseGestionnaire": "305",
"centreGestionnaire": "0000",
"libelle": "NIMES",
"regime": "Régime Agricole",
"organismeDestinataire": "301",
"codeCentreInformatique": "301",
"adresse1": "Rue Edouard-Lalo",
"adresse2": "",
"commune": "NIMES",
"codePostal": "30924",
"cedex": "CEDEX 9",
"telephone": "04.66.63.68.68",
"fax": "04.66.63.68.90"
},
{
"id": "02-791-0000",
"codeRegime": "02",
"caisseGestionnaire": "791",
"centreGestionnaire": "0000",
"libelle": "NIORT",
"regime": "Régime Agricole",
"organismeDestinataire": "791",
"codeCentreInformatique": "791",
"adresse1": "37. rue de Touffenet",
"adresse2": "",
"commune": "POITIERS",
"codePostal": "86042",
"cedex": "CEDEX",
"telephone": "05.49.44.56.40",
"fax": "05.49.01.80.40"
},
{
"id": "02-795-0000",
"codeRegime": "02",
"caisseGestionnaire": "795",
"centreGestionnaire": "0000",
"libelle": "NIORT",
"regime": "Régime Agricole",
"organismeDestinataire": "791",
"codeCentreInformatique": "791",
"adresse1": "37 rue du Touffenet",
"adresse2": "",
"commune": "POITIERS",
"codePostal": "86042",
"cedex": "CEDEX",
"telephone": "05.49.44.56.40",
"fax": "05.49.01.80.40"
},
{
"id": "02-451-0000",
"codeRegime": "02",
"caisseGestionnaire": "451",
"centreGestionnaire": "0000",
"libelle": "ORLEANS",
"regime": "Régime Agricole",
"organismeDestinataire": "451",
"codeCentreInformatique": "411",
"adresse1": "11. avenue des Droits de l'Homme",
"adresse2": "B.P. 9200",
"commune": "ORLEANS",
"codePostal": "45924",
"cedex": "CEDEX 9",
"telephone": "02.38.60.55.55",
"fax": "02.38.60.56.80"
},
{
"id": "02-455-0000",
"codeRegime": "02",
"caisseGestionnaire": "455",
"centreGestionnaire": "0000",
"libelle": "ORLEANS",
"regime": "Régime Agricole",
"organismeDestinataire": "451",
"codeCentreInformatique": "411",
"adresse1": "11. avenue des Droits de l'Homme",
"adresse2": "B.P. 9200",
"commune": "ORLEANS",
"codePostal": "45924",
"cedex": "CEDEX 9",
"telephone": "02.38.60.55.55",
"fax": "02.38.60.56.80"
},
{
"id": "02-751-0000",
"codeRegime": "02",
"caisseGestionnaire": "751",
"centreGestionnaire": "0000",
"libelle": "PARIS",
"regime": "Régime Agricole",
"organismeDestinataire": "751",
"codeCentreInformatique": "591",
"adresse1": "161, av. Paul Vaillant Couturier",
"adresse2": "",
"commune": "GENTILLY",
"codePostal": "94250",
"cedex": "BP126",
"telephone": "01 49 85 59 31",
"fax": "01 49 85 55 05"
},
{
"id": "02-755-0000",
"codeRegime": "02",
"caisseGestionnaire": "755",
"centreGestionnaire": "0000",
"libelle": "PARIS",
"regime": "Régime Agricole",
"organismeDestinataire": "751",
"codeCentreInformatique": "591",
"adresse1": "161, av. Paul Vaillant Couturier",
"adresse2": "",
"commune": "GENTILLY",
"codePostal": "94250",
"cedex": "BP126",
"telephone": "01 49 85 59 31",
"fax": "01 49 85 55 05"
},
{
"id": "02-641-0000",
"codeRegime": "02",
"caisseGestionnaire": "641",
"centreGestionnaire": "0000",
"libelle": "PAU",
"regime": "Régime Agricole",
"organismeDestinataire": "641",
"codeCentreInformatique": "641",
"adresse1": "1. place Marguerite Laborde",
"adresse2": "",
"commune": "PAU",
"codePostal": "64017",
"cedex": "CEDEX",
"telephone": "05.59.80.72.72",
"fax": "05.59.80.72.27"
},
{
"id": "02-645-0000",
"codeRegime": "02",
"caisseGestionnaire": "645",
"centreGestionnaire": "0000",
"libelle": "PAU",
"regime": "Régime Agricole",
"organismeDestinataire": "641",
"codeCentreInformatique": "641",
"adresse1": "1. place Marguerite Laborde",
"adresse2": "",
"commune": "PAU",
"codePostal": "64017",
"cedex": "CEDEX",
"telephone": "05.59.80.72.72",
"fax": "05.59.80.72.27"
},
{
"id": "02-241-0000",
"codeRegime": "02",
"caisseGestionnaire": "241",
"centreGestionnaire": "0000",
"libelle": "PERIGUEUX",
"regime": "Régime Agricole",
"organismeDestinataire": "241",
"codeCentreInformatique": "821",
"adresse1": "CS 30003",
"adresse2": "",
"commune": "PERIGUEUX",
"codePostal": "24012",
"cedex": "CEDEX",
"telephone": "05.53.02.68.29",
"fax": "05.53.09.55.85"
},
{
"id": "02-245-0000",
"codeRegime": "02",
"caisseGestionnaire": "245",
"centreGestionnaire": "0000",
"libelle": "PERIGUEUX",
"regime": "Régime Agricole",
"organismeDestinataire": "241",
"codeCentreInformatique": "821",
"adresse1": "7 place du Général Leclerc",
"adresse2": "",
"commune": "PERIGUEUX",
"codePostal": "24012",
"cedex": "CEDEX",
"telephone": "05.53.02.67.00",
"fax": "05.53.09.55.85"
},
{
"id": "02-661-0000",
"codeRegime": "02",
"caisseGestionnaire": "661",
"centreGestionnaire": "0000",
"libelle": "PERPIGNAN",
"regime": "Régime Agricole",
"organismeDestinataire": "661",
"codeCentreInformatique": "341",
"adresse1": "23 rue francois broussais",
"adresse2": "B.P. 946",
"commune": "PERPIGNAN",
"codePostal": "66017",
"cedex": "CEDEX 9",
"telephone": "04.68.55.11.66",
"fax": "04.68.82.65.83"
},
{
"id": "02-665-0000",
"codeRegime": "02",
"caisseGestionnaire": "665",
"centreGestionnaire": "0000",
"libelle": "PERPIGNAN",
"regime": "Régime Agricole",
"organismeDestinataire": "661",
"codeCentreInformatique": "341",
"adresse1": "23 rue francois broussais",
"adresse2": "B.P. 946",
"commune": "PERPIGNAN",
"codePostal": "66017",
"cedex": "CEDEX 9",
"telephone": "04.68.55.11.66",
"fax": "04.68.82.65.83"
},
{
"id": "02-971-0000",
"codeRegime": "02",
"caisseGestionnaire": "971",
"centreGestionnaire": "0000",
"libelle": "POINTE A PITRE",
"regime": "Régime Agricole",
"organismeDestinataire": "971",
"codeCentreInformatique": "591",
"adresse1": "CGSS MSA",
"adresse2": "CS 18102",
"commune": "LES ABYMES",
"codePostal": "97181",
"cedex": "CEDEX",
"telephone": "05 90 90 50 23",
"fax": ""
},
{
"id": "02-861-0000",
"codeRegime": "02",
"caisseGestionnaire": "861",
"centreGestionnaire": "0000",
"libelle": "POITIERS",
"regime": "Régime Agricole",
"organismeDestinataire": "861",
"codeCentreInformatique": "871",
"adresse1": "37. rue de Touffenet",
"adresse2": "",
"commune": "POITIERS",
"codePostal": "86042",
"cedex": "CEDEX",
"telephone": "05.49.44.56.40",
"fax": "05.49.01.80.40"
},
{
"id": "02-865-0000",
"codeRegime": "02",
"caisseGestionnaire": "865",
"centreGestionnaire": "0000",
"libelle": "POITIERS",
"regime": "Régime Agricole",
"organismeDestinataire": "861",
"codeCentreInformatique": "871",
"adresse1": "37. rue de Touffenet",
"adresse2": "",
"commune": "POITIERS",
"codePostal": "86042",
"cedex": "CEDEX",
"telephone": "05.49.44.56.40",
"fax": "05.49.01.80.40"
},
{
"id": "02-071-0000",
"codeRegime": "02",
"caisseGestionnaire": "071",
"centreGestionnaire": "0000",
"libelle": "PRIVAS",
"regime": "Régime Agricole",
"organismeDestinataire": "071",
"codeCentreInformatique": "381",
"adresse1": "5. avenue du Vanel",
"adresse2": "B.P. 614",
"commune": "PRIVAS",
"codePostal": "07006",
"cedex": "CEDEX",
"telephone": "04.75.66.42.00",
"fax": "04.75.64.08.69"
},
{
"id": "02-075-0000",
"codeRegime": "02",
"caisseGestionnaire": "075",
"centreGestionnaire": "0000",
"libelle": "PRIVAS",
"regime": "Régime Agricole",
"organismeDestinataire": "071",
"codeCentreInformatique": "381",
"adresse1": "5. avenue du Vanel",
"adresse2": "B.P. 614",
"commune": "PRIVAS",
"codePostal": "07006",
"cedex": "CEDEX",
"telephone": "04.75.66.42.00",
"fax": "04.75.64.08.69"
},
{
"id": "04-400-0000",
"codeRegime": "04",
"caisseGestionnaire": "400",
"centreGestionnaire": "0000",
"libelle": "Regime des Subsistants",
"regime": "Caisse de Prévoyance et de Retraite du Personnel Ferroviaire - CPRPF",
"organismeDestinataire": "110",
"codeCentreInformatique": "001",
"adresse1": "17 avenue du général Leclerc",
"adresse2": "",
"commune": "Marseille",
"codePostal": "13347",
"cedex": "cedex 1",
"telephone": "04.95.04.04.04",
"fax": ""
},
{
"id": "07-225-0000",
"codeRegime": "07",
"caisseGestionnaire": "225",
"centreGestionnaire": "0000",
"libelle": "Regime minier de securite sociale",
"regime": "Régime Minier de Sécurité Sociale",
"organismeDestinataire": "225",
"codeCentreInformatique": "022",
"adresse1": "TSA 39014",
"adresse2": "",
"commune": "ARRAS",
"codePostal": "62035",
"cedex": "CEDEX",
"telephone": "08 11 50 00 11",
"fax": ""
},
{
"id": "02-511-0000",
"codeRegime": "02",
"caisseGestionnaire": "511",
"centreGestionnaire": "0000",
"libelle": "REIMS",
"regime": "Régime Agricole",
"organismeDestinataire": "511",
"codeCentreInformatique": "541",
"adresse1": "24. boulevard Louis-Roederer",
"adresse2": "",
"commune": "REIMS",
"codePostal": "51077",
"cedex": "CEDEX",
"telephone": "03.26.40.88.00",
"fax": "03.26.40.87.50"
},
{
"id": "02-515-0000",
"codeRegime": "02",
"caisseGestionnaire": "515",
"centreGestionnaire": "0000",
"libelle": "REIMS",
"regime": "Régime Agricole",
"organismeDestinataire": "511",
"codeCentreInformatique": "541",
"adresse1": "24. boulevard Louis-Roederer",
"adresse2": "",
"commune": "REIMS",
"codePostal": "51077",
"cedex": "CEDEX",
"telephone": "03.26.40.88.00",
"fax": "03.26.40.87.50"
},
{
"id": "02-351-0000",
"codeRegime": "02",
"caisseGestionnaire": "351",
"centreGestionnaire": "0000",
"libelle": "RENNES",
"regime": "Régime Agricole",
"organismeDestinataire": "351",
"codeCentreInformatique": "351",
"adresse1": "TSA 55001",
"adresse2": "",
"commune": "VANNES",
"codePostal": "56960",
"cedex": "CEDEX",
"telephone": "02.99.01.80.80",
"fax": "02.99.31.52.16"
},
{
"id": "02-355-0000",
"codeRegime": "02",
"caisseGestionnaire": "355",
"centreGestionnaire": "0000",
"libelle": "RENNES",
"regime": "Régime Agricole",
"organismeDestinataire": "351",
"codeCentreInformatique": "351",
"adresse1": "TSA 55001",
"adresse2": "",
"commune": "VANNES",
"codePostal": "56960",
"cedex": "CEDEX",
"telephone": "02.99.01.80.80",
"fax": "02.99.31.52.16"
},
{
"id": "02-121-0000",
"codeRegime": "02",
"caisseGestionnaire": "121",
"centreGestionnaire": "0000",
"libelle": "RODEZ",
"regime": "Régime Agricole",
"organismeDestinataire": "121",
"codeCentreInformatique": "821",
"adresse1": "15-17. avenue Victor Hugo",
"adresse2": "",
"commune": "RODEZ",
"codePostal": "12022",
"cedex": "CEDEX",
"telephone": "05.63.48.40.40",
"fax": "05.63.48.40.99"
},
{
"id": "02-125-0000",
"codeRegime": "02",
"caisseGestionnaire": "125",
"centreGestionnaire": "0000",
"libelle": "RODEZ",
"regime": "Régime Agricole",
"organismeDestinataire": "121",
"codeCentreInformatique": "821",
"adresse1": "15-17. avenue Victor Hugo",
"adresse2": "",
"commune": "RODEZ",
"codePostal": "12022",
"cedex": "CEDEX",
"telephone": "05.63.48.40.40",
"fax": "05.63.48.40.99"
},
{
"id": "02-221-0000",
"codeRegime": "02",
"caisseGestionnaire": "221",
"centreGestionnaire": "0000",
"libelle": "SAINT BRIEUC",
"regime": "Régime Agricole",
"organismeDestinataire": "221",
"codeCentreInformatique": "351",
"adresse1": "12. rue de Paimpont",
"adresse2": "B.P. 68",
"commune": "SAINT-BRIEUC",
"codePostal": "22024",
"cedex": "CEDEX",
"telephone": "02.96.78.87.00",
"fax": "02.96.78.87.59"
},
{
"id": "02-225-0000",
"codeRegime": "02",
"caisseGestionnaire": "225",
"centreGestionnaire": "0000",
"libelle": "SAINT BRIEUC",
"regime": "Régime Agricole",
"organismeDestinataire": "221",
"codeCentreInformatique": "351",
"adresse1": "12. rue de Paimpont",
"adresse2": "B.P. 68",
"commune": "SAINT-BRIEUC",
"codePostal": "22024",
"cedex": "CEDEX",
"telephone": "02.96.78.87.00",
"fax": "02.96.78.87.59"
},
{
"id": "02-501-0000",
"codeRegime": "02",
"caisseGestionnaire": "501",
"centreGestionnaire": "0000",
"libelle": "SAINT LO",
"regime": "Régime Agricole",
"organismeDestinataire": "501",
"codeCentreInformatique": "351",
"adresse1": "9. place du Champ-de-Mars",
"adresse2": "B.P. 205",
"commune": "SAINT-LO",
"codePostal": "50005",
"cedex": "CEDEX",
"telephone": "02.31.25.37.10",
"fax": "02.33.06.42.00"
},
{
"id": "02-505-0000",
"codeRegime": "02",
"caisseGestionnaire": "505",
"centreGestionnaire": "0000",
"libelle": "SAINT LO",
"regime": "Régime Agricole",
"organismeDestinataire": "501",
"codeCentreInformatique": "351",
"adresse1": "9. place du Champ-de-Mars",
"adresse2": "B.P. 205",
"commune": "SAINT-LO",
"codePostal": "50005",
"cedex": "CEDEX",
"telephone": "02.31.25.37.10",
"fax": "02.33.06.42.00"
},
{
"id": "02-421-0000",
"codeRegime": "02",
"caisseGestionnaire": "421",
"centreGestionnaire": "0000",
"libelle": "SAINT PRIEST EN JAREZ",
"regime": "Régime Agricole",
"organismeDestinataire": "421",
"codeCentreInformatique": "381",
"adresse1": "43. avenue Albert-Raimond",
"adresse2": "B.P. 51",
"commune": "ST-PRIEST-EN-JAREZ",
"codePostal": "42275",
"cedex": "CEDEX",
"telephone": "04.77.91.54.83",
"fax": "04.77.91.55.58"
},
{
"id": "02-425-0000",
"codeRegime": "02",
"caisseGestionnaire": "425",
"centreGestionnaire": "0000",
"libelle": "SAINT PRIEST EN JAREZ",
"regime": "Régime Agricole",
"organismeDestinataire": "421",
"codeCentreInformatique": "381",
"adresse1": "43. avenue Albert-Raimond",
"adresse2": "B.P. 51",
"commune": "ST-PRIEST-EN-JAREZ",
"codePostal": "42275",
"cedex": "CEDEX",
"telephone": "04.77.91.54.72",
"fax": "04.77.91.55.25"
},
{
"id": "01-022-0000",
"codeRegime": "01",
"caisseGestionnaire": "022",
"centreGestionnaire": "0000",
"libelle": "SAINT QUENTIN",
"regime": "Régime Général",
"organismeDestinataire": "022",
"codeCentreInformatique": "011",
"adresse1": "29, Boulevard Roosevelt",
"adresse2": "BP 606",
"commune": "SAINT QUENTIN",
"codePostal": "02323",
"cedex": "CEDEX",
"telephone": "03 23 08 41 41",
"fax": ""
},
{
"id": "02-171-0000",
"codeRegime": "02",
"caisseGestionnaire": "171",
"centreGestionnaire": "0000",
"libelle": "SAINTES",
"regime": "Régime Agricole",
"organismeDestinataire": "171",
"codeCentreInformatique": "171",
"adresse1": "1 Bd Vladimir",
"adresse2": "Fief Montlouis",
"commune": "SAINTES",
"codePostal": "17106",
"cedex": "CEDEX",
"telephone": "05.46.97.50.85",
"fax": "05.46.93.84.26"
},
{
"id": "02-175-0000",
"codeRegime": "02",
"caisseGestionnaire": "175",
"centreGestionnaire": "0000",
"libelle": "SAINTES",
"regime": "Régime Agricole",
"organismeDestinataire": "171",
"codeCentreInformatique": "171",
"adresse1": "1 Bd Vladimir",
"adresse2": "Fief Montlouis",
"commune": "SAINTES",
"codePostal": "17106",
"cedex": "CEDEX",
"telephone": "05.46.97.50.87",
"fax": "05.46.93.84.26"
},
{
"id": "01-572-0000",
"codeRegime": "01",
"caisseGestionnaire": "572",
"centreGestionnaire": "0000",
"libelle": "SARREGUEMINES",
"regime": "Régime Général",
"organismeDestinataire": "572",
"codeCentreInformatique": "017",
"adresse1": "2, Rue de l'Ecole",
"adresse2": "BP 31169",
"commune": "SARREGUEMINES",
"codePostal": "57217",
"cedex": "CEDEX",
"telephone": "03 87 95 80 00",
"fax": ""
},
{
"id": "01-672-0000",
"codeRegime": "01",
"caisseGestionnaire": "672",
"centreGestionnaire": "0000",
"libelle": "SELESTAT",
"regime": "Régime Général",
"organismeDestinataire": "672",
"codeCentreInformatique": "017",
"adresse1": "2, Avenue Schweisguth",
"adresse2": "",
"commune": "SELESTAT",
"codePostal": "67605",
"cedex": "CEDEX",
"telephone": "0820904152",
"fax": ""
},
{
"id": "15-751-0000",
"codeRegime": "15",
"caisseGestionnaire": "751",
"centreGestionnaire": "0000",
"libelle": "Senat",
"regime": "Caisses Autonomes de Sécurité Sociale du Sénat",
"organismeDestinataire": "751",
"codeCentreInformatique": "001",
"adresse1": "15, rue Vaugirard",
"adresse2": "",
"commune": "PARIS",
"codePostal": "75291",
"cedex": "CEDEX 06",
"telephone": "01.42.34.20.33",
"fax": "01.42.34.35.29"
},
{
"id": "02-671-0000",
"codeRegime": "02",
"caisseGestionnaire": "671",
"centreGestionnaire": "0000",
"libelle": "STRASBOURG",
"regime": "Régime Agricole",
"organismeDestinataire": "671",
"codeCentreInformatique": "541",
"adresse1": "9 , rue de Guebwiller",
"adresse2": "",
"commune": "COLMAR",
"codePostal": "68023",
"cedex": "CEDEX",
"telephone": "03 89 20 78 68",
"fax": "03 89 20 79 00"
},
{
"id": "02-675-0000",
"codeRegime": "02",
"caisseGestionnaire": "675",
"centreGestionnaire": "0000",
"libelle": "STRASBOURG",
"regime": "Régime Agricole",
"organismeDestinataire": "671",
"codeCentreInformatique": "541",
"adresse1": "9 rue de Guebwiller",
"adresse2": "",
"commune": "Colmar",
"codePostal": "68023",
"cedex": "CEDEX",
"telephone": "03 89 20 78 68",
"fax": "03 89 20 79 00"
},
{
"id": "02-651-0000",
"codeRegime": "02",
"caisseGestionnaire": "651",
"centreGestionnaire": "0000",
"libelle": "TARBES",
"regime": "Régime Agricole",
"organismeDestinataire": "651",
"codeCentreInformatique": "641",
"adresse1": "22. rue de Cronstadt",
"adresse2": "B.P. 119",
"commune": "TARBES",
"codePostal": "65022",
"cedex": "CEDEX",
"telephone": "05.62.34.39.95",
"fax": "05.62.51.07.46"
},
{
"id": "02-655-0000",
"codeRegime": "02",
"caisseGestionnaire": "655",
"centreGestionnaire": "0000",
"libelle": "TARBES",
"regime": "Régime Agricole",
"organismeDestinataire": "651",
"codeCentreInformatique": "641",
"adresse1": "22. rue de Cronstadt",
"adresse2": "B.P. 119",
"commune": "TARBES",
"codePostal": "65022",
"cedex": "CEDEX",
"telephone": "05.62.34.39.95",
"fax": "05.62.51.07.46"
},
{
"id": "01-573-0000",
"codeRegime": "01",
"caisseGestionnaire": "573",
"centreGestionnaire": "0000",
"libelle": "THIONVILLE",
"regime": "Régime Général",
"organismeDestinataire": "573",
"codeCentreInformatique": "017",
"adresse1": "2, Allée Bel Air",
"adresse2": "BP 50351",
"commune": "THIONVILLE",
"codePostal": "57128",
"cedex": "CEDEX",
"telephone": "03 82 55 94 00",
"fax": "03 82 55 94 99"
},
{
"id": "02-311-0000",
"codeRegime": "02",
"caisseGestionnaire": "311",
"centreGestionnaire": "0000",
"libelle": "TOULOUSE",
"regime": "Régime Agricole",
"organismeDestinataire": "311",
"codeCentreInformatique": "821",
"adresse1": "61, allée de Brienne",
"adresse2": "",
"commune": "TOULOUSE",
"codePostal": "31064",
"cedex": "CEDEX",
"telephone": "05.61.10.40.40",
"fax": "05.61.22.46.64"
},
{
"id": "02-315-0000",
"codeRegime": "02",
"caisseGestionnaire": "315",
"centreGestionnaire": "0000",
"libelle": "TOULOUSE",
"regime": "Régime Agricole",
"organismeDestinataire": "311",
"codeCentreInformatique": "821",
"adresse1": "61. allée de Brienne",
"adresse2": "",
"commune": "TOULOUSE",
"codePostal": "31064",
"cedex": "CEDEX",
"telephone": "05.61.10.40.40",
"fax": "05.61.22.46.64"
},
{
"id": "01-598-0000",
"codeRegime": "01",
"caisseGestionnaire": "598",
"centreGestionnaire": "0000",
"libelle": "TOURCOING",
"regime": "Régime Général",
"organismeDestinataire": "598",
"codeCentreInformatique": "011",
"adresse1": "2 Place Sébastopol",
"adresse2": "BP 700",
"commune": "TOURCOING",
"codePostal": "59208",
"cedex": "CEDEX",
"telephone": "03 20 25 72 00",
"fax": "03 20 25 72 69"
},
{
"id": "02-371-0000",
"codeRegime": "02",
"caisseGestionnaire": "371",
"centreGestionnaire": "0000",
"libelle": "TOURS",
"regime": "Régime Agricole",
"organismeDestinataire": "371",
"codeCentreInformatique": "411",
"adresse1": "MSA Berry Touraine 19 Avenue de Vendôme",
"adresse2": "CS 72301",
"commune": "BLOIS",
"codePostal": "41023",
"cedex": "CEDEX",
"telephone": "02 54 44 87 87",
"fax": "02 54 74 82 97"
},
{
"id": "02-375-0000",
"codeRegime": "02",
"caisseGestionnaire": "375",
"centreGestionnaire": "0000",
"libelle": "TOURS",
"regime": "Régime Agricole",
"organismeDestinataire": "371",
"codeCentreInformatique": "411",
"adresse1": "MSA Berry Touraine 19 Avenue de Vendôme",
"adresse2": "CS 72301",
"commune": "BLOIS",
"codePostal": "41023",
"cedex": "CEDEX",
"telephone": "02 54 44 87 87",
"fax": "02 54 74 82 97"
},
{
"id": "02-101-0000",
"codeRegime": "02",
"caisseGestionnaire": "101",
"centreGestionnaire": "0000",
"libelle": "TROYES",
"regime": "Régime Agricole",
"organismeDestinataire": "101",
"codeCentreInformatique": "541",
"adresse1": "1 avenue du Maréchal Joffre",
"adresse2": "",
"commune": "TROYES",
"codePostal": "10032",
"cedex": "CEDEX",
"telephone": "03.25.43.54.00",
"fax": "03.25.43.54.74"
},
{
"id": "02-105-0000",
"codeRegime": "02",
"caisseGestionnaire": "105",
"centreGestionnaire": "0000",
"libelle": "TROYES",
"regime": "Régime Agricole",
"organismeDestinataire": "101",
"codeCentreInformatique": "541",
"adresse1": "1 avenue du Maréchal Joffre",
"adresse2": "",
"commune": "TROYES",
"codePostal": "10032",
"cedex": "CEDEX",
"telephone": "03.25.43.54.00",
"fax": "03.25.43.54.74"
},
{
"id": "02-191-0000",
"codeRegime": "02",
"caisseGestionnaire": "191",
"centreGestionnaire": "0000",
"libelle": "TULLE",
"regime": "Régime Agricole",
"organismeDestinataire": "191",
"codeCentreInformatique": "821",
"adresse1": "Champeau",
"adresse2": "B.P. 20",
"commune": "TULLE",
"codePostal": "19019",
"cedex": "CEDEX",
"telephone": "05.55.93.40.40",
"fax": "05.55.26.26.67"
},
{
"id": "02-195-0000",
"codeRegime": "02",
"caisseGestionnaire": "195",
"centreGestionnaire": "0000",
"libelle": "TULLE",
"regime": "Régime Agricole",
"organismeDestinataire": "191",
"codeCentreInformatique": "821",
"adresse1": "Champeau",
"adresse2": "B.P. 20",
"commune": "TULLE",
"codePostal": "19019",
"cedex": "CEDEX",
"telephone": "05.55.93.40.40",
"fax": "05.55.26.26.67"
},
{
"id": "02-261-0000",
"codeRegime": "02",
"caisseGestionnaire": "261",
"centreGestionnaire": "0000",
"libelle": "VALENCE",
"regime": "Régime Agricole",
"organismeDestinataire": "261",
"codeCentreInformatique": "381",
"adresse1": "29. rue Frédéric Chopin",
"adresse2": "B.P. 1001",
"commune": "VALENCE",
"codePostal": "26025",
"cedex": "CEDEX",
"telephone": "04.75.75.68.68",
"fax": "04.75.42.57.14"
},
{
"id": "02-265-0000",
"codeRegime": "02",
"caisseGestionnaire": "265",
"centreGestionnaire": "0000",
"libelle": "VALENCE",
"regime": "Régime Agricole",
"organismeDestinataire": "261",
"codeCentreInformatique": "381",
"adresse1": "29. rue Frédéric Chopin",
"adresse2": "B.P. 1001",
"commune": "VALENCE",
"codePostal": "26025",
"cedex": "CEDEX",
"telephone": "04.75.75.68.68",
"fax": "04.75.42.57.14"
},
{
"id": "02-541-0000",
"codeRegime": "02",
"caisseGestionnaire": "541",
"centreGestionnaire": "0000",
"libelle": "VANDOEUVRE LES NANCY",
"regime": "Régime Agricole",
"organismeDestinataire": "541",
"codeCentreInformatique": "541",
"adresse1": "15. avenue Paul-Doumer",
"adresse2": "",
"commune": "VANDOEUVRE-LES-NANCY",
"codePostal": "54507",
"cedex": "CEDEX",
"telephone": "03.83.50.35.00",
"fax": "03.83.56.65.86"
},
{
"id": "02-545-0000",
"codeRegime": "02",
"caisseGestionnaire": "545",
"centreGestionnaire": "0000",
"libelle": "VANDOEUVRE LES NANCY",
"regime": "Régime Agricole",
"organismeDestinataire": "541",
"codeCentreInformatique": "541",
"adresse1": "15. avenue Paul-Doumer",
"adresse2": "",
"commune": "VANDOEUVRE-LES-NANCY",
"codePostal": "54507",
"cedex": "CEDEX",
"telephone": "03.83.50.35.00",
"fax": "03.83.56.65.86"
},
{
"id": "02-561-0000",
"codeRegime": "02",
"caisseGestionnaire": "561",
"centreGestionnaire": "0000",
"libelle": "VANNES",
"regime": "Régime Agricole",
"organismeDestinataire": "561",
"codeCentreInformatique": "351",
"adresse1": "TSA 55001",
"adresse2": "",
"commune": "VANNES",
"codePostal": "56960",
"cedex": "CEDEX",
"telephone": "02.97.46.52.52",
"fax": "02.97.40.92.81"
},
{
"id": "02-565-0000",
"codeRegime": "02",
"caisseGestionnaire": "565",
"centreGestionnaire": "0000",
"libelle": "VANNES",
"regime": "Régime Agricole",
"organismeDestinataire": "561",
"codeCentreInformatique": "351",
"adresse1": "TSA 55001",
"adresse2": "",
"commune": "VANNES",
"codePostal": "56960",
"cedex": "CEDEX",
"telephone": "02.97.46.52.52",
"fax": "02.97.40.92.81"
},
{
"id": "02-551-0000",
"codeRegime": "02",
"caisseGestionnaire": "551",
"centreGestionnaire": "0000",
"libelle": "VERDUN",
"regime": "Régime Agricole",
"organismeDestinataire": "551",
"codeCentreInformatique": "541",
"adresse1": "Place Saint Paul",
"adresse2": "",
"commune": "VERDUN",
"codePostal": "55112",
"cedex": "CEDEX",
"telephone": "03 29 83 38 00",
"fax": ""
},
{
"id": "02-555-0000",
"codeRegime": "02",
"caisseGestionnaire": "555",
"centreGestionnaire": "0000",
"libelle": "VERDUN",
"regime": "Régime Agricole",
"organismeDestinataire": "551",
"codeCentreInformatique": "541",
"adresse1": "Place Saint Paul",
"adresse2": "",
"commune": "VERDUN",
"codePostal": "55112",
"cedex": "CEDEX",
"telephone": "03 29 83 38 00",
"fax": ""
},
{
"id": "02-701-0000",
"codeRegime": "02",
"caisseGestionnaire": "701",
"centreGestionnaire": "0000",
"libelle": "VESOUL",
"regime": "Régime Agricole",
"organismeDestinataire": "701",
"codeCentreInformatique": "541",
"adresse1": "13 Avenue Elisée Cusenier",
"adresse2": "",
"commune": "BESANCON",
"codePostal": "25090",
"cedex": "CEDEX 9",
"telephone": "03.81.65.60.60",
"fax": "03.81.65.60.09"
},
{
"id": "02-705-0000",
"codeRegime": "02",
"caisseGestionnaire": "705",
"centreGestionnaire": "0000",
"libelle": "VESOUL",
"regime": "Régime Agricole",
"organismeDestinataire": "701",
"codeCentreInformatique": "541",
"adresse1": "Rue Réné Hologne",
"adresse2": "",
"commune": "VESOUL",
"codePostal": "70021",
"cedex": "CEDEX",
"telephone": "03.84.96.31.00",
"fax": "03.84.96.31.55"
}
];
export default CAISSES_REFERENCE;
